const jobTitles = [
    {
        "id":0,
        "name":"X11030  :  Do not wish to disclose | ไม่ต้องการที่จะเปิดเผย | 不愿透露"
    },
    {
        "id":1,
        "name":"X11010  :  New Entrants To The Workforce | ผู้เข้าสู่แรงงานใหม่ | 新进入职场的人"
    },
    {
        "id":2,
        "name":"11010  :  Soldier | ทหาร | 士兵"
    },
    {
        "id":3,
        "name":"111020  :  Member Of The House Of Representatives | สมาชิกสภาผู้แทนราษฎร | 众议院议员"
    },
    {
        "id":4,
        "name":"111025  :  Senator | สมาชิกวุฒิสภา | 参议员"
    },
    {
        "id":5,
        "name":"111030  :  Minister | รัฐมนตรี | 部长"
    },
    {
        "id":6,
        "name":"111040  :  Local Council Member | สมาชิกสภาท้องถิ่น | 地方议会成员"
    },
    {
        "id":7,
        "name":"111045  :  Local Administrators | ผู้บริหารท้องถิ่น | 本地管理员"
    },
    {
        "id":8,
        "name":"111090  :  Other Lawmakers | ผู้บัญญัติกฎหมายอื่น ๆ | 其他立法者"
    },
    {
        "id":9,
        "name":"112020  :  Executive Level Civil Servants | ข้าราชการระดับบริหาร | 行政级别公务员"
    },
    {
        "id":10,
        "name":"112030  :  State Enterprise Executives | ผู้บริหารรัฐวิสาหกิจ | 国企高管"
    },
    {
        "id":11,
        "name":"112040  :  Public Organization Executives | ผู้บริหารองค์การมหาชน | 公共组织高管"
    },
    {
        "id":12,
        "name":"112090  :  Executives Of Other Government Agencies | ผู้บริหารหน่วยงานของรัฐอื่นๆ | 其他政府机构的行政人员"
    },
    {
        "id":13,
        "name":"113020  :  Traditional Leader | ผู้นำตามประเพณี | 传统领袖"
    },
    {
        "id":14,
        "name":"113030  :  Village Headman | กำนัน | 村长"
    },
    {
        "id":15,
        "name":"113035  :  Sub-Inspector | สารวัตรกำนัน | 副督察"
    },
    {
        "id":16,
        "name":"113040  :  Village Headman | ผู้ใหญ่บ้าน | 村长"
    },
    {
        "id":17,
        "name":"113045  :  Assistant Village Headman | ผู้ช่วยผู้ใหญ่บ้าน | 村长助理"
    },
    {
        "id":18,
        "name":"113050  :  District Doctor | แพทย์ประจำตำบล | 区医生"
    },
    {
        "id":19,
        "name":"113090  :  Other Local\/Community Leaders | ผู้นำท้องถิ่น\/ชุมชนอื่น ๆ | 其他当地\/社区领袖"
    },
    {
        "id":20,
        "name":"114120  :  Party Executive Committee | กรรมการบริหารพรรค | 党的执行委员会"
    },
    {
        "id":21,
        "name":"114130  :  Party Executive | ผู้บริหารพรรค | 党的执行官"
    },
    {
        "id":22,
        "name":"114140  :  Party Leader | หัวหน้าพรรค | 党魁"
    },
    {
        "id":23,
        "name":"114150  :  Party Secretary | เลขาธิการพรรค | 党委书记"
    },
    {
        "id":24,
        "name":"114160  :  Party Treasurer | เหรัญญิกพรรค | 党的财务主管"
    },
    {
        "id":25,
        "name":"114170  :  Party Spokesperson | โฆษกพรรค | 政党发言人"
    },
    {
        "id":26,
        "name":"114190  :  Executive Officers Of Other Political Party Organizations | เจ้าหน้าที่บริหารขององค์กรพรรคการเมืองอื่น ๆ | 其他政党组织的执行官"
    },
    {
        "id":27,
        "name":"114220  :  Executive Officer Of The Employer Organization Employee Organizations And Organizations With Economic Interests | เจ้าหน้าที่บริหารขององค์กรนายจ้าง องค์กรลูกจ้างและองค์กรที่มีผลประโยชน์เชิงเศรษฐกิจ | 雇主组织执行官职工组织和有经济利益的组织"
    },
    {
        "id":28,
        "name":"114320  :  Executive Officer Of An Organization That Serves A Specific Interest. (Secretary Of The Organization; Administrative Officer) | เจ้าหน้าที่บริหารขององค์กรที่ดำเนินการเพื่อผลประโยชน์เฉพาะอย่าง (เลขาธิการองค์กร ; เจ้าหน้าที่บริหารงาน) | 服务于特定利益的组织的执行官。 （组织秘书；行政官员）"
    },
    {
        "id":29,
        "name":"114420  :  Parliamentary Ombudsman | ผู้ตรวจการแผ่นดินของรัฐสภา | 议会监察员"
    },
    {
        "id":30,
        "name":"114430  :  Election Committee | กรรมการเลือกตั้ง | 选举委员会"
    },
    {
        "id":31,
        "name":"114440  :  Human Rights Committee | กรรมการสิทธิมนุษยชน | 人权委员会"
    },
    {
        "id":32,
        "name":"114450  :  Audit Committee | กรรมการตรวจเงินแผ่นดิน | 审计委员会"
    },
    {
        "id":33,
        "name":"114460  :  Member Of The National Anti-Corruption Commission | กรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ | 国家反腐败委员会委员"
    },
    {
        "id":34,
        "name":"115020  :  Executive Officers Of Government Agencies, Government Officials | เจ้าหน้าที่บริหารของหน่วยงานรัฐบาล , เจ้าหน้าที่ของรัฐ | 政府机关执行官、政府官员"
    },
    {
        "id":35,
        "name":"121010  :  Chairman | ประธานกรรมการ | 主席"
    },
    {
        "id":36,
        "name":"121020  :  Chairman | ประธานกรรมการ | 主席"
    },
    {
        "id":37,
        "name":"121030  :  Senior Executives Of Private Agencies | ผู้บริหารระดับสูงของหน่วยงานเอกชน | 私人机构的高级管理人员"
    },
    {
        "id":38,
        "name":"121040  :  Executives Of Private Agencies | ผู้บริหารของหน่วยงานเอกชน | 私人机构的高管"
    },
    {
        "id":39,
        "name":"121050  :  Administrators In Educational Institutions | ผู้บริหารในสถานศึกษา | 教育机构的管理人员"
    },
    {
        "id":40,
        "name":"121060  :  Senior Information Technology Executive | ผู้บริหารด้านเทคโนโลยีสารสนเทศระดับสูง | 高级信息技术主管"
    },
    {
        "id":41,
        "name":"122110  :  Plantation Operations Manager | ผู้จัดการฝ่ายปฏิบัติการด้านการเพาะปลูก | 种植园运营经理"
    },
    {
        "id":42,
        "name":"122120  :  Plantation Manager | ผู้จัดการฝ่ายการเพาะปลูก | 种植园经理"
    },
    {
        "id":43,
        "name":"122130  :  Livestock Farming Manager | ผู้จัดการฝ่ายการเลี้ยงปศุสัตว์ | 畜牧业经理"
    },
    {
        "id":44,
        "name":"122140  :  Forestry Manager | ผู้จัดการฝ่ายการป่าไม้ | 林业经理"
    },
    {
        "id":45,
        "name":"122150  :  Manager Of Aquaculture | ผู้จัดการฝ่ายการเพาะเลี้ยงสัตว์น้ำ | 水产养殖经理"
    },
    {
        "id":46,
        "name":"122220  :  Production Manager\/Production Operations (Various Manufacturing Industries, Mining, Electricity, Gas And Water Supply) | ผู้จัดการฝ่ายผลิต\/ฝ่ายปฏิบัติการด้านการผลิต (อุตสาหกรรมผลิตต่าง ๆ เหมืองแร่ , ไฟฟ้า , ก๊าซและประปา) | 生产经理\/生产运营（各制造业、采矿业、电力、燃气及供水）"
    },
    {
        "id":47,
        "name":"122320  :  Construction Manager | ผู้จัดการฝ่ายการก่อสร้าง | 施工经理"
    },
    {
        "id":48,
        "name":"122420  :  Wholesale Manager | ผู้จัดการฝ่ายค้าส่ง | 批发经理"
    },
    {
        "id":49,
        "name":"122430  :  Retail Manager | ผู้จัดการฝ่ายค้าปลีก | 零售经理"
    },
    {
        "id":50,
        "name":"122520  :  Director \/ Room Manager | ผู้อำนวยการ \/ ผู้จัดการฝ่ายห้องพัก | 总监\/客房经理"
    },
    {
        "id":51,
        "name":"122530  :  Front Office Manager | ผู้จัดการแผนกงานส่วนหน้า | 前厅部经理"
    },
    {
        "id":52,
        "name":"122540  :  Head Of Baggage Handling Department | หัวหน้าแผนกจัดการสัมภาระ | 行李处理部主管"
    },
    {
        "id":53,
        "name":"122550  :  Housekeeping Manager \/ Head Housekeeper | ผู้จัดการงานแม่บ้าน \/ หัวหน้าแม่บ้าน | 客房部经理\/管家总管"
    },
    {
        "id":54,
        "name":"122560  :  Director\/Food And Beverage Manager | ผู้อำนวยการ \/ ผู้จัดการฝ่ายอาหารและเครื่องดื่ม | 总监\/餐饮经理"
    },
    {
        "id":55,
        "name":"122570  :  Restaurant Department Manager Bar And Catering | ผู้จัดการแผนกห้องอาหาร บาร์และจัดเลี้ยง | 餐厅部经理酒吧及餐饮"
    },
    {
        "id":56,
        "name":"122590  :  Other Restaurant And Hotel Managers | ผู้จัดการด้านภัตตาคารและโรงแรมอื่นๆ | 其他餐厅和酒店经理"
    },
    {
        "id":57,
        "name":"122620  :  Transportation Manager (Passengers And Parcels) | ผู้จัดการฝ่ายการขนส่ง (ผู้โดยสารและพัสดุ) | 运输经理（旅客及包裹）"
    },
    {
        "id":58,
        "name":"122630  :  Station Manager Transport Station Master (Land, Air, Water, Rail) | ผู้จัดการสถานี นายสถานีขนส่ง (ทางบก ทางอากาศ ทางน้ำ ทางรถไฟ) | 站长交通站长（陆运、空运、水运、铁路）"
    },
    {
        "id":59,
        "name":"122640  :  Service Manager (Telecommunications, Satellite, Internet, Mobile Phones) | ผู้จัดการฝ่ายบริการ (โทรคมนาคม , ดาวเทียม, อินเตอร์เน็ต , โทรศัพท์เคลื่อนที่) | 服务经理（电信、卫星、互联网、移动电话）"
    },
    {
        "id":60,
        "name":"122650  :  Postal Manager | ผู้จัดการไปรษณีย์ | 邮政经理"
    },
    {
        "id":61,
        "name":"122660  :  Procurement And Warehouse Manager | ผู้จัดการฝ่ายพัสดุและคลังสินค้า | 采购及仓储经理"
    },
    {
        "id":62,
        "name":"122670  :  Port Department Manager, Port Department Head | ผู้จัดการแผนกท่าเรือ , หัวหน้าแผนกท่าเรือ | 港口部经理、港口部部长"
    },
    {
        "id":63,
        "name":"122690  :  Transportation Manager Communications And Other Transportation | ผู้จัดการด้านการขนส่ง การสื่อสารและการคมนาคมอื่น ๆ | 运输经理通讯及其他交通"
    },
    {
        "id":64,
        "name":"122720  :  Business Service Managers (Banks, Financial Institutions, Insurance, Real Estate) | ผู้จัดการด้านบริการธุรกิจ (ธนาคาร สถาบันการเงิน , ประกันภัย , อสังหาริมทรัพย์) | 商业服务经理（银行、金融机构、保险、房地产）"
    },
    {
        "id":65,
        "name":"122730  :  Meeting Manager | ผู้จัดการด้านการจัดประชุม | 会议经理"
    },
    {
        "id":66,
        "name":"122820  :  Personal Services Manager | ผู้จัดการฝ่ายการให้บริการส่วนบุคคล | 个人服务经理"
    },
    {
        "id":67,
        "name":"122830  :  Cleaning Manager | ผู้จัดการฝ่ายการทำความสะอาด | 清洁经理"
    },
    {
        "id":68,
        "name":"122920  :  Educational Administrative Assistant | ผู้ช่วยผู้บริหารด้านการศึกษา | 教育行政助理"
    },
    {
        "id":69,
        "name":"122925  :  Educational Institution Administrators | ผู้บริหารสถานศึกษา | 教育机构管理者"
    },
    {
        "id":70,
        "name":"122930  :  Cultural Manager Leisure And Sports | ผู้จัดการด้านวัฒนธรรม สันทนาการและกีฬา | 文化经理休闲运动"
    },
    {
        "id":71,
        "name":"122940  :  Radio Station Executive | ผู้บริหารสถานีวิทยุกระจายเสียง | 广播电台主管"
    },
    {
        "id":72,
        "name":"122945  :  Radio Broadcast Producer | ผู้ผลิตรายการวิทยุกระจายเสียง | 广播制作人"
    },
    {
        "id":73,
        "name":"122950  :  Television Station Manager | ผู้จัดการสถานีโทรทัศน์ | 电视台经理"
    },
    {
        "id":74,
        "name":"122955  :  Television Producer | ผู้ผลิตรายการโทรทัศน์ | 电视制片人"
    },
    {
        "id":75,
        "name":"122960  :  Film Producer | ผู้อำนวยการสร้างภาพยนตร์ | 电影制片人"
    },
    {
        "id":76,
        "name":"122965  :  Film Production Manager | ผู้จัดการกองถ่ายทำภาพยนตร์ | 电影制作经理"
    },
    {
        "id":77,
        "name":"122970  :  Parliamentary Ombudsman | ผู้ตรวจการแผ่นดินของรัฐสภา | 议会监察员"
    },
    {
        "id":78,
        "name":"122972  :  Election Committee | กรรมการการเลือกตั้ง | 选举委员会"
    },
    {
        "id":79,
        "name":"122974  :  Human Rights Committee | กรรมการสิทธิมนุษยชน | 人权委员会"
    },
    {
        "id":80,
        "name":"122976  :  Audit Committee | กรรมการตรวจเงินแผ่นดิน | 审计委员会"
    },
    {
        "id":81,
        "name":"122978  :  Member Of The National Anti-Corruption Commission | กรรมการป้องกันและปราบปรามการทุจริตแห่งชาติ | 国家反腐败委员会委员"
    },
    {
        "id":82,
        "name":"122990  :  Other Production Managers | ผู้จัดการฝ่ายผลิตอื่น ๆ | 其他生产经理"
    },
    {
        "id":83,
        "name":"123120  :  Finance And Accounting Manager | ผู้จัดการฝ่ายการเงินและการบัญชี | 财务会计经理"
    },
    {
        "id":84,
        "name":"123130  :  General Administration Manager | ผู้จัดการฝ่ายบริหารทั่วไป | 综合行政经理"
    },
    {
        "id":85,
        "name":"123220  :  Human Resources Manager | ผู้จัดการฝ่ายบุคคล | 人力资源经理"
    },
    {
        "id":86,
        "name":"123230  :  Industrial Relations Manager | ผู้จัดการฝ่ายอุตสาหกรรมสัมพันธ์ | 劳资关系经理"
    },
    {
        "id":87,
        "name":"123240  :  Training Manager | ผู้จัดการฝ่ายฝึกอบรม | 培训经理"
    },
    {
        "id":88,
        "name":"123320  :  Sales Manager, Promotion Manager | ผู้จัดการฝ่ายขาย , ผู้จัดการฝ่ายส่งเสริมการขาย | 销售经理、促销经理"
    },
    {
        "id":89,
        "name":"123330  :  Marketing Manager | ผู้จัดการฝ่ายการตลาด | 营销经理"
    },
    {
        "id":90,
        "name":"123420  :  Advertising Manager, Advertising Promotion Manager | ผู้จัดการฝ่ายโฆษณา , ผู้จัดการฝ่ายส่งเสริมงานโฆษณา | 广告经理、广告推广经理"
    },
    {
        "id":91,
        "name":"123430  :  Public Relations Manager | ผู้จัดการฝ่ายประชาสัมพันธ์ | 公共关系经理"
    },
    {
        "id":92,
        "name":"123520  :  Purchasing And Materials Manager, Procurement Manager | ผู้จัดการฝ่ายจัดซื้อและวัสดุ , ผู้จัดการฝ่ายจัดหา | 采购及材料经理、采购经理"
    },
    {
        "id":93,
        "name":"123530  :  Procurement Manager, Warehouse Manager | ผู้จัดการฝ่ายพัสดุ , ผู้จัดการฝ่ายคลังสินค้า | 采购经理、仓库经理"
    },
    {
        "id":94,
        "name":"123620  :  Manager Of Computational Services | ผู้จัดการฝ่ายบริการงานด้านคำนวณ | 计算服务经理"
    },
    {
        "id":95,
        "name":"123720  :  Research And Development Manager | ผู้จัดการฝ่ายวิจัยและพัฒนา | 研发经理"
    },
    {
        "id":96,
        "name":"123820  :  Project Manager (Information Technology) | ผู้จัดการโครงการ (เทคโนโลยีสารสนเทศ) | 专案经理（信息技术）"
    },
    {
        "id":97,
        "name":"123830  :  Computer Systems Manager | ผู้จัดการด้านระบบคอมพิวเตอร์ | 计算机系统经理"
    },
    {
        "id":98,
        "name":"123920  :  Air Traffic Control Manager | ผู้จัดการงานควบคุมจราจรทางอากาศ | 空中交通管制经理"
    },
    {
        "id":99,
        "name":"123990  :  Other Department Managers Not Classified Elsewhere | ผู้จัดการฝ่ายอื่น ๆ ที่มิได้จัดประเภทไว้ในที่อื่น | 其他未分类的部门经理"
    },
    {
        "id":100,
        "name":"131110  :  General Manager In Crop Farm | ผู้จัดการทั่วไปในฟาร์มพืช | 农作物农场总经理"
    },
    {
        "id":101,
        "name":"131112  :  General Manager In Nurseries And Greenhouses | ผู้จัดการทั่วไปในสถานเพาะชำและเรือนกระจก | 苗圃和温室总经理"
    },
    {
        "id":102,
        "name":"131114  :  General Manager At A Livestock Farm | ผู้จัดการทั่วไปในฟาร์มปศุสัตว์ | 某畜牧场总经理"
    },
    {
        "id":103,
        "name":"131120  :  General Manager Of Cultivation | ผู้จัดการทั่วไปด้านการเพาะปลูก | 种植总经理"
    },
    {
        "id":104,
        "name":"131130  :  Livestock Farm General Manager | ผู้จัดการทั่วไปฟาร์มปศุสัตว์ | 畜牧场总经理"
    },
    {
        "id":105,
        "name":"131140  :  General Manager Of Forestry | ผู้จัดการทั่วไปด้านการป่าไม้ | 林业总经理"
    },
    {
        "id":106,
        "name":"131150  :  General Manager At An Aquatic Farm | ผู้จัดการทั่วไปในฟาร์มเพาะเลี้ยงสัตว์น้ำ | 水产养殖场总经理"
    },
    {
        "id":107,
        "name":"131220  :  General Manager Of Production | ผู้จัดการทั่วไปด้านการผลิต | 生产总经理"
    },
    {
        "id":108,
        "name":"131320  :  General Manager Of Construction | ผู้จัดการทั่วไปด้านการก่อสร้าง | 建设部总经理"
    },
    {
        "id":109,
        "name":"131410  :  General Manager Retail | ผู้จัดการทั่วไปด้านค้าปลีก | 零售总经理"
    },
    {
        "id":110,
        "name":"131420  :  General Manager Of Wholesale | ผู้จัดการทั่วไปด้านค้าส่ง | 批发部总经理"
    },
    {
        "id":111,
        "name":"131430  :  Wholesale Business Owner | เจ้าของผู้ดำเนินธุรกิจค้าส่ง | 批发企业主"
    },
    {
        "id":112,
        "name":"131440  :  Retail Business Owner | เจ้าของผู้ดำเนินธุรกิจค้าปลีก | 零售企业主"
    },
    {
        "id":113,
        "name":"131520  :  General Manager Of Restaurant\/Restaurant | ผู้จัดการทั่วไปของภัตตคาร\/ ห้องอาหาร | 餐厅\/餐厅总经理"
    },
    {
        "id":114,
        "name":"131530  :  General Manager Of The Hotel | ผู้จัดการทั่วไปของโรงแรม | 酒店总经理"
    },
    {
        "id":115,
        "name":"131540  :  General Manager (Food And Accommodation Sales Service) | ผู้จัดการทั่วไป (บริการขายอาหารและที่พักอาศัย) | 总经理（餐饮住宿销售服务）"
    },
    {
        "id":116,
        "name":"131620  :  General Manager Of Transportation | ผู้จัดการทั่วไปด้านการขนส่ง | 交通部总经理"
    },
    {
        "id":117,
        "name":"131630  :  General Manager Of Telecommunications | ผู้จัดการทั่วไปด้านการสื่อสารโทรคมนาคม | 电信总经理"
    },
    {
        "id":118,
        "name":"131640  :  General Manager Of Warehouse | ผู้จัดการทั่วไปด้านคลังเก็บสินค้า | 仓库总经理"
    },
    {
        "id":119,
        "name":"131720  :  General Manager Of Business Services | ผู้จัดการทั่วไปด้านบริการทางธุรกิจ | 商业服务总经理"
    },
    {
        "id":120,
        "name":"131730  :  General Manager Of Property | ผู้จัดการทั่วไปด้านทรัพย์สิน | 物业总经理"
    },
    {
        "id":121,
        "name":"131820  :  General Manager, Personal Services | ผู้จัดการทั่วไปงานบริการส่วนบุคคล | 个人服务总经理"
    },
    {
        "id":122,
        "name":"131830  :  General Manager Of Cleaning | ผู้จัดการทั่วไปด้านการทำความสะอาด | 清洁部总经理"
    },
    {
        "id":123,
        "name":"131920  :  General Manager Of A Travel Agency | ผู้จัดการทั่วไปบริษัทตัวแทนธุรกิจท่องเที่ยว | 某旅行社总经理"
    },
    {
        "id":124,
        "name":"211110  :  General Physicist | นักฟิสิกส์ทั่วไป | 普通物理学家"
    },
    {
        "id":125,
        "name":"211120  :  Specialized Physicist | นักฟิสิกส์เฉพาะทาง | 专业物理学家"
    },
    {
        "id":126,
        "name":"211130  :  Astronomer | นักดาราศาสตร์ | 天文学家"
    },
    {
        "id":127,
        "name":"211210  :  Meteorologist | นักอุตุนิยมวิทยา | 气象学家"
    },
    {
        "id":128,
        "name":"211310  :  General Chemist | นักเคมีทั่วไป | 普通化学家"
    },
    {
        "id":129,
        "name":"211315  :  Industrial Chemist | นักเคมีอุตสาหกรรม | 工业化学家"
    },
    {
        "id":130,
        "name":"211320  :  Organic Chemist | นักอินทรีย์เคมี | 有机化学家"
    },
    {
        "id":131,
        "name":"211325  :  Inorganic Chemist | นักอนินทรีย์เคมี | 无机化学家"
    },
    {
        "id":132,
        "name":"211330  :  Analytical Chemist | นักเคมีวิเคราะห์ | 分析化学家"
    },
    {
        "id":133,
        "name":"211340  :  Physical Chemist | นักเคมีเชิงฟิสิกส์ | 物理化学家"
    },
    {
        "id":134,
        "name":"211345  :  Nuclear Chemist | นักนิวเคลียร์เคมี | 核化学家"
    },
    {
        "id":135,
        "name":"211350  :  Radiochemist | นักเคมีรังสี | 放射化学家"
    },
    {
        "id":136,
        "name":"211355  :  Fiber-Textile Chemist | นักเคมีเส้นใย-สิ่งทอ | 纤维纺织化学家"
    },
    {
        "id":137,
        "name":"211360  :  Polymer Chemist | นักเคมีพอลิเมอร์ | 高分子化学家"
    },
    {
        "id":138,
        "name":"211365  :  Petroleum Products Chemist | นักเคมีผลิตภัณฑ์ปิโตรเลียม | 石油产品化学家"
    },
    {
        "id":139,
        "name":"211370  :  Corrosion Chemist | นักเคมีด้านการกัดกร่อน | 腐蚀化学家"
    },
    {
        "id":140,
        "name":"211375  :  Electrochemist | นักเคมีไฟฟ้า | 电化学家"
    },
    {
        "id":141,
        "name":"211380  :  Surface Chemist | นักเคมีพื้นผิว | 表面化学家"
    },
    {
        "id":142,
        "name":"211385  :  Soil Chemist | นักเคมีของดิน | 土壤化学家"
    },
    {
        "id":143,
        "name":"211390  :  Other Chemists | นักเคมีอื่น ๆ | 其他化学家"
    },
    {
        "id":144,
        "name":"211410  :  General Geologist | นักธรณีวิทยาทั่วไป | 普通地质学家"
    },
    {
        "id":145,
        "name":"211420  :  Geophysicist | นักธรณีฟิสิกส์ | 地球物理学家"
    },
    {
        "id":146,
        "name":"211425  :  Geochemist | นักธรณีเคมี | 地球化学家"
    },
    {
        "id":147,
        "name":"211430  :  Petroleum Geologist | นักธรณีปิโตรเลียม | 石油地质学家"
    },
    {
        "id":148,
        "name":"211435  :  Paleontologist | นักบรรพชีวัน | 古生物学家"
    },
    {
        "id":149,
        "name":"211440  :  Geologist | นักธรณีวิศวกรรม | 地质学家"
    },
    {
        "id":150,
        "name":"211445  :  Geotechnologist | นักธรณีเทคโนโลยี | 岩土工程师"
    },
    {
        "id":151,
        "name":"211450  :  Mineral Geologist | นักธรณีแหล่งแร่ | 矿物地质学家"
    },
    {
        "id":152,
        "name":"211455  :  Hydrologist | นักอุทกวิทยา | 水文学家"
    },
    {
        "id":153,
        "name":"211490  :  Other Geologists | นักธรณีอื่น ๆ | 其他地质学家"
    },
    {
        "id":154,
        "name":"212110  :  Pure Mathematician | นักคณิตศาสตร์บริสุทธิ์ | 纯数学家"
    },
    {
        "id":155,
        "name":"212120  :  Applied Mathematician | นักคณิตศาสตร์ประยุกต์ | 应用数学家"
    },
    {
        "id":156,
        "name":"212130  :  Operations Research Analyst | นักวิเคราะห์ด้านการวิจัยเชิงปฏิบัติการ | 运筹分析师"
    },
    {
        "id":157,
        "name":"212140  :  Actuary | นักคณิตศาสตร์ประกันภัย | 精算师"
    },
    {
        "id":158,
        "name":"212210  :  General Statistician | นักสถิติทั่วไป | 普通统计学家"
    },
    {
        "id":159,
        "name":"212220  :  Mathematical Statistician | นักสถิติทางคณิตศาสตร์ | 数理统计学家"
    },
    {
        "id":160,
        "name":"212230  :  Applied Statistician | นักสถิติประยุกต์ | 应用统计学家"
    },
    {
        "id":161,
        "name":"212240  :  Specialist Statistician (Agricultural Statistics, Financial Studies, Labor Surveys, Various Statistics) \/ Demographic Statistician, Demographer | นักสถิติเฉพาะสาขา (สถิติการเกษตร, การศึกษาการเงิน การสำรวจ การแรงงาน สถิติต่าง ๆ) \/ นักสถิติประชากร , นักประชากรศาสตร์ | 专业统计学家（农业统计、金融研究、劳动调查、各种统计）\/人口统计学家、人口统计学家"
    },
    {
        "id":162,
        "name":"213110  :  Systems Analyst (Computer), Program Analyst | นักวิเคราะห์ระบบ (คอมพิวเตอร์) , นักวิเคราะห์โปรแกรม | 系统分析师（计算机），程序分析师"
    },
    {
        "id":163,
        "name":"213120  :  Applied Software Specialist (System Developer, Senior Programmer) | ผู้เชี่ยวชาญด้านซอฟท์แวร์ประยุกต์ (นักพัฒนาระบบ , โปรแกรมเมอร์อาวุโส) | 应用软件专家（系统开发人员、高级程序员）"
    },
    {
        "id":164,
        "name":"213130  :  Data Communication Specialist (Network Administrator, Network Analyst, Lan System) | ผู้เชี่ยวชาญด้านสื่อสารข้อมูล (นักบริหารข่ายงาน , นักวิเคราะห์ระบบข่ายงาน , ระบบ LAN) | 数据通讯专家（网络管理员、网络分析师、Lan系统）"
    },
    {
        "id":165,
        "name":"213140  :  Database Expert (Database Analyst) | ผู้เชี่ยวชาญด้านฐานข้อมูล (นักวิเคราะห์ฐานข้อมูล) | 数据库专家（数据库分析师）"
    },
    {
        "id":166,
        "name":"213150  :  It Security Expert | ผู้เชี่ยวชาญด้านความปลอดภัยของ ไอที | It安全专家"
    },
    {
        "id":167,
        "name":"213160  :  Software Engineer | วิศวกรซอฟต์แวร์ | 软件工程师"
    },
    {
        "id":168,
        "name":"213170  :  Cad & Cam Expert, (Consultant, Cad & Cam Software Developer) | ผู้เชี่ยวชาญด้าน CAD & CAM , (ที่ปรึกษา , นักพัฒนาซอฟต์แวร์ CAD & CAM ) | Cad & Cam 专家（顾问、Cad & Cam 软件开发人员）"
    },
    {
        "id":169,
        "name":"213210  :  Programmer (Programmer, System Programmer) | โปรแกรมเมอร์ (นักเขียนโปรแกรม, โปรแกรมเมอร์ระบบ) | 程序员（程序员、系统程序员）"
    },
    {
        "id":170,
        "name":"213220  :  Webmaster (Website Designer) | เว็บมาสเตอร์ (นักออกแบบเว็บไซด์) | 网站管理员（网站设计师）"
    },
    {
        "id":171,
        "name":"213230  :  Computer Training Staff | เจ้าหน้าที่ฝึกอบรมคอมพิวเตอร์ | 电脑培训人员"
    },
    {
        "id":172,
        "name":"213910  :  It Sales Engineer | วิศวกรขายด้านไอที | It销售工程师"
    },
    {
        "id":173,
        "name":"213920  :  It Sales Engineer (It Sales And Service Engineer) | วิศวกรขายด้าน ไอที (วิศวกรขายและบริการด้านไอที) | It销售工程师（It销售与服务工程师）"
    },
    {
        "id":174,
        "name":"213990  :  Computer Professionals Which Are Not Classified Here | ผู้ประกอบวิชาชีพด้านคอมพิวเตอร์ ซึ่งมิได้จัดประเภทไว้ในที่นี้ | 计算机专业人士此处未分类"
    },
    {
        "id":175,
        "name":"214120  :  Building Architect | สถาปนิกงานอาคาร | 建筑建筑师"
    },
    {
        "id":176,
        "name":"214125  :  Building Interior Architect, Decorative Arts | สถาปนิกงานตกแต่งภายในอาคาร , มัณฑนศิลป์ | 建筑室内建筑师、装饰艺术"
    },
    {
        "id":177,
        "name":"214130  :  Landscape Architect, Landscape Architect | สถาปนิกงานภูมิทัศน์, ภูมิสถาปนิก | 景观设计师, 景观设计师"
    },
    {
        "id":178,
        "name":"214140  :  City ​​Planner, City Planner | นักวางผังเมือง , นักผังเมือง | 城市规划师、城市规划师"
    },
    {
        "id":179,
        "name":"214145  :  City ​​Planner | นักผังเมือง | 城市规划师"
    },
    {
        "id":180,
        "name":"214150  :  Traffic Planner, Traffic Engineer | นักวางแผนผังการจราจร , วิศวกรจราจร | 交通规划师、交通工程师"
    },
    {
        "id":181,
        "name":"214190  :  Architects\/Urban Planners And Other Traffic Systems | สถาปนิก\/นักวางผังเมืองและระบบงานจราจรอื่น ๆ | 建筑师\/城市规划师和其他交通系统"
    },
    {
        "id":182,
        "name":"214210  :  General Civil Engineer | วิศวกรโยธาทั่วไป | 普通土木工程师"
    },
    {
        "id":183,
        "name":"214215  :  Civil Engineer (Construction) | วิศวกรโยธา (การก่อสร้าง) | 土木工程师（建筑）"
    },
    {
        "id":184,
        "name":"214220  :  Civil Engineer (Road And Highway Construction), Road Engineer | วิศวกรโยธา (ก่อสร้างถนนและทางหลวง) , วิศวกรการทาง | 土木工程师（道路和公路建设）、道路工程师"
    },
    {
        "id":185,
        "name":"214225  :  Civil Engineer (Airport Construction), Airport Engineer | วิศวกรโยธา (ก่อสร้างท่าอากาศยาน) , วิศวกรท่าอากาศยาน | 土木工程师（机场建设）、机场工程师"
    },
    {
        "id":186,
        "name":"214230  :  Civil Engineer (Railway Construction), Railway Engineer | วิศวกรโยธา (ก่อสร้างทางรถไฟ ) , วิศวกรรถไฟ | 土木工程师（铁路建设）、铁路工程师"
    },
    {
        "id":187,
        "name":"214235  :  Civil Engineer (Bridge Construction), Bridge Engineer | วิศวกรโยธา (ก่อสร้างสะพาน) , วิศวกรสะพาน | 土木工程师（桥梁建设）、桥梁工程师"
    },
    {
        "id":188,
        "name":"214240  :  Civil Engineer (Drilling And Tunnel Construction), Tunnel Engineer | วิศวกรโยธา (ขุดเจาะและก่อสร้างอุโมงค์) , วิศวกรอุโมงค์ | 土木工程师（钻孔和隧道施工）、隧道工程师"
    },
    {
        "id":189,
        "name":"214245  :  Civil Engineer (Environmental) , Environmental Engineer | วิศวกรโยธา (สิ่งแวดล้อม) , วิศวกรสิ่งแวดล้อม | 土木工程师（环境）、环境工程师"
    },
    {
        "id":190,
        "name":"214250  :  Civil Engineer (Irrigation) | วิศวกรโยธา (ชลประทาน) | 土木工程师（灌溉）"
    },
    {
        "id":191,
        "name":"214255  :  Civil Engineer (Geotechnical Engineering) | วิศวกรโยธา (ปฐพีวิศวกรรม) | 土木工程师（岩土工程）"
    },
    {
        "id":192,
        "name":"214260  :  Transportation Engineer | วิศวกรขนส่ง | 交通工程师"
    },
    {
        "id":193,
        "name":"214270  :  Agricultural Engineer | วิศวกรการเกษตร | 农业工程师"
    },
    {
        "id":194,
        "name":"214290  :  Other Civil Engineers | วิศวกรโยธาอื่นๆ | 其他土木工程师"
    },
    {
        "id":195,
        "name":"214310  :  General Electrical Engineer | วิศวกรไฟฟ้าทั่วไป | 通用电气工程师"
    },
    {
        "id":196,
        "name":"214320  :  Electrical Power Engineer | วิศวกรไฟฟ้ากำลัง | 电力工程师"
    },
    {
        "id":197,
        "name":"214330  :  Electrical Engineer (Measurement And Control System) | วิศวกรไฟฟ้า (ระบบวัดคุม) | 电气工程师（测控系统）"
    },
    {
        "id":198,
        "name":"214340  :  Electrical Engineer (Electromechanical Equipment) | วิศวกรไฟฟ้า (อุปกรณ์เครื่องกลไฟฟ้า) | 电气工程师（机电设备）"
    },
    {
        "id":199,
        "name":"214350  :  Electrical Engineer (Power Transmission System) | วิศวกรไฟฟ้า (ระบบส่งจ่ายกำลังไฟฟ้า) | 电气工程师（输电系统）"
    },
    {
        "id":200,
        "name":"214390  :  Other Electrical Engineers | วิศวกรไฟฟ้าอื่นๆ | 其他电气工程师"
    },
    {
        "id":201,
        "name":"214420  :  Electronic Engineer | วิศวกรอิเล็กทรอนิกส์ | 电子工程师"
    },
    {
        "id":202,
        "name":"214430  :  Computer Engineer | วิศวกรคอมพิวเตอร์ | 计算机工程师"
    },
    {
        "id":203,
        "name":"214440  :  Telecommunications Engineer | วิศวกรสื่อสารโทรคมนาคม | 电信工程师"
    },
    {
        "id":204,
        "name":"214445  :  Telecommunications Engineer (Equipment) | วิศวกรสื่อสารโทรคมนาคม (อุปกรณ์) | 电信工程师（设备）"
    },
    {
        "id":205,
        "name":"214490  :  Electronic And Other Communications Engineers | วิศวกรสื่อสารอิเล็กทรอนิกส์และการสื่อสารอื่นๆ | 电子和其他通信工程师"
    },
    {
        "id":206,
        "name":"214510  :  General Mechanical Engineer | วิศวกรเครื่องจักรกลทั่วไป | 通用机械工程师"
    },
    {
        "id":207,
        "name":"214512  :  Mechanical Engineer (Machines And Machine Tools) | วิศวกรเครื่องกล (เครื่องจักรและเครื่องมือกล) | 机械工程师（机器和机床）"
    },
    {
        "id":208,
        "name":"214514  :  Mechanical Engineer (Turbines Except Turbines And Aircraft) | วิศวกรเครื่องกล (เครื่องกังหัน ยกเว้น และอากาศยาน) | 机械工程师（涡轮机和飞机除外）"
    },
    {
        "id":209,
        "name":"214516  :  Mechanical Engineer (Pipeline) | วิศวกรเครื่องกล (ระบบท่อ) | 机械工程师（管道）"
    },
    {
        "id":210,
        "name":"214518  :  Mechanical Engineer (Steam Generator And Pressure Vessels) | วิศวกรเครื่องกล (เครื่องกำเนิดไอน้ำ และภาชนะรับแรงดัน) | 机械工程师（蒸汽发生器和压力容器）"
    },
    {
        "id":211,
        "name":"214520  :  Agricultural Machinery Engineer | วิศวกรเครื่องจักรกลการเกษตร | 农业机械工程师"
    },
    {
        "id":212,
        "name":"214525  :  Mechanical Engineer (Agriculture) | วิศวกรเครื่องกล (การเกษตร) | 机械工程师（农业）"
    },
    {
        "id":213,
        "name":"214530  :  Mechanical Engineer (Food) | วิศวกรเครื่องกล (อาหาร) | 机械工程师（食品）"
    },
    {
        "id":214,
        "name":"214540  :  Nuclear Technology Engineer, Nuclear Energy Engineer | วิศวกรนิวเคลียร์เทคโนโลยี , วิศวกรพลังงานนิวเคลียร์ | 核技术工程师、核能工程师"
    },
    {
        "id":215,
        "name":"214550  :  Aeronautical And Aircraft Engineer | วิศวกรการบินและอากาศยาน | 航空和飞机工程师"
    },
    {
        "id":216,
        "name":"214555  :  Mechanical Engineering (Railway) | วิศวะเครื่องกล(รถไฟ) | 机械工程（铁路）"
    },
    {
        "id":217,
        "name":"214556  :  Aircraft Inspector, Engineer Inspector, Inspector | นายตรวจอากาศยาน , สารวัตรช่าง , นายตรวจ | 飞机检查员、工程师检查员、检查员"
    },
    {
        "id":218,
        "name":"214560  :  Automotive Engineer, Mechanical Engineer (Automobile) | วิศวกรยานยนต์ , วิศวกรเครื่องกล (รถยนต์) | 汽车工程师、机械工程师（汽车）"
    },
    {
        "id":219,
        "name":"214565  :  Mechanical Engineer (Internal Combustion Engines, Except Engines Used In Ships, Aircraft, And Automobiles) | วิศวกรเครื่องกล (เครื่องยนต์ชนิดสันดาปภายใน ยกเว้น เครื่องยนต์ที่ใช้กับเรืออากาศยาน และรถยนต์) | 机械工程师（内燃机，船舶、飞机和汽车用发动机除外）"
    },
    {
        "id":220,
        "name":"214570  :  Ship Engineer | วิศวกรเรือ | 船舶工程师"
    },
    {
        "id":221,
        "name":"214575  :  Shipbuilding Engineer | วิศวกรต่อเรือ | 造船工程师"
    },
    {
        "id":222,
        "name":"214580  :  Mechanical Engineer (Structural) | วิศวกรเครื่องกล (โครงสร้าง) | 机械工程师（结构）"
    },
    {
        "id":223,
        "name":"214582  :  Mechanical Engineer (Maintenance) | วิศวกรเครื่องกล (บำรุงรักษา) | 机械工程师（维修）"
    },
    {
        "id":224,
        "name":"214584  :  Mechanical Engineer (Air Conditioning System) | วิศวกรเครื่องกล (ระบบปรับอากาศ) | 机械工程师（空调系统）"
    },
    {
        "id":225,
        "name":"214586  :  Mechanical Engineer (Cooling System) | วิศวกรเครื่องกล (ระบบทำความเย็น) | 机械工程师(冷却系统)"
    },
    {
        "id":226,
        "name":"214590  :  Other Mechanical Engineers | วิศวกรเครื่องกลอื่นๆ | 其他机械工程师"
    },
    {
        "id":227,
        "name":"214610  :  General Chemical Engineer | วิศวกรเคมีทั่วไป | 普通化学工程师"
    },
    {
        "id":228,
        "name":"214620  :  Chemical Product Engineer | วิศวกรผลิตภัณฑ์เคมี | 化工产品工程师"
    },
    {
        "id":229,
        "name":"214625  :  Chemical Production Engineer | วิศวกรการผลิตเคมีภัณฑ์ | 化工生产工程师"
    },
    {
        "id":230,
        "name":"214630  :  Petroleum Engineer | วิศวกรปิโตรเลียม | 石油工程师"
    },
    {
        "id":231,
        "name":"214640  :  Food And Beverage Technologist | นักเทคโนโลยีอาหารและเครื่องดื่ม | 食品和饮料技术员"
    },
    {
        "id":232,
        "name":"214650  :  Textile Chemical Engineer | วิศวกรเคมีสิ่งทอ | 纺织化学工程师"
    },
    {
        "id":233,
        "name":"214660  :  Industrial Chemical Technologist | นักเทคโนโลยีเคมีอุตสาหกรรม | 工业化学技师"
    },
    {
        "id":234,
        "name":"214690  :  Other Chemical Engineers | วิศวกรเคมีอื่น ๆ | 其他化学工程师"
    },
    {
        "id":235,
        "name":"214710  :  General Mining Engineer | วิศวกรเหมืองแร่ทั่วไป | 采矿总工程师"
    },
    {
        "id":236,
        "name":"214720  :  Metal Mining Engineer | วิศวกรเหมืองแร่โลหะ | 金属采矿工程师"
    },
    {
        "id":237,
        "name":"214730  :  Non-Metallic Mining Engineer | วิศวกรเหมืองแร่อโลหะ | 非金属采矿工程师"
    },
    {
        "id":238,
        "name":"214740  :  Petroleum And Gas Mining Engineer | วิศวกรเหมืองแร่ปิโตรเลียมและก๊าซ | 石油和天然气开采工程师"
    },
    {
        "id":239,
        "name":"214750  :  Metallurgical Engineer | วิศวกรโลหการ | 冶金工程师"
    },
    {
        "id":240,
        "name":"214760  :  Metallurgy Smelting | นักโลหกรรมการถลุง | 冶金冶炼"
    },
    {
        "id":241,
        "name":"214790  :  Other Mining Engineers | วิศวกรเหมืองแร่อื่น ๆ | 其他采矿工程师"
    },
    {
        "id":242,
        "name":"214810  :  General Explorer | นักสำรวจทั่วไป | 通用探险家"
    },
    {
        "id":243,
        "name":"214820  :  Cartographer | นักทำแผนที่ | 制图师"
    },
    {
        "id":244,
        "name":"214830  :  Ground Surveyor | นักสำรวจพื้นดิน | 地面测量员"
    },
    {
        "id":245,
        "name":"214835  :  Mining Explorer | นักสำรวจเหมืองแร่ | 采矿探险家"
    },
    {
        "id":246,
        "name":"214840  :  Water Surface Explorer | นักสำรวจพื้นน้ำ | 水面探索者"
    },
    {
        "id":247,
        "name":"214850  :  Sky Explorer | นักสำรวจท้องฟ้า | 天空探索者"
    },
    {
        "id":248,
        "name":"214860  :  Aerial Photographer | ช่างถ่ายภาพทางอากาศ | 航空摄影师"
    },
    {
        "id":249,
        "name":"214890  :  Cartographers And Other Explorers | นักทำแผนที่และนักสำรวจอื่น ๆ | 制图师和其他探险家"
    },
    {
        "id":250,
        "name":"214910  :  Industrial Engineer | วิศวกรอุตสาหการ | 工业工程师"
    },
    {
        "id":251,
        "name":"214920  :  Performance Control Engineer | วิศวกรควบคุมประสิทธิภาพ | 性能控制工程师"
    },
    {
        "id":252,
        "name":"214925  :  Quality Engineer ;Quality Control Engineer | วิศวกรคุณภาพ ;วิศวกรควบคุมคุณภาพ | 质量工程师；质量控制工程师"
    },
    {
        "id":253,
        "name":"214930  :  Manufacturing Industrial Engineer; Industrial Engineer Factory | วิศวกรอุตสาหกรรมการผลิต; วิศวกรอุตสาหกรรมโรงงาน | 制造工业工程师；工业工程师工厂"
    },
    {
        "id":254,
        "name":"214934  :  Textile Engineer ; Textile Industrial Engineer | วิศวกรสิ่งทอ ; วิศวกรอุตสหกรรมสิ่งทอ | 纺织工程师；纺织工业工程师"
    },
    {
        "id":255,
        "name":"214936  :  Clothing And Clothing Engineer | วิศวกรเสื้อผ้าและเครื่องนุ่งห่ม | 服装及服装工程师"
    },
    {
        "id":256,
        "name":"214940  :  Safety Engineer | วิศวกรความปลอดภัย | 安全工程师"
    },
    {
        "id":257,
        "name":"214945  :  Safety Engineer (Product) | วิศวกรความปลอดภัย (ผลิตภัณฑ์) | 安全工程师（产品）"
    },
    {
        "id":258,
        "name":"214950  :  Environmental Engineer, Water Supply Engineer, Wastewater Treatment Engineer | วิศวกรสิ่งแวดล้อม,วิศวกรประปา,วิศวกรบำบัดนำเสีย | 环境工程师、供水工程师、废水处理工程师"
    },
    {
        "id":259,
        "name":"214990  :  Architects, Engineers And Other Related Professionals | สถาปนิกวิศวกรและผู้ประกอบวิชาชีพที่เกี่ยวข้องอื่น ๆ | 建筑师、工程师和其他相关专业人员"
    },
    {
        "id":260,
        "name":"221110  :  General Biologist | นักชีววิทยาทั่วไป | 普通生物学家"
    },
    {
        "id":261,
        "name":"221120  :  Botanist | นักพฤษศาสตร์ | 植物学家"
    },
    {
        "id":262,
        "name":"221130  :  Zoologist | นักสัตววิทยา | 动物学家"
    },
    {
        "id":263,
        "name":"221140  :  Microbiologist And Virologist | นักจุลชีววิทยาและไวรัส | 微生物学家和病毒学家"
    },
    {
        "id":264,
        "name":"221150  :  Ecologist | นักนิเวศวิทยา | 生态学家"
    },
    {
        "id":265,
        "name":"221160  :  Biotechnologist | นักเทคโนโลยีชีวภาพ | 生物技术专家"
    },
    {
        "id":266,
        "name":"221170  :  Marine Scientist | นักวิทยาศาสตร์ทางทะเล | 海洋科学家"
    },
    {
        "id":267,
        "name":"221190  :  Biologists And Other Related Scientists | นักชีววิทยาและนักวิทยาศาสตร์ที่เกี่ยวข้องกันอื่นๆ | 生物学家和其他相关科学家"
    },
    {
        "id":268,
        "name":"221210  :  Pharmacologist | นักเภสัชวิทยา | 药理学家"
    },
    {
        "id":269,
        "name":"221220  :  Pharmacologist | นักเภสัชววิทยา | 药理学家"
    },
    {
        "id":270,
        "name":"221225  :  Physiologist | นักสรีรวิทยา | 生理学家"
    },
    {
        "id":271,
        "name":"221230  :  Biochemist | นักชีวเคมี | 生物化学家"
    },
    {
        "id":272,
        "name":"221235  :  Biological Physicist | นักฟิสิกส์ชีวภาพ | 生物物理学家"
    },
    {
        "id":273,
        "name":"221240  :  Pathologist | นักพยาธิวิทยา | 病理学家"
    },
    {
        "id":274,
        "name":"221245  :  Plant Pathologist | นักโรคพืช | 植物病理学家"
    },
    {
        "id":275,
        "name":"221250  :  Medical Technician | นักเทคนิคการแพทย์ | 医疗技术员"
    },
    {
        "id":276,
        "name":"221255  :  Radiologic Technologist | นักรังสีเทคนิค | 放射技师"
    },
    {
        "id":277,
        "name":"221290  :  Pharmacologist Pathologists And Other Related Professionals | นักเภสัชวิทยา นักพยาธิวิทยาและผู้ประกอยวิชาชีพที่เกี่ยวข้องอื่นๆ | 药理学家病理学家和其他相关专业人员"
    },
    {
        "id":278,
        "name":"221320  :  Agronomist, Plant Farmer | นักพืชไร่ , พืชกร | 农学家、植物农民"
    },
    {
        "id":279,
        "name":"221330  :  Horticulturist | นักพืชสวน | 园艺师"
    },
    {
        "id":280,
        "name":"221340  :  Forest Scientist, Silviculturalist | นักวิทยาศาสตร์ป่าไม้ , นักวนวัฒนวิทยา | 森林科学家、造林学家"
    },
    {
        "id":281,
        "name":"221345  :  Forestry Academic | นักวิชาการป่าไม้ | 林业学术"
    },
    {
        "id":282,
        "name":"221350  :  Agronomist, Agricultural Soil Scientist | นักปฐพีวิทยา, นักวิทยาศาสตร์การเกษตรทางดิน | 农学家、农业土壤科学家"
    },
    {
        "id":283,
        "name":"221360  :  Animal Husbandman | นักสัตวบาล | 动物饲养员"
    },
    {
        "id":284,
        "name":"221365  :  Entomologist | นักกีฏวิทยา | 昆虫学家"
    },
    {
        "id":285,
        "name":"221390  :  Agriculturalists And Other Related Professionals | นักเกษตรกรรมและผู้ประกอบวิชาชีพที่เกี่ยวข้องอื่น ๆ | 农学家和其他相关专业人员"
    },
    {
        "id":286,
        "name":"222110  :  General Doctor | แพทย์ทั่วไป | 全科医生"
    },
    {
        "id":287,
        "name":"222115  :  Specialized Doctors (Ophthalmologist, Obstetrician-Gynecologist, Pediatrician) | แพทย์เฉพาะทาง (จักษุแพทย์ , สูตินารีแพทย์ , กุมารแพทย์) | 专科医生（眼科医生、妇产科医生、儿科医生）"
    },
    {
        "id":288,
        "name":"222120  :  Internal Medicine Doctor, Internist | แพทย์อายุรกรรม , อายุรแพทย์ | 内科医生、内科医生"
    },
    {
        "id":289,
        "name":"222122  :  Otolaryngology And Laryngology | โสต-ศอ-นาสิกและลาริงซ์วิทยา | 耳鼻喉科和喉科"
    },
    {
        "id":290,
        "name":"222124  :  Ophthalmologist | จักษุแพทย์ | 眼科医生"
    },
    {
        "id":291,
        "name":"222130  :  Surgeon | ศัลยแพทย์ | 外科医生"
    },
    {
        "id":292,
        "name":"222135  :  Orthopedic Surgeon | ศัลยแพทย์เฉพาะทางกระดูกและข้อ | 骨科医生"
    },
    {
        "id":293,
        "name":"222137  :  Anesthesiologist | วิสัญญีแพทย์ | 麻醉师"
    },
    {
        "id":294,
        "name":"222140  :  Obstetrician-Gynecologist | แพทย์สูติ-นรีแพทย์ | 妇产科医生"
    },
    {
        "id":295,
        "name":"222145  :  Pediatrician | กุมารแพทย์ | 儿科医生"
    },
    {
        "id":296,
        "name":"222150  :  Psychiatrist | จิตแพทย์ | 精神科医生"
    },
    {
        "id":297,
        "name":"222160  :  Radiologist | รังสีแพทย์ | 放射科医生"
    },
    {
        "id":298,
        "name":"222165  :  Physical Therapy Doctor | แพทย์กายภาพบำบัด | 物理治疗医生"
    },
    {
        "id":299,
        "name":"222170  :  Rehabilitation Medicine Doctor | แพทย์เวชศาสตร์ฟื้นฟู | 康复医学医生"
    },
    {
        "id":300,
        "name":"222180  :  Dermatologist (Dermatologist) | แพทย์ตจวิทยา (แพทย์โรคผิวหนัง) | 皮肤科医生（皮肤科医生）"
    },
    {
        "id":301,
        "name":"222190  :  Other Doctors | แพทย์อื่น ๆ | 其他医生"
    },
    {
        "id":302,
        "name":"222210  :  General Dentist | ทันตแพทย์ทั่วไป | 普通牙医"
    },
    {
        "id":303,
        "name":"222215  :  Specialist Dentist (Pediatric Dentist) | ทันตแพทย์เฉพาะทาง (ทันตแพทย์สำหรับเด็ก) | 专科牙医（儿科牙医）"
    },
    {
        "id":304,
        "name":"222220  :  Specialist Dentist (Oral And Maxillofacial Surgery) | ทันตแพทย์เฉพาะทาง (ศัลยศาสตร์ช่องปากและแม็กซิลโลเฟเชียล) | 专科牙医（口腔颌面外科）"
    },
    {
        "id":305,
        "name":"222225  :  Specialist Dentist (Oral Disease Research Science) | ทันตแพทย์เฉพาะทาง (วิทยาการวิจัยโรคช่องปาก) | 专科牙医（口腔疾病研究科学）"
    },
    {
        "id":306,
        "name":"222230  :  Dentist (Orthodontist) | ทันตแพทย์ (จัดฟัน) | 牙医（正畸医生）"
    },
    {
        "id":307,
        "name":"222235  :  Specialist Dentist (Artificial Dentistry) | ทันตแพทย์เฉพาะทาง (ทันกรรมประดิษฐ์) | 专科牙医（人工牙科）"
    },
    {
        "id":308,
        "name":"222240  :  Specialist Dentist (Dental Public Health) | ทันตแพทย์เฉพาะทาง (ทันตสาธารณสุข) | 专科牙医（牙科公共卫生）"
    },
    {
        "id":309,
        "name":"222245  :  Specialist Dentist (Operational Dentistry) | ทันตแพทย์เฉพาะทาง (ทันตกรรรมหัตถการ) | 专科牙医（牙科手术）"
    },
    {
        "id":310,
        "name":"222250  :  Specialist Dentist (Periodontics) | ทันตแพทย์เฉพาะทาง (ปริทันตวิทยา) | 专科牙医（牙周病学）"
    },
    {
        "id":311,
        "name":"222255  :  Specialist Dentist (Endodontics) | ทันตแพทย์เฉพาะทาง (วิทยาเอ็นโดดอนต์) | 专科牙医（牙髓病学）"
    },
    {
        "id":312,
        "name":"222290  :  Other Dentists | ทันตแพทย์อื่น ๆ | 其他牙医"
    },
    {
        "id":313,
        "name":"222310  :  General Veterinarian | สัตวแพทย์ทั่วไป | 普通兽医"
    },
    {
        "id":314,
        "name":"222320  :  Pet Veterinarian | สัตวแพทย์สัตว์เลี้ยง | 宠物兽医"
    },
    {
        "id":315,
        "name":"222330  :  Wildlife Veterinarian | สัตวแพทย์สัตว์ป่า | 野生动物兽医"
    },
    {
        "id":316,
        "name":"222340  :  Aquatic Animal Veterinarian | สัตวแพทย์สัตว์น้ำ | 水生动物兽医"
    },
    {
        "id":317,
        "name":"222350  :  Livestock Veterinarian | สัตวแพทย์ปศุสัตว์ | 畜牧兽医"
    },
    {
        "id":318,
        "name":"222360  :  Public Health Veterinarian | สัตวแพทย์สาธารณสุข | 公共卫生兽医"
    },
    {
        "id":319,
        "name":"222370  :  Veterinarian Autopsy | สัตวแพทย์ชันสูตร | 兽医尸检"
    },
    {
        "id":320,
        "name":"222390  :  Other Veterinarians | สัตวแพทย์อื่น ๆ | 其他兽医"
    },
    {
        "id":321,
        "name":"222410  :  Pharmacist | เภสัชกร | 药剂师"
    },
    {
        "id":322,
        "name":"222420  :  Hospital Pharmacist | เภสัชกรโรงพยาบาล | 医院药剂师"
    },
    {
        "id":323,
        "name":"222425  :  Community Pharmacist | เภสัชกรชุมชน | 社区药剂师"
    },
    {
        "id":324,
        "name":"222430  :  Industrial Pharmacist | เภสัชกรการอุตสาหกรรม | 工业药剂师"
    },
    {
        "id":325,
        "name":"222435  :  Pharmacists Research And Develop Drugs And Pharmaceuticals. | เภสัชกรวิจัยและพัฒนาตัวยาและเภสัชภัณฑ์ | 药剂师研究和开发药物和药品。"
    },
    {
        "id":326,
        "name":"222440  :  Pharmacist Drug Marketing | เภสัชกรการตลาดยา | 药剂师药品营销"
    },
    {
        "id":327,
        "name":"222450  :  Public Health Pharmacist And Consumer Protection | เภสัชกรสาธารณสุขและการคุ้มครองผู้บริโภค | 公共卫生药剂师和消费者保护"
    },
    {
        "id":328,
        "name":"222490  :  Other Pharmacists | เภสัชกรอื่น ๆ | 其他药剂师"
    },
    {
        "id":329,
        "name":"222920  :  Health Professionals (Except Nursing) That Is Not Classified Elsewhere | ผู้ประกอบวิชาชีพเกี่ยวกับสุขภาพอนามัย (ยกเว้นการพยาบาล) ที่มิได้จัดประเภทไว้ในที่อื่น | 健康专业人士（护理除外）未分类于其他地方的"
    },
    {
        "id":330,
        "name":"223010  :  General Professional Nurse | พยาบาลวิชาชีพทั่วไป | 全科专业护士"
    },
    {
        "id":331,
        "name":"223012  :  Outpatient Professional Nurse | พยาบาลวิชาชีพผู้ป่วยนอก | 门诊专业护士"
    },
    {
        "id":332,
        "name":"223014  :  Inpatient Professional Nurse | พยาบาลวิชาชีพผู้ป่วยใน | 住院专业护士"
    },
    {
        "id":333,
        "name":"223020  :  Specialized Professional Nurses (Anesthesia, Obstetrics, Surgery, Pediatrics, Psychiatry) | พยาบาลวิชาชีพเฉพาะ (วิสัญญี, สูติกรรม, ศัลยกรรม, กุมารเวช , จิตเวช) | 专业护士（麻醉、产科、外科、儿科、精神科）"
    },
    {
        "id":334,
        "name":"223030  :  Midwife, Professional Midwife | พยาบาลผดุงครรภ์ , ผดุงครรภ์อาชีพ | 助产士, 专业助产士"
    },
    {
        "id":335,
        "name":"223040  :  Consultant Nurse, Public Health Nurse, Occupational Health Department | พยาบาลที่ปรึกษา , พยาบาลฝ่ายสาธารณสุข , ฝ่ายอาชีวอนามัย | 顾问护士、公共卫生护士、职业健康科"
    },
    {
        "id":336,
        "name":"223090  :  Other Professional Nurses And Midwives | พยาบาลวิชาชีพและผดุงครรภ์อื่น ๆ | 其他专业护士和助产士"
    },
    {
        "id":337,
        "name":"231010  :  General Teacher (Higher Education, University, College) | อาจารย์ทั่วไป (ระดับอุดมศึกษา , มหาวิทยาลัย , วิทยาลัย) | 普通教师（高等教育、大学、学院）"
    },
    {
        "id":338,
        "name":"231020  :  Specialized Professors (Liberal Arts, Law, Mathematics, Science, Agriculture, Medicine, Engineering, Social Sciences, Arts, Arts) | อาจารย์เฉพาะสาขา (ศิลปศาสตร์ , นิติศาสตร์ , คณิตศาสตร์ วิทยาศาสตร์ , เกษตรศาสตร์ , แพทย์ศาสตร์ , วิศวกรรมศาสตร์, สังคมศาสตร์ , อักษรศาสตร์ , ศิลปะ ) | 专业教授（文科、法学、数学、科学、农业、医学、工程、社会科学、艺术、艺术）"
    },
    {
        "id":339,
        "name":"231022  :  Instructor (Department Of Education And Teacher Training) | ผู้สอน (สาขาวิชาศึกษาศาตร์และการฝึกหัดครู) | 讲师（教育及教师培训系）"
    },
    {
        "id":340,
        "name":"231024  :  Instructor (Social And Behavioral Sciences) | ผู้สอน (สาขาวิชาสังคมศาสตร์และพฤติกรรมศาสตร์) | 讲师（社会和行为科学）"
    },
    {
        "id":341,
        "name":"231030  :  Instructor (Fine Arts And Applied Arts Department) | ผู้สอน (สาขาวิชาวิจิตรศิลป์และประยุกต์ศิลป์) | 讲师（美术与应用艺术系）"
    },
    {
        "id":342,
        "name":"231035  :  Instructor (Major: Mass Communication And Documentation) | ผู้สอน (สาขาวิชาการสื่อสารมวลชนและเอกสาร) | 讲师（专业：大众传播与文献）"
    },
    {
        "id":343,
        "name":"231040  :  Instructor (Law Major) | ผู้สอน (สาขาวิชานิติศาสตร์) | 讲师（法学专业）"
    },
    {
        "id":344,
        "name":"231050  :  Instructor (Commerce And Business Administration) | ผู้สอน (สาขาวิชาการบริหารพาณิชยการและธุรกิจ) | 讲师（商业和工商管理）"
    },
    {
        "id":345,
        "name":"231055  :  Instructor (Home Economics Department) | ผู้สอน (สาขาวิชาคหกรรมศาตร์) | 讲师（家政系）"
    },
    {
        "id":346,
        "name":"231060  :  Instructor (Medical Science And Health Related Subjects) | ผู้สอน (สาขาวิชาแพทย์ศาสตร์และวิชาที่เกี่ยวข้องกับสุขภาพ) | 讲师（医学与健康相关科目）"
    },
    {
        "id":347,
        "name":"231065  :  Instructor (Natural Sciences Academic Program) | ผู้สอน (สาขาวิชาการวิทยาศาสตร์ธรรมชาติ) | 讲师（自然科学学术项目）"
    },
    {
        "id":348,
        "name":"231070  :  Instructor (Engineering Subject) | ผู้สอน (วิชาวิศวกรรมศาตร์) | 讲师（工程学科）"
    },
    {
        "id":349,
        "name":"231075  :  Instructor (Architecture Department And Urban Planning) | ผู้สอน (สาขาวิชาสถาปัตยกรรม และการผังเมือง) | 讲师（建筑系和城市规划）"
    },
    {
        "id":350,
        "name":"231078  :  Instructor (Mathematics And Computer Science) | ผู้สอน (สาขาวิชาคณิตศาสตร์และวิทยาการคอมพิวเตอร์) | 讲师（数学和计算机科学）"
    },
    {
        "id":351,
        "name":"231080  :  Instructor (Agriculture And Forestry And Fisheries Subjects) | ผู้สอน (สาขาวิชาเกษตรศาสตร์ และ วนศาสตร์ และการประมง) | 讲师（农林水产学科）"
    },
    {
        "id":352,
        "name":"231090  :  College Tutor Universities And Higher Education Institutions | ผู้สอนในวิทยาลัย มหาวิทยาลัยและสถาบันอุดมศึกษา | 大学导师大学和高等教育机构"
    },
    {
        "id":353,
        "name":"232010  :  Teachers, General Secondary School Teachers | ครู อาจารย์ระดับมัธยมศึกษาทั่วไป | 教师、普通中学教师"
    },
    {
        "id":354,
        "name":"232020  :  Teachers, Vocational Level Teachers (Only Mathematics, Computers, Industry, Construction, Linguistics, Fine Arts, Society, Housing, Science) | ครู อาจารย์ระดับอาชีวศึกษา (เฉพาะสาขาคณิตศาสตร์,คอมพิวเตอร์, อุตสาหกรรม, ก่อสร้าง, ภาษาศาสตร์, วิจิตรศิลป์, สังคม, เคหะศาสตร์, วิทยาศาสตร์ ) | 教师、职业教师（仅限数学、计算机、工业、建筑、语言学、美术、社会、住房、科学）"
    },
    {
        "id":355,
        "name":"232030  :  Vocational Secondary School Teachers | ผู้สอนในระดับมัธยมศึกษาสายอาชีพ | 职业中学教师"
    },
    {
        "id":356,
        "name":"232090  :  Teachers At Other Secondary Levels | ผู้สอนในระดับมัธยมศึกษาอื่นๆ | 其他中学教师"
    },
    {
        "id":357,
        "name":"233120  :  Primary School Teacher (Degree Level) | ครูประถมศึกษา (ระดับปริญญา) | 小学老师（学位级别）"
    },
    {
        "id":358,
        "name":"233190  :  Teachers At Other Primary Levels | ผู้สอนในระดับประถมศึกษาอื่นๆ | 其他小学教师"
    },
    {
        "id":359,
        "name":"233220  :  Kindergarten Teacher (Degree Level) | ครูอนุบาล (ระดับปริญญา) | 幼儿园教师（学位级别）"
    },
    {
        "id":360,
        "name":"234020  :  Teacher\/Professor (Teaching Blind People) | ครู\/อาจารย์ (สอนคนตาบอด) | 教师\/教授（教导盲人）"
    },
    {
        "id":361,
        "name":"234025  :  Teacher\/Professor (Teaching The Deaf) | ครู\/อาจารย์ (สอนคนหูหนวก) | 教师\/教授（教导聋人）"
    },
    {
        "id":362,
        "name":"234030  :  Teacher\/Professor (Teaching Slow Developers, Mentally Retarded People) | ครู\/อาจารย์ (สอนผู้พัฒนาการช้า , ปัญญาอ่อน) | 教师\/教授（教授开发缓慢、智障人士）"
    },
    {
        "id":363,
        "name":"234040  :  Teachers Who Teach Students Who Have Physical Or Motor Disabilities | ครูสอนผู้เรียนทึ่มีความบหพร่องทางร่างการหรือการเคลื่อนไหว | 教导有身体或运动障碍的学生的教师"
    },
    {
        "id":364,
        "name":"234045  :  Teacher Teaching Students With Multiple Disabilities | ครูสอนผู้เรียนที่มีความบกพร่องซ้ำซ้อน | 老师教导患有多种残疾的学生"
    },
    {
        "id":365,
        "name":"234050  :  Teachers Who Teach Students Who Have Learning Problems | ครูสอนผู้เรียนที่มีปัญหาทางการเรียน | 教导有学习问题的学生的老师"
    },
    {
        "id":366,
        "name":"234055  :  Teacher Teaching Students With Behavioral Problems | ครูสอนผู้เรียนที่มีปัญหาทางพฤติกรรม | 老师教导有行为问题的学生"
    },
    {
        "id":367,
        "name":"234060  :  Teacher Teaching Autistic Students | ครูสอนผู้เรียนออทิซติค | 老师教自闭症学生"
    },
    {
        "id":368,
        "name":"234065  :  Teacher Teaching Adhd Students | ครูสอนผู้เรียนสมาธิสั้น | 老师教多动症学生"
    },
    {
        "id":369,
        "name":"234090  :  Teacher\/Professor Teaching Other Disabled People | ครู\/อาจารย์ สอนผู้พิการอื่นๆ | 教授其他残疾人的教师\/教授"
    },
    {
        "id":370,
        "name":"235120  :  Course Developer | นักพัฒนาหลักสูตร | 课程开发者"
    },
    {
        "id":371,
        "name":"235130  :  Educational Supervisor, Educational Technologist | ศึกษานิเทศก์ , นักเทคโนโลยีทางการศึกษา | 教育督导、教育技术专家"
    },
    {
        "id":372,
        "name":"235140  :  Specialist In Teaching Media, Audiovisual Academic | ผู้เชี่ยวชาญพิเศษด้านสื่อการสอน , นักวิชาการโสตทัศนศึกษา | 教学媒体、视听学术专家"
    },
    {
        "id":373,
        "name":"235145  :  Audiovisualist | นักโสตทัศนศึกษา | 视听师"
    },
    {
        "id":374,
        "name":"235190  :  Other Educational Experts | ผู้เชี่ยญชาญพิเศษด้านการศึกษาอื่นๆ | 其他教育专家"
    },
    {
        "id":375,
        "name":"235220  :  School Inspector | ผู้ตรวจการโรงเรียน | 督学"
    },
    {
        "id":376,
        "name":"235990  :  Other Teaching Professionals Not Classified Elsewhere | ผู้ประกอบวิชาชีพด้านการสอนอื่น ๆ ที่มิได้จัดประเภทไว้ในที่อื่น | 未分类于别处的其他教学专业人员"
    },
    {
        "id":377,
        "name":"241110  :  General Accountant, Accountant | นักบัญชีทั่วไป , สมุห์บัญชี | 总会计师、会计师"
    },
    {
        "id":378,
        "name":"241120  :  Specialized Accountant | นักบัญชีเฉพาะสาขา | 专业会计师"
    },
    {
        "id":379,
        "name":"241130  :  Auditor ; Tax Auditor | ผู้สอบบัญชี ; ผู้ตรวจสอบภาษี | 审计师；税务审计员"
    },
    {
        "id":380,
        "name":"241140  :  Internal Auditor | ผู้ตรวจสอบภายใน | 内部审计师"
    },
    {
        "id":381,
        "name":"241220  :  Career Analyst | นักวิเคราะห์งานอาชีพ | 职业分析师"
    },
    {
        "id":382,
        "name":"241230  :  Counselor, Guidance Officer; Career Consultant And Guidance | นักแนะแนว , เจ้าหน้าที่แนะแนว ; ที่ปรึกษาและแนะแนวการประกอบอาชีพ | 辅导员、辅导员；职业顾问和指导"
    },
    {
        "id":383,
        "name":"241240  :  Career Counselor | ผู้ให้คำปรึกษาด้านอาชีพ | 职业顾问"
    },
    {
        "id":384,
        "name":"241290  :  Personnel Professionals And Other Professional Work | ผู้ประกอบวิชาชีพด้านงานบุคลากร และงานอาชีพอื่น ๆ | 人事专业人员以及其他专业工作"
    },
    {
        "id":385,
        "name":"241920  :  Advertiser ; Advertising Creator | นักโฆษณา ; ผู้สร้างสรรค์งานโฆษณา | 广告商；广告创作者"
    },
    {
        "id":386,
        "name":"241930  :  Public Relations Officer\/Public Relations Officer | เจ้าหน้าที่ประชาสัมพันธ์\/นักประชาสัมพันธ์ | 公共关系主任\/公共关系主任"
    },
    {
        "id":387,
        "name":"241935  :  Public Relations Creative Officer | เจ้าหน้าที่สร้างสรรค์งานประชาสัมพันธ์ | 公关创意官"
    },
    {
        "id":388,
        "name":"241940  :  Market Analyst | นักวิเคราะห์ตลาด | 市场分析师"
    },
    {
        "id":389,
        "name":"241950  :  Market Researcher | นักวิจัยตลาด | 市场研究员"
    },
    {
        "id":390,
        "name":"241960  :  Marketer; Marketing Officer ; Sales Promotion Officer | นักการตลาด ; เจ้าหน้าที่การตลาด ; เจ้าหน้าที่ส่งเสริมการขาย | 营销人员；营销官；促销员"
    },
    {
        "id":391,
        "name":"241970  :  Customer Management Officer | เจ้าหน้าที่บริหารงานลูกค้า | 客户管理官"
    },
    {
        "id":392,
        "name":"241980  :  Meeting Planner | นักวางแผนงานประชุม | 会议策划者"
    },
    {
        "id":393,
        "name":"241990  :  Business Professionals That Are Not Classified Elsewhere | ผู้ประกอบวิชาชีพทางธุรกิจ ที่มิได้จัดประเภทไว้ในที่อื่น | 商业专业人士未分类于其他地方的"
    },
    {
        "id":394,
        "name":"242110  :  Legal Jurist | นักกฎหมายกฤษฎีการ | 法律法学家"
    },
    {
        "id":395,
        "name":"242115  :  Lawyer | นิติกร | 律师"
    },
    {
        "id":396,
        "name":"242120  :  Lawyer | ทนายความ | 律师"
    },
    {
        "id":397,
        "name":"242130  :  Prosecutor | พนักงานอัยการ | 检察官"
    },
    {
        "id":398,
        "name":"242190  :  Other Lawyers | นักกฎหมายอื่น ๆ | 其他律师"
    },
    {
        "id":399,
        "name":"242220  :  Judge, Judge | ผู้พิพากษา , ตุลาการ | 法官，法官"
    },
    {
        "id":400,
        "name":"242230  :  Constitutional Court Judge | ตุลาการศาลรัฐธรรมนูญ | 宪法法院法官"
    },
    {
        "id":401,
        "name":"242240  :  Administrative Court Judge | ตุลาการศาลปกครอง | 行政法院法官"
    },
    {
        "id":402,
        "name":"242250  :  Arbitration | อนุญาโตตุลาการ | 仲裁"
    },
    {
        "id":403,
        "name":"242290  :  Legal Professionals Not Classified Elsewhere | ผู้ประกอบวิชาชีพด้านกฎหมายที่มิได้จัดประเภทไว้ที่อื่น | 未分类于其他地方的法律专业人员"
    },
    {
        "id":404,
        "name":"242920  :  Legal Advisor, Legal Officer | ที่ปรึกษาทางกฎหมาย , เจ้าหน้าที่ฝ่ายกฎหมาย | 法律顾问、法律官员"
    },
    {
        "id":405,
        "name":"242930  :  Coroner | เจ้าหน้าที่ชันสูตรศพ | 验尸官"
    },
    {
        "id":406,
        "name":"243110  :  Storekeeper | ภัณฑารักษ์ | 店主"
    },
    {
        "id":407,
        "name":"243120  :  Archivist | นักจดหมายเหตุ | 档案管理员"
    },
    {
        "id":408,
        "name":"243190  :  Other Curators | ภัณฑารักษ์อื่น ๆ | 其他策展人"
    },
    {
        "id":409,
        "name":"243210  :  Librarian | บรรณารักษ์ | 图书管理员"
    },
    {
        "id":410,
        "name":"243220  :  Information Major | นักเอกสารสนเทศ | 信息专业"
    },
    {
        "id":411,
        "name":"243290  :  Librarians And Other Information Professionals | บรรณารักษ์และผู้ประกอบวิชาชีพด้านงานสนเทศอื่น ๆ | 图书馆员和其他信息专业人员"
    },
    {
        "id":412,
        "name":"244110  :  General Economist | นักเศรษฐศาสตร์ทั่วไป | 普通经济学家"
    },
    {
        "id":413,
        "name":"244120  :  Specialized Economist (Finance, Treasury, International Trade) | นักเศรษฐศาสตร์เฉพาะสาขา (การเงิน , การคลัง, การค้าระหว่างประเทศ ) | 专业经济学家（金融、国库、国际贸易）"
    },
    {
        "id":414,
        "name":"244220  :  Sociologist | นักสังคมวิทยา | 社会学家"
    },
    {
        "id":415,
        "name":"244230  :  Anthropologist | นักมนุษยวิทยา | 人类学家"
    },
    {
        "id":416,
        "name":"244240  :  Archaeologist | นักโบราณคดี | 考古学家"
    },
    {
        "id":417,
        "name":"244250  :  Geographer | นักภูมิศาสตร์ | 地理学家"
    },
    {
        "id":418,
        "name":"244320  :  Philosopher | นักปรัชญา | 哲学家"
    },
    {
        "id":419,
        "name":"244330  :  Historian (Social, Political, Economic) | นักประวัติศาสตร์ (สังคม, การเมือง, เศรษฐกิจ) | 历史学家（社会、政治、经济）"
    },
    {
        "id":420,
        "name":"244340  :  Political Scientist | นักรัฐศาสตร์ | 政治学家"
    },
    {
        "id":421,
        "name":"244420  :  Interpreter | ล่าม | 口译员"
    },
    {
        "id":422,
        "name":"244430  :  Linguist, Etymologist | นักภาษาศาสตร์, นักนิรุกติศาสตร์ | 语言学家、词源学家"
    },
    {
        "id":423,
        "name":"244440  :  Translator | นักแปล | 翻译者"
    },
    {
        "id":424,
        "name":"244450  :  Script Translator (Television, Film) | นักแปลบท (โทรทัศน์, ภาพยนตร์) | 剧本翻译（电视、电影）"
    },
    {
        "id":425,
        "name":"244455  :  News Translator | ผู้แปลข่าว | 新闻翻译"
    },
    {
        "id":426,
        "name":"244510  :  General Psychologist | นักจิตวิทยาทั่วไป | 普通心理学家"
    },
    {
        "id":427,
        "name":"244520  :  Specialist Psychologists (Nursing, Education, Society, Industry) | นักจิตวิทยาเฉพาะสาขา (การพยาบาล , การศึกษา , สังคม , อุตสาหกรรม) | 专业心理学家（护理、教育、社会、工业）"
    },
    {
        "id":428,
        "name":"244590  :  Other Painters | นักจิตรวิทยาอื่นๆ | 其他画家"
    },
    {
        "id":429,
        "name":"244610  :  General Social Worker | นักสังคมสงเคราะห์ทั่วไป | 一般社会工作者"
    },
    {
        "id":430,
        "name":"244620  :  Social Worker (Individual, Group) | นักสังคมสงเคราะห์ (เฉพาะราย, กลุ่ม) | 社会工作者（个人、团体）"
    },
    {
        "id":431,
        "name":"244625  :  Social Worker (Specific Group) | นักสังคมสงเคราะห์ (เฉพาะกลุ่ม) | 社会工作者（特定群体）"
    },
    {
        "id":432,
        "name":"244630  :  Social Welfare Officer (Children, Family), Social Welfare Officer | เจ้าหน้าที่สวัสดิการสังคม (เด็ก , ครอบครัว),นักสวัสดิการสังคม | 社会福利主任（儿童、家庭）、社会福利主任"
    },
    {
        "id":433,
        "name":"244690  :  Other Social Workers | นักสังคมสงเคราะห์อื่น ๆ | 其他社会工作者"
    },
    {
        "id":434,
        "name":"245110  :  Novelist | นักประพันธ์ | 小说家"
    },
    {
        "id":435,
        "name":"245115  :  Academic Writer | นักเขียนด้านวิชาการ | 学术作家"
    },
    {
        "id":436,
        "name":"245120  :  Newspaper Editor | บรรณาธิการหนังสือพิมพ์ | 报纸编辑"
    },
    {
        "id":437,
        "name":"245122  :  Newspaper Managing Editor | บรรณาธิการบริหารหนังสือพิมพ์ | 报纸总编辑"
    },
    {
        "id":438,
        "name":"245124  :  Newspaper News Editor | ผู้เรียบเรียงข่าวหนังสือพิมพ์ | 报纸新闻编辑"
    },
    {
        "id":439,
        "name":"245126  :  Newspaper Reporter | ผู้สื่อข่าวหนังสือพิมพ์ | 报纸记者"
    },
    {
        "id":440,
        "name":"245130  :  Radio News Editor | บรรณาธิการข่าววิทยุกระจายเสียง | 电台新闻编辑"
    },
    {
        "id":441,
        "name":"245134  :  Radio News Editor | ผู้เรียบเรียงข่าววิทยุกระจายเสียง | 电台新闻编辑"
    },
    {
        "id":442,
        "name":"245136  :  Radio Broadcast Reporter | ผู้สื่อข่าววิทยุกระจายเสียง | 广播电台记者"
    },
    {
        "id":443,
        "name":"245140  :  Television News Editor | บรรณาธิการข่าวโทรทัศน์ | 电视新闻编辑"
    },
    {
        "id":444,
        "name":"245146  :  Television Reporter | ผู้สื่อข่าวโทรทัศน์ | 电视记者"
    },
    {
        "id":445,
        "name":"245150  :  Radio Script Writer | ผู้เขียนบทวิทยุกระจายเสียง | 广播剧本作家"
    },
    {
        "id":446,
        "name":"245154  :  Screenwriter | ผู้เขียนบทภาพยนตร์ | 编剧"
    },
    {
        "id":447,
        "name":"245156  :  Television Script Writer | ผู้เขียนบทรายการโทรทัศน์ | 电视剧本作家"
    },
    {
        "id":448,
        "name":"245158  :  Television Script Writer | ผู้เขียนบทละครโทรทัศน์ | 电视剧本作家"
    },
    {
        "id":449,
        "name":"245160  :  Novelist | นักเขียนนวนิยาย | 小说家"
    },
    {
        "id":450,
        "name":"245165  :  Copywriter | นักเขียนบทโฆษณา | 撰稿人"
    },
    {
        "id":451,
        "name":"245170  :  Critic | นักวิจารณ์ | 评论家"
    },
    {
        "id":452,
        "name":"245190  :  Author, Journalist And Other Writers | นักประพันธ์ นักหนังสือพิมพ์ และนักเขียนอื่น ๆ | 作家、记者和其他作家"
    },
    {
        "id":453,
        "name":"245210  :  Sculptor | ประติมากร | 雕塑家"
    },
    {
        "id":454,
        "name":"245220  :  Painter, Drawing Artist | จิตรกร, ช่างวาดรูป | 画家、绘画艺术家"
    },
    {
        "id":455,
        "name":"245230  :  Cartoon Artist | ช่างเขียนภาพการ์ตูน | 卡通艺术家"
    },
    {
        "id":456,
        "name":"245240  :  Advertising Draftsman | ช่างเขียนแบบโฆษณา | 广告制图员"
    },
    {
        "id":457,
        "name":"245250  :  Graphic Artist | ศิลปินภาพพิมพ์ | 平面艺术家"
    },
    {
        "id":458,
        "name":"245260  :  What A Mask | ช่างหัวโขน | 什么面具啊"
    },
    {
        "id":459,
        "name":"245261  :  Chang Lai Rodnam | ช่างลายรดน้ำ | 张莱·罗德南"
    },
    {
        "id":460,
        "name":"245262  :  Fine Art Carpentry | ช่างไม้ประณีตศิลป์ | 美术木工"
    },
    {
        "id":461,
        "name":"245263  :  Sculptor | ช่างแกะสลัก | 雕塑家"
    },
    {
        "id":462,
        "name":"245264  :  Gilder | ช่างปิดทอง | 吉尔德"
    },
    {
        "id":463,
        "name":"245265  :  Glass Decorator | ช่างประดับกระจก | 玻璃装饰工"
    },
    {
        "id":464,
        "name":"245266  :  Writer | ช่างเขียน | 作家"
    },
    {
        "id":465,
        "name":"245267  :  Pearl Maker | ช่างมุก | 珍珠制造者"
    },
    {
        "id":466,
        "name":"245268  :  Metal Fabricator | ช่างโลหะประดิษฐ์ | 金属制造商"
    },
    {
        "id":467,
        "name":"245269  :  Sculptor, Figure And Pattern Molder | ช่างปั้น ช่างหล่อหุ่นและลาย | 雕塑家、人物和图案塑造者"
    },
    {
        "id":468,
        "name":"245290  :  Artists Who Work In Art Related To Sculptors And Other Painters. | ช่างผู้ทำงานศิลปะเกี่ยวข้องกับประติมากรและจิตรกรอื่น ๆ | 从事与雕塑家和其他画家相关的艺术工作的艺术家。"
    },
    {
        "id":469,
        "name":"245310  :  Composer, Songwriter | นักประพันธ์เพลง, นักแต่งเพลง | 作曲家、词曲作者"
    },
    {
        "id":470,
        "name":"245315  :  Lyricist | ผู้ประพันธ์เนื้อร้อง | 作词家"
    },
    {
        "id":471,
        "name":"245320  :  Arranger | นักเรียบเรียงเสียงประสาน | 编曲者"
    },
    {
        "id":472,
        "name":"245330  :  Music Director, Orchestra And Orchestra, Conductor | ผู้อำนวยเพลงวงดุริยางค์และวงหัสดนตรี, วาทยากร | 音乐总监、管弦乐队和管弦乐队、指挥"
    },
    {
        "id":473,
        "name":"245340  :  Band Conductor, Band Manager | ผู้ควบคุมวงดนตรี , ผู้จัดการวงดนตรี | 乐队指挥、乐队经理"
    },
    {
        "id":474,
        "name":"245350  :  Music Band Leader | หัวหน้าวงหัสดนตรี | 乐队领队"
    },
    {
        "id":475,
        "name":"245355  :  Symphony Orchestra Leader | หัวหน้าวงซิมโฟนีออเคสต้า | 交响乐团指挥"
    },
    {
        "id":476,
        "name":"245360  :  Musician ; Musical Instrument Practitioner | นักดนตรี ; ผู้ปฏิบัติเครื่องดนตรี | 音乐家;乐器从业者"
    },
    {
        "id":477,
        "name":"245370  :  Singer | นักร้อง | 歌手"
    },
    {
        "id":478,
        "name":"245390  :  Composers, Musicians, And Other Singers | นักประพันธ์เพลง , นักดนตรีและนักร้องเพลงอื่น ๆ | 作曲家、音乐家和其他歌手"
    },
    {
        "id":479,
        "name":"245420  :  Choreographer, Dance Choreographer | นักออกแบบท่าแสดง , ท่าเต้น | 编舞、舞蹈编导"
    },
    {
        "id":480,
        "name":"245430  :  Actor (Dance\/Dance Artist) | นักแสดง (นาฎศิลป์\/นาฎศิลปิน) | 演员（舞蹈\/舞蹈艺术家）"
    },
    {
        "id":481,
        "name":"245440  :  Folk Artist Dancer | นาฎศิลปินพื้นบ้าน | 民间艺术家舞蹈家"
    },
    {
        "id":482,
        "name":"245450  :  Dancers Accompanying Music (Tail Dancers) | นักเต้นรำประกอบเพลง (หางเครื่อง แดนซ์เซอร์) | 伴随音乐的舞者（尾舞者）"
    },
    {
        "id":483,
        "name":"245490  :  Inventors And Performers Of Other Dances | นักประดิษฐ์ท่าแสดงและผู้แสดงระบำอื่น ๆ | 其他舞蹈的发明者和表演者"
    },
    {
        "id":484,
        "name":"245510  :  Actor | นักแสดง | 演员"
    },
    {
        "id":485,
        "name":"245512  :  Radio Drama Actor; Story Teller | นักแสดงละครวิทยุ ; นักเล่านิทาน | 广播剧演员；讲故事的人"
    },
    {
        "id":486,
        "name":"245514  :  Story Teller | นักเล่านิทาน | 讲故事的人"
    },
    {
        "id":487,
        "name":"245515  :  Actor | ผู้แสดงแทนนักแสดง | 演员"
    },
    {
        "id":488,
        "name":"245517  :  Actor Casting Agent, Actor Recruitment Officer | ผู้คัดเลือกนักแสดง , เจ้าหน้าที่จัดหานักแสดง | 演员选角经纪人、演员招募官"
    },
    {
        "id":489,
        "name":"245520  :  Film Director | ผู้กำกับการแสดงภาพยนตร์ | 电影导演"
    },
    {
        "id":490,
        "name":"245522  :  Television Drama Director | ผู้กำกับการแสดงละครโทรทัศน์ | 电视剧导演"
    },
    {
        "id":491,
        "name":"245524  :  Stage Drama Director | ผู้กำกับการแสดงละครบนเวที | 舞台剧导演"
    },
    {
        "id":492,
        "name":"245530  :  Director Of Photography (Film) | ผู้กำกับภาพ (ภาพยนตร์) | 摄影指导（电影）"
    },
    {
        "id":493,
        "name":"245532  :  Director Of Photography (Television) | ผู้กำกับภาพ (โทรทัศน์) | 摄影指导（电视）"
    },
    {
        "id":494,
        "name":"245533  :  Sound Director (Film) | ผู้กำกับเสียง (ภาพยนตร์) | 声音总监（电影）"
    },
    {
        "id":495,
        "name":"245534  :  Sound Director (Television) | ผู้กำกับเสียง (โทรทัศน์) | 音响总监（电视）"
    },
    {
        "id":496,
        "name":"245535  :  Technical Director (Television) | ผู้กำกับเทคนิค (โทรทัศน์) | 技术总监（电视）"
    },
    {
        "id":497,
        "name":"245536  :  Lighting Director (Television) | ผู้กำกับแสง (โทรทัศน์) | 灯光总监（电视）"
    },
    {
        "id":498,
        "name":"245538  :  Still (Movie) Photographer | ผู้ถ่ายภาพนิ่ง (ภาพยนตร์) | 静态（电影）摄影师"
    },
    {
        "id":499,
        "name":"245540  :  Television Production Supervisor | ผู้ควบคุมการผลิตรายการโทรทัศน์ | 电视制作主管"
    },
    {
        "id":500,
        "name":"245541  :  Tv Presenter | ผู้จัดรายการโทรทัศน์ | 电视节目主持人"
    },
    {
        "id":501,
        "name":"245542  :  Television Program Operator | ผู้ควบคุมรายการโทรทัศน์ | 电视节目运营商"
    },
    {
        "id":502,
        "name":"245543  :  Television Director | ผู้กำกับรายการโทรทัศน์ | 电视导演"
    },
    {
        "id":503,
        "name":"245544  :  Television Drama Station Staff | เจ้าหน้าที่สถานีรายการละครโทรทัศน์ | 电视剧台工作人员"
    },
    {
        "id":504,
        "name":"245545  :  Radio Broadcasting Program Staff | เจ้าหน้าที่จัดผังรายการวิทยุกระจายเสียง | 广播节目工作人员"
    },
    {
        "id":505,
        "name":"245547  :  Television Information Officer | เจ้าหน้าที่ข้อมูลรายการโทรทัศน์ | 电视新闻官"
    },
    {
        "id":506,
        "name":"245548  :  Movie Program Information Officer | เจ้าหน้าที่ข้อมูลรายการภาพยนตร์ | 电影节目信息官"
    },
    {
        "id":507,
        "name":"245549  :  Program And News Coordinator | ผู้ประสานงานรายการและงานข่าว | 节目和新闻协调员"
    },
    {
        "id":508,
        "name":"245550  :  Art Director (Television And Film) | ผู้กำกับศิลปกรรม (โทรทัศน์และภาพยนตร์) | 艺术总监（电视和电影）"
    },
    {
        "id":509,
        "name":"245551  :  Television Drama Set And Arts Officer | เจ้าหน้าที่งานฉากและศิลปกรรมรายการละครโทรทัศน์ | 电视剧布景及艺术主任"
    },
    {
        "id":510,
        "name":"245552  :  Stage Director (Television) | ผู้กำกับเวที (โทรทัศน์) | 舞台导演（电视）"
    },
    {
        "id":511,
        "name":"245553  :  Stage Director (Stage Play) | ผู้กำกับเวที (ละครเวที) | 舞台导演（舞台剧）"
    },
    {
        "id":512,
        "name":"245555  :  Art Director (Advertising) | ผู้กำกับศิลป์ (งานโฆษณา) | 艺术总监（广告）"
    },
    {
        "id":513,
        "name":"245560  :  Television Creative Officer | เจ้าหน้าที่สร้างสรรค์รายการโทรทัศน์ | 电视创意官"
    },
    {
        "id":514,
        "name":"245565  :  Radio Broadcasting Creator | นักสร้างสรรค์รายการวิทยุกระจายเสียง | 广播创作者"
    },
    {
        "id":515,
        "name":"245570  :  Continuity Controller (Film) | ผู้ควบคุมความต่อเนื่อง (ภาพยนตร์) | 连续性控制器（薄膜）"
    },
    {
        "id":516,
        "name":"245580  :  Business Officers And Business Assistants On Television Drama Productions | เจ้าหน้าที่ธุรกิจและผู้ช่วยธุรกิจกองถ่ายรายการละครโทรทัศน์ | 电视剧制作业务主管、业务助理"
    },
    {
        "id":517,
        "name":"245585  :  Employees Oversee Clothing And Clothing. | พนักงานควบคุมดูแลเสื้อผ้าและเครื่องแต่งกาย | 员工负责监督服装和服装。"
    },
    {
        "id":518,
        "name":"245590  :  Other Actors And Directors | นักแสดงและผู้กำกับการแสดงอื่น ๆ | 其他演员和导演"
    },
    {
        "id":519,
        "name":"246010  :  Monks, Monks | พระสงฆ์ นักบวช | 和尚，和尚"
    },
    {
        "id":520,
        "name":"246020  :  Pastor | ศาสนาจารย์ | 牧师"
    },
    {
        "id":521,
        "name":"246025  :  Pastor | ศิษยาภิบาล | 牧师"
    },
    {
        "id":522,
        "name":"246030  :  Evangelist: Mission, Missionary | ผู้ประกาศศาสนา : มิชชัน มิชชันนารี | Evangelist：传教士，传教士"
    },
    {
        "id":523,
        "name":"246090  :  Clergy And Other Related Workers | นักบวชและผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 神职人员及其他相关工作人员"
    },
    {
        "id":524,
        "name":"311110  :  Chemical Technician, Technician (Organic Chemistry, Rubber, Plastic, Polymer, Paint, Paper, Oil, Fiber, Food And Beverage) | ช่างเทคนิคเคมี , ช่างเทคนิค (อินทรีย์เคมี , ยาง , พลาสติก , พอลิเมอร์, สี, กระดาษ, น้ำมัน, เส้นใย, อาหารและเครื่องดื่ม) | 化学技师、技师（有机化学、橡胶、塑料、聚合物、油漆、造纸、石油、纤维、食品饮料）"
    },
    {
        "id":525,
        "name":"311120  :  Physics Technician | ช่างเทคนิคทางฟิสิกส์ | 物理技术员"
    },
    {
        "id":526,
        "name":"311125  :  Nuclear Technical Officer | เจ้าหน้าที่เทคนิคนิวเคลียร์ | 核技术官员"
    },
    {
        "id":527,
        "name":"311130  :  Meteorological Technician, Meteorological Technician | เจ้าหน้าที่เทคนิคอุตุนิยมวิทยา , ช่างเทคนิคอุตุนิยมวิทยา | 气象技术员、气象技术员"
    },
    {
        "id":528,
        "name":"311140  :  Geological Technician | เจ้าหน้าที่เทคนิคทางธรณีวิทยา | 地质技术员"
    },
    {
        "id":529,
        "name":"311190  :  Other Physical And Chemical Science Technicians | เจ้าหน้าที่เทคนิควิทยาศาสตร์กายภาพและเคมีอื่น ๆ | 其他理化科学技术人员"
    },
    {
        "id":530,
        "name":"311210  :  Civil Engineering Technician | ช่างเทคนิควิศวกรรมโยธา | 土木工程技术员"
    },
    {
        "id":531,
        "name":"311220  :  Civil Engineering Technician (Construction) | ช่างเทคนิควิศวกรรมโยธา (ก่อสร้าง) | 土木工程技术员（建筑）"
    },
    {
        "id":532,
        "name":"311290  :  Other Civil Engineering Technicians | ช่างเทคนิควิศวกรรมโยธาอื่น ๆ | 其他土木工程技术人员"
    },
    {
        "id":533,
        "name":"311310  :  Electrical Engineering Technician | ช่างเทคนิควิศวกรรมไฟฟ้า | 电气工程技术员"
    },
    {
        "id":534,
        "name":"311320  :  Electrical Engineering Technician (Electric Power Transmission Line) | ช่างเทคนิควิศวกรรมไฟฟ้า (สายส่งไฟฟ้ากำลัง) | 电气工程技术员（电力传输线）"
    },
    {
        "id":535,
        "name":"311330  :  Electrical Engineering Technician, Instrumentation And Control | ช่างเทคนิควิศวกรรมไฟฟ้าเครื่องวัดและควบคุม | 电气工程技术员，仪表与控制"
    },
    {
        "id":536,
        "name":"311390  :  Other Electrical Engineering Technicians | ช่างเทคนิควิศวกรรมไฟฟ้าอื่น ๆ | 其他电气工程技术人员"
    },
    {
        "id":537,
        "name":"311410  :  Electronic Engineering Technician | ช่างเทคนิควิศวกรรมอิเล็กทรอนิกส์ | 电子工程技术员"
    },
    {
        "id":538,
        "name":"311420  :  Telecommunications Engineering Technician | ช่างเทคนิควิศวกรรมโทรคมนาคม | 电信工程技术员"
    },
    {
        "id":539,
        "name":"311430  :  Computer Engineering Technician | ช่างเทคนิควิศวกรรมคอมพิวเตอร์ | 计算机工程技术员"
    },
    {
        "id":540,
        "name":"311490  :  Other Electronics And Telecommunications Engineering Technicians | ช่างเทคนิควิศวกรรมอิเล็กทรอนิกส์และโทรคมนาคมอื่น ๆ | 其他电子和电信工程技术人员"
    },
    {
        "id":541,
        "name":"311510  :  Mechanical Engineering Technicians, Technician Operators, Or Other Production-Related Employees | ช่างเทคนิควิศวกรรมเครื่องกล,ผู้ควบคุมช่างหรือพนักงานอื่นๆที่เกี่ยวกับการผลิต | 机械工程技术人员、技术操作人员或其他与生产相关的员工"
    },
    {
        "id":542,
        "name":"311520  :  Engineering Technicians, Engines, Machinery And Equipment | ช่างเทคนิควิศวกรรม เครื่องยนต์ เครื่องจักรและอุปกรณ์ | 工程技术人员、发动机、机械设备"
    },
    {
        "id":543,
        "name":"311530  :  Shipbuilding Engineering Technician | ช่างเทคนิควิศวกรรมการต่อเรือ | 造船工程技术员"
    },
    {
        "id":544,
        "name":"311540  :  Nuclear Energy Engineering Technician | ช่างเทคนิควิศวกรรมพลังงานนิวเคลียร์ | 核能工程技术员"
    },
    {
        "id":545,
        "name":"311550  :  Aircraft Engineering Technician | ช่างเทคนิควิศวกรรมอากาศยาน | 飞机工程技术员"
    },
    {
        "id":546,
        "name":"311560  :  Mechatronics Technician | ช่างเทคนิคแมคคาทรอนิกส์ | 机电一体化技术员"
    },
    {
        "id":547,
        "name":"311570  :  Casting Technician | ช่างเทคนิคการหล่อ | 铸造技术员"
    },
    {
        "id":548,
        "name":"311580  :  Air Conditioning Engineering Technician | ช่างเทคนิควิศวกรรมระบบปรับอากาศ | 空调工程技术员"
    },
    {
        "id":549,
        "name":"311585  :  Refrigeration Engineering Technician | ช่างเทคนิควิศวกรรมระบบทำความเย็น | 制冷工程技术员"
    },
    {
        "id":550,
        "name":"311590  :  Other Mechanical Engineering Technicians | ช่างเทคนิควิศวกรรมเครื่องกลอื่น ๆ | 其他机械工程技术人员"
    },
    {
        "id":551,
        "name":"311610  :  Chemical Engineering Technician | ช่างเทคนิควิศวกรรมเคมี | 化学工程技术员"
    },
    {
        "id":552,
        "name":"311615  :  Chemical Engineering Technician (Petroleum And Gas) | ช่างเทคนิควิศวกรรมเคมี (ปิโตรเลียมและก๊าซ) | 化学工程技术员（石油和天然气）"
    },
    {
        "id":553,
        "name":"311690  :  Other Chemical Engineering Technicians | ช่างเทคนิควิศวกรรมเคมีอื่น ๆ | 其他化学工程技术人员"
    },
    {
        "id":554,
        "name":"311710  :  General Mining Technician, Technician | เจ้าหน้าที่เทคนิคเหมืองแร่ทั่วไป, ช่างเทคนิค | 普通采矿技术员、技术员"
    },
    {
        "id":555,
        "name":"311720  :  Petroleum And Natural Gas Mining Engineering Technician: Technician | เจ้าหน้าที่เทคนิควิศวกรรมเหมืองแร่ปิโตรเลียมและก๊าซธรรมชาติ :ช่างเทคนิค | 石油天然气开采工程技术员：技术员"
    },
    {
        "id":556,
        "name":"311730  :  Metal Engineering Technician, Technician | เจ้าหน้าที่เทคนิควิศวกรรมโลหะ , ช่างเทคนิค | 金属工程技术员、技术员"
    },
    {
        "id":557,
        "name":"311740  :  Metallurgical Technician (Smelting, Separating And Melting Metal), Metallurgical Technician | เจ้าหน้าที่เทคนิคโลหกรรม (ถลุง แยกและหลอมโลหะ) , ช่างเทคนิคโลหะกรรม | 冶金技术员（熔炼、分离和熔化金属）、冶金技术员"
    },
    {
        "id":558,
        "name":"311790  :  Other Mining And Metallurgy Technicians | ช่างเทคนิคเหมืองแร่และโลหะวิทยาอื่น ๆ | 其他采矿、冶金技术人员"
    },
    {
        "id":559,
        "name":"311810  :  General Draftsman | ช่างเขียนแบบทั่วไป | 总绘图员"
    },
    {
        "id":560,
        "name":"311815  :  Architectural Draftsman | ช่างเขียนแบบสถาปัตยกรรม | 建筑绘图员"
    },
    {
        "id":561,
        "name":"311820  :  Structural Draftsman, Civil Engineering | ช่างเขียนแบบโครงสร้าง , งานวิศวกรรมโยธา | 结构绘图员、土木工程"
    },
    {
        "id":562,
        "name":"311830  :  Mechanical Draftsman | ช่างเขียนแบบงานเครื่องกล | 机械制图员"
    },
    {
        "id":563,
        "name":"311835  :  Cartographer | ช่างเขียนแผนที่ | 制图师"
    },
    {
        "id":564,
        "name":"311840  :  Electrical Draftsman | ช่างเขียนแบบงานไฟฟ้า | 电气制图员"
    },
    {
        "id":565,
        "name":"311850  :  Ship Draftsman | ช่างเขียนแบบเรือ | 船舶绘图员"
    },
    {
        "id":566,
        "name":"311890  :  Other Draftsmen | ช่างเขียนแบบอื่น ๆ | 其他制图员"
    },
    {
        "id":567,
        "name":"311920  :  Performance Control Technician (Manufacturing Industry, Textiles, Glass, Paper, Ceramics, Cement, Wood, Leather) | ช่างเทคนิคควบคุมประสิทธิภาพ (อุตสาหกรรมการผลิต, สิ่งทอ, แก้ว, กระดาษ , เซรามิค, ซีเมนต์, ไม้, หนังสัตว์) | 性能控制技术员（制造业、纺织、玻璃、造纸、陶瓷、水泥、木材、皮革）"
    },
    {
        "id":568,
        "name":"311930  :  Systems Engineering Technician (Except Computers) | ช่างเทคนิควิศวกรรมระบบ (ยกเว้นคอมพิวเตอร์) | 系统工程技术员（电脑除外）"
    },
    {
        "id":569,
        "name":"311940  :  Production Engineering Technician (Planning) | ช่างเทคนิควิศวกรรมการผลิต (การวางแผน) | 生产工程技术员（策划）"
    },
    {
        "id":570,
        "name":"311950  :  Safety Engineering Technician (Systems) | ช่างเทคนิควิศวกรรม (ระบบ) ความปลอดภัย | 安全工程技术员（系统）"
    },
    {
        "id":571,
        "name":"311960  :  Surveying Technician (Quantity) | ช่างเทคนิคการสำรวจ (ปริมาณ) | 测量技术员（数量）"
    },
    {
        "id":572,
        "name":"311970  :  Estimator (Engineering) | ผู้ประมาณการ (งานวิศวกรรม) | 估算师（工程）"
    },
    {
        "id":573,
        "name":"311990  :  Physical Science And Engineering Technicians Not Classified Elsewhere | ช่างเทคนิควิทยาศาสตร์กายภาพและวิศวกรรมศาสตร์ที่มีมิได้จัดประเภทไว้ในที่อื่น ๆ | 未分类的物理科学和工程技术人员"
    },
    {
        "id":574,
        "name":"312120  :  Computer Assistant | ผู้ช่วยงานด้านคอมพิวเตอร์ | 电脑助理"
    },
    {
        "id":575,
        "name":"312130  :  It Salesperson (It Service Representative) | พนักงานขายด้านไอที (ตัวแทนบริการไอที) | It销售员（It服务代表）"
    },
    {
        "id":576,
        "name":"312210  :  Computer System Technician | ช่างเทคนิคระบบคอมพิวเตอร์ | 计算机系统技术员"
    },
    {
        "id":577,
        "name":"312220  :  Computer System Worker (Computer Operator, Data Processing Service Officer) | ผู้ปฏิบัติงานด้านระบบคอมพิวเตอร์ (เจ้าหน้าที่ควบคุมคอมพิวเตอร์ , เจ้าหน้าที่บริการประมวลผลข้อมูล) | 计算机系统工作者(计算机操作员、数据处理服务官)"
    },
    {
        "id":578,
        "name":"312320  :  Robot Operator | ผู้ควบคุมหุ่นยนต์ | 机器人操作员"
    },
    {
        "id":579,
        "name":"313110  :  Portrait Photographer | ช่างถ่ายภาพบุคคล | 肖像摄影师"
    },
    {
        "id":580,
        "name":"313112  :  Advertising Photographer | ช่างภาพโฆษณา | 广告摄影师"
    },
    {
        "id":581,
        "name":"313114  :  Newspaper Photographer | ช่างภาพหนังสือพิมพ์ | 报纸摄影师"
    },
    {
        "id":582,
        "name":"313116  :  Documentary Photographer | ช่างภาพสารคดี | 纪实摄影师"
    },
    {
        "id":583,
        "name":"313118  :  Photographer For Public Relations | ช่างภาพเพื่อการประชาสัมพันธ์ | 公共关系摄影师"
    },
    {
        "id":584,
        "name":"313120  :  Television Cameraman | ช่างภาพประจำกล้องโทรทัศน์ | 电视摄影师"
    },
    {
        "id":585,
        "name":"313125  :  Cinematographer, Cameraman | ช่างถ่ายภาพยนตร์, ช่างกล้อง | 电影摄影师、摄影师"
    },
    {
        "id":586,
        "name":"313130  :  Television Direction Technician | ช่างเทคนิคงานกำกับภาพรายการโทรทัศน์ | 电视导演技术员"
    },
    {
        "id":587,
        "name":"313135  :  Television Editor | เจ้าหน้าที่ตัดต่อรายการโทรทัศน์ | 电视编辑"
    },
    {
        "id":588,
        "name":"313137  :  Television Graphics Officer | เจ้าหน้าที่กราฟฟิกรายการโทรทัศน์ | 电视制图官员"
    },
    {
        "id":589,
        "name":"313140  :  Image Recording Technician | ช่างเทคนิคบันทึกภาพ | 影像记录技术员"
    },
    {
        "id":590,
        "name":"313145  :  Film Sequence Editor | ผู้ตัดต่อลำดับภาพยนตร์ | 电影序列编辑器"
    },
    {
        "id":591,
        "name":"313150  :  Technician, Camera Assistant | ช่างเทคนิค , ผู้ช่วยกล้อง | 技术员、摄像助理"
    },
    {
        "id":592,
        "name":"313160  :  Sound Technicians, Sound Recorders, Sound Recorders And Make Copies Of Television Drama Tapes | ช่างเทคนิคงานเสียง , ผู้บันทึกเสียง , เจ้าหน้าที่บันทึกเสียงและ ทำสำเนาเทปละครโทรทัศน์ | 音响技术人员、录音师、录音师和复制电视剧磁带"
    },
    {
        "id":593,
        "name":"313170  :  Technical And Maintenance Staff On Television Drama Filming Sets | เจ้าหน้าที่เทคนิคและซ่อมบำรุงประจำกองถ่ายรายการละคร โทรทัศน์ | 电视剧拍摄场技术及维护人员"
    },
    {
        "id":594,
        "name":"313190  :  Photographers And Other Audio-Visual Recording Equipment Personnel | ช่างภาพและเจ้าหน้าที่อุปกรณ์บันทึกภาพและเสียงอื่น ๆ | 摄影师及其他视听记录设备人员"
    },
    {
        "id":595,
        "name":"313220  :  Radio Station Staff; Radio Broadcasting Controller | พนักงานประจำสถานีวิทยุกระจายเสียง ; ผู้ควบคุมการออกอากาศรายการวิทยุกระจายเสียง | 广播电台工作人员；无线电广播控制器"
    },
    {
        "id":596,
        "name":"313225  :  Technical Officer At Radio Broadcasting Station | เจ้าหน้าที่เทคนิคประจำสถานีวิทยุกระจายเสียง | 广播电台技术员"
    },
    {
        "id":597,
        "name":"313230  :  Experts Install Movie Projectors And Customize Sound Systems. | ผู้เชี่ยวชาญติดตั้งเครื่องฉายภาพยนตร์และปรับแต่งระบบเสียง | 专家安装电影放映机并定制音响系统。"
    },
    {
        "id":598,
        "name":"313235  :  Movie Projector | ผู้ฉายภาพยนตร์ | 电影放映机"
    },
    {
        "id":599,
        "name":"313240  :  Television Station Employee; Television Broadcasting Technical Officer | พนักงานประจำสถานีโทรทัศน์ ; เจ้าหน้าที่เทคนิคงานแพร่ภาพสถานีโทรทัศน์ | 电视台工作人员；电视广播技术官员"
    },
    {
        "id":600,
        "name":"313250  :  Microwave Technician | ช่างเทคนิคงานไมโครเวฟ | 微波技术员"
    },
    {
        "id":601,
        "name":"313255  :  Satellite And Transmitter Technician | ช่างเทคนิคด้านดาวเทียมและเครื่องส่ง | 卫星和发射机技术员"
    },
    {
        "id":602,
        "name":"313260  :  Signal Controller | ผู้ควบคุมสัญญาณ | 信号控制器"
    },
    {
        "id":603,
        "name":"313270  :  Ship'S Radio Operator; Ship'S Communications Officer | พนักงานวิทยุประจำเรือ ; พนักงานสื่อสารประจำเรือ | 船上无线电操作员；船舶通讯官"
    },
    {
        "id":604,
        "name":"313290  :  Broadcasting And Other Telecommunications Equipment Staff | เจ้าหน้าที่อุปกรณ์แพร่ภาพกระจายเสียงและโทรคมนาคมอื่น ๆ | 广播及其他电讯设备人员"
    },
    {
        "id":605,
        "name":"313320  :  Operator Of Ecg Measurement Equipment | เจ้าหน้าที่ควบคุมอุปกรณ์การวัดคลื่นไฟฟ้าหัวใจ | 心电图测量设备操作员"
    },
    {
        "id":606,
        "name":"313330  :  X-Ray Equipment Operator (Medical) | เจ้าหน้าที่ควบคุมอุปกรณ์เอ็กซเรย์ (ทางการแพทย์) | X射线设备操作员（医疗的）"
    },
    {
        "id":607,
        "name":"313340  :  Scanning Equipment Operator | เจ้าหน้าที่ควบคุมอุปกรณ์สแกนนิ่ง | 扫描设备操作员"
    },
    {
        "id":608,
        "name":"313350  :  Radiologic Technologist, Medical Radiology Officer | นักรังสีเทคนิค, เจ้าหน้าที่รังสีการแพทย์ | 放射技师、医学放射科主任"
    },
    {
        "id":609,
        "name":"313390  :  Other Medical Equipment Controllers | เจ้าหน้าควบคุมอุปกรณ์การแพทย์อื่น ๆ | 其他医疗设备控制器"
    },
    {
        "id":610,
        "name":"313920  :  Optical And Electronic Equipment Personnel Not Classified Elsewhere | เจ้าหน้าที่อุปกรณ์ด้านทัศนศาสตร์ (ออฟจิตัล) และอิเล็กทรอนิกส์ที่มิได้จัดประเภทไว้ในที่อื่น | 未分类的光学和电子设备人员"
    },
    {
        "id":611,
        "name":"314120  :  Engineering Master (Ship)\/Technical Supervisor | นายช่างใหญ่ทางวิศวกรรม (เรือ)\/ผู้ควบคุมงานฝ่ายช่าง | 工程硕士(船舶)\/技术主管"
    },
    {
        "id":612,
        "name":"314130  :  Tonkol | ต้นกล | 通科尔"
    },
    {
        "id":613,
        "name":"314132  :  Deputy Tonkon | รองต้นกล | 副手孔"
    },
    {
        "id":614,
        "name":"314134  :  Mr. Mechanic | นายช่างกล | 机械师先生"
    },
    {
        "id":615,
        "name":"314136  :  Ship'S Mechanical Engineer | นายช่างประจำเรือฝ่ายช่างกล | 船舶机械工程师"
    },
    {
        "id":616,
        "name":"314190  :  Ship Technician Or Mechanic | ช่างเทคนิคหรือช่างเครื่องประจำเรือ | 船舶技术员或机械师"
    },
    {
        "id":617,
        "name":"314220  :  Ship Commander\/Navigator | ผู้บังคับการเรือ\/นายเรือเดินทะเล | 舰长\/领航员"
    },
    {
        "id":618,
        "name":"314230  :  Ship'S Master\/Ship Operator | นายเรือ\/ผู้ควบคุมเรือ | 船长\/船舶操作员"
    },
    {
        "id":619,
        "name":"314240  :  Ship Tree | ต้นเรือ | 船树"
    },
    {
        "id":620,
        "name":"314245  :  Ship'S Navigator | นายประจำเรือฝ่ายเดินเรือ | 船舶导航员"
    },
    {
        "id":621,
        "name":"314250  :  Pilot\/Pilot Officer | ผู้นำร่อง\/เจ้าพนักงานนำร่อง | 飞行员\/飞行员"
    },
    {
        "id":622,
        "name":"314260  :  Captain (Fishing Boat) | ไต้ก๋ง (เรือประมง) | 船长（渔船）"
    },
    {
        "id":623,
        "name":"314270  :  Ship'S Electrician | ช่างไฟประจำเรือ | 船舶电工"
    },
    {
        "id":624,
        "name":"314275  :  Ship Engine Room Employee | พนักงานห้องเครื่องเรือ | 船舶机舱员工"
    },
    {
        "id":625,
        "name":"314290  :  Shipmasters And Other Pilots | นายเรือและผู้นำร่องอื่นๆ | 船长和其他飞行员"
    },
    {
        "id":626,
        "name":"314310  :  Pilot | นักบิน | 飞行员"
    },
    {
        "id":627,
        "name":"314320  :  Specialized Pilot | นักบินเฉพาะงาน | 专业飞行员"
    },
    {
        "id":628,
        "name":"314330  :  Aircraft Navigator | ต้นหนประจำอากาศยาน | 飞机导航仪"
    },
    {
        "id":629,
        "name":"314340  :  Aircraft Mechanic | นายช่างประจำอากาศยาน | 飞机机械师"
    },
    {
        "id":630,
        "name":"314420  :  Air Traffic Controller | ผู้ควบคุมการจราจรทางอากาศ | 空中交通管制员"
    },
    {
        "id":631,
        "name":"314520  :  Air Traffic Safety Technician | ช่างเทคนิคความปลอดภัยด้านการจราจรทางอากาศ | 空中交通安全技术员"
    },
    {
        "id":632,
        "name":"315120  :  Building Inspector | ผู้ตรวจสอบอาคารสิ่งก่อสร้าง | 建筑检查员"
    },
    {
        "id":633,
        "name":"315130  :  Fire Inspector | ผู้ตรวจสอบอัคคีภัย | 消防督察"
    },
    {
        "id":634,
        "name":"315210  :  Safety And Hygiene Inspectors (Pollution, Environment, Waste Disposal In Factories | ผู้ตรวจสอบด้านความปลอดภัยและสุขอนามัย (ด้านมลภาวะ , สิ่งแวดล้อม , การกำจัดของเสียในโรงงาน | 安全卫生检查员（工厂污染、环境、废物处理"
    },
    {
        "id":635,
        "name":"315220  :  Work Safety Inspector, Safety Officer | ผู้ตรวจสอบความปลอดภัยในการทำงาน , เจ้าหน้าที่ความปลอดภัย | 安全生产监察员、安全员"
    },
    {
        "id":636,
        "name":"315225  :  Weather Inspector | เจ้าหน้าที่ตรวจสภาพอากาศยาน | 气象督察"
    },
    {
        "id":637,
        "name":"315227  :  Aircraft Inspector; Mechanic Inspector | นายตรวจอากาศยาน ; สารวัตรช่าง | 飞机检查员；机械检验员"
    },
    {
        "id":638,
        "name":"315230  :  Product Quality Inspector (Electrical, Electronic, Mechanical) | ผู้ตรวจสอบคุณภาพผลิตภัณฑ์สินค้า (ไฟฟ้า , อิเล็กทรอนิกส์,เครื่องกล) | 产品质量检验员（电气、电子、机械）"
    },
    {
        "id":639,
        "name":"315240  :  Product Quality Inspectors (Fibers, Clothing, And Other Products) | ผู้ตรวจสอบคุณภาพผลิตภัณฑ์สินค้า (เส้นใย , เสื้อผ้าและผลิตภัณฑ์อื่น ๆ) | 产品质量检验员（纤维、服装等产品）"
    },
    {
        "id":640,
        "name":"315245  :  Fiber Inspection Staff Knitted Fabric | พนักงานตรวจสอบเส้นใย สิ่งทอสิ่งถัก | 纤维检验人员针织面料"
    },
    {
        "id":641,
        "name":"315247  :  Canvas Inspector | พนักงานตรวจผืนผ้า | 画布检查员"
    },
    {
        "id":642,
        "name":"315250  :  Wood Product Quality Inspector | ผู้ตรวจสอบคุณภาพผลิตภัณฑ์ไม้ | 木制品质量检验员"
    },
    {
        "id":643,
        "name":"315260  :  Quality Controller Of Raw Materials And Food Products | ผู้ควบคุมคุณภาพวัตถุดิบและผลิตภัณฑ์อาหาร | 原材料和食品质量控制员"
    },
    {
        "id":644,
        "name":"315270  :  Quality Inspector (Service) | ผู้ตรวจสอบคุณภาพ (ด้านบริการ) | 质检员（服务）"
    },
    {
        "id":645,
        "name":"315290  :  Safety, Health, And Other Product Quality Inspectors | ผู้ตรวจสอบด้านความปลอดภัย สุขภาพ และคุณภาพผลิตภัณฑ์อื่น ๆ | 安全、卫生等产品质量检验员"
    },
    {
        "id":646,
        "name":"321120  :  Biology Technician | เจ้าหน้าที่เทคนิคด้านชีววิทยา | 生物技术员"
    },
    {
        "id":647,
        "name":"321190  :  Other Life Sciences Technicians | เจ้าหน้าที่เทคนิคด้านวิทยาศาสตร์ชีวภาพอื่นๆ | 其他生命科学技术人员"
    },
    {
        "id":648,
        "name":"321220  :  Agricultural Technical Officer | เจ้าหน้าที่เทคนิคด้านเกษตรกรรม | 农业技术官员"
    },
    {
        "id":649,
        "name":"321230  :  Forestry Technical Officer | เจ้าหน้าที่เทคนิคด้านการป่าไม้ | 林业技术官员"
    },
    {
        "id":650,
        "name":"321240  :  Agronomy Technical Officer | เจ้าหน้าที่เทคนิคด้านปฐพีวิทยา | 农艺技术官员"
    },
    {
        "id":651,
        "name":"321320  :  Advisor And Expert In Agriculture | ที่ปรึกษาและผู้ชำนาญการด้านเกษตรกรรม | 农业顾问和专家"
    },
    {
        "id":652,
        "name":"321330  :  Consultant And Expert In Forestry | ที่ปรึกษาและผู้ชำนาญการด้านป่าไม้ | 林业顾问和专家"
    },
    {
        "id":653,
        "name":"321340  :  Agricultural Demonstration Officer | เจ้าหน้าที่สาธิตด้านการเกษตร | 农业示范员"
    },
    {
        "id":654,
        "name":"322120  :  Medical Assistant | ผู้ช่วยแพทย์ | 医疗助理"
    },
    {
        "id":655,
        "name":"322220  :  Occupational Health Specialist | นักอาชีวอนามัย | 职业健康专家"
    },
    {
        "id":656,
        "name":"322230  :  Hygiene Expert | ผู้เชี่ยวชาญด้านสุขอนามัย | 卫生专家"
    },
    {
        "id":657,
        "name":"322240  :  Public Health Professional, Public Health Expert | นักสาธารณสุข , ผู้เชี่ยวชาญด้านสาธารณสุข | 公共卫生专业人员、公共卫生专家"
    },
    {
        "id":658,
        "name":"322250  :  Health Educator | นักสุขศึกษา | 健康教育者"
    },
    {
        "id":659,
        "name":"322290  :  Other Hygiene Professionals | ผู้เชี่ยวชาญด้านสุขอนามัยอื่น ๆ | 其他卫生专业人员"
    },
    {
        "id":660,
        "name":"322320  :  Dietary Consultant, Nutrition Expert, Nutritionist | ที่ปรึกษาด้านการควบคุมอาหาร , ผู้เชี่ยวชาญด้านโภชนาการ , นักโภชนาการ | 膳食顾问、营养专家、营养师"
    },
    {
        "id":661,
        "name":"322330  :  Dietitian | นักกำหนดอาหาร | 营养师"
    },
    {
        "id":662,
        "name":"322390  :  Nutrition Expert And Other Nutritionists | ผู้เชี่ยวชาญด้านโภชนาการ และนักโภชนาการอื่น ๆ | 营养专家和其他营养师"
    },
    {
        "id":663,
        "name":"322410  :  Eye Examination Specialist, Optometrist | ผู้เชี่ยวชาญการตรวจวัดสายตา , ผู้ตรวจวัดสายตา | 眼科检查专家、验光师"
    },
    {
        "id":664,
        "name":"322420  :  Tailor And Assembler Of Glasses Or Vision Aids, Eyeglass Maker | ช่างตัดและประกอบแว่นหรืออุปกรณ์ช่วยสายตา , ช่างทำแว่น | 眼镜或助视器的裁缝和组装工、眼镜制造商"
    },
    {
        "id":665,
        "name":"322490  :  Opticians, Opticians And Other Opticians | ผู้วัดสายตาประกอบแว่นและช่างทำแว่นอื่น ๆ | 配镜师、配镜师和其他配镜师"
    },
    {
        "id":666,
        "name":"322520  :  Dental Assistant, Dental Staff | ผู้ช่วยด้านทันตกรรม , เจ้าหน้าที่ทันตกรรม | 牙科助理、牙科工作人员"
    },
    {
        "id":667,
        "name":"322590  :  Other Dental Assistants | ผู้ช่วยด้านทันตกรรมอื่น ๆ | 其他牙科助理"
    },
    {
        "id":668,
        "name":"322620  :  Physical Therapist | นักกายภาพบำบัด | 物理治疗师"
    },
    {
        "id":669,
        "name":"322690  :  Other Physical Therapists | นักกายภาพบำบัดอื่น ๆ | 其他物理治疗师"
    },
    {
        "id":670,
        "name":"322720  :  Veterinary Assistant | ผู้ช่วยสัตวแพทย์ | 兽医助理"
    },
    {
        "id":671,
        "name":"322730  :  Artificial Insemination Officer | เจ้าหน้าที่ผสมเทียม | 人工授精官员"
    },
    {
        "id":672,
        "name":"322740  :  Veterinary Technician | นักเทคนิคการสัตวแพทย์ | 兽医技术员"
    },
    {
        "id":673,
        "name":"322790  :  Other Veterinary Assistants | ผู้ช่วยสัตวแพทย์อื่น ๆ | 其他兽医助理"
    },
    {
        "id":674,
        "name":"322820  :  Pharmacy Assistant | ผู้ช่วยด้านเภสัชกรกรรม | 药房助理"
    },
    {
        "id":675,
        "name":"322920  :  Occupational Therapist | นักอาชีวบำบัด | 职业治疗师"
    },
    {
        "id":676,
        "name":"322930  :  Occupational Therapist | นักกิจกรรมบำบัด | 职业治疗师"
    },
    {
        "id":677,
        "name":"322940  :  Specialist In Correcting Speech And Pronunciation Defects | ผู้เชี่ยวชาญด้านการแก้ไขข้อบกพร่องในการพูดและออกเสียง | 纠正言语和发音缺陷的专家"
    },
    {
        "id":678,
        "name":"322990  :  Other Occupational Therapy Specialists | ผู้เชี่ยวชาญด้านอาชีวบำบัดอื่น ๆ | 其他职业治疗专家"
    },
    {
        "id":679,
        "name":"323120  :  Nursing Assistant | ผู้ช่วยพยาบาล | 护理助理"
    },
    {
        "id":680,
        "name":"323190  :  Other Nursing Assistants | ผู้ช่วยพยาบาลอื่น ๆ | 其他护理助理"
    },
    {
        "id":681,
        "name":"323220  :  Midwife Assistant | ผู้ช่วยผดุงครรภ์ | 助产士助理"
    },
    {
        "id":682,
        "name":"323290  :  Other Midwifery Assistants | ผู้ช่วยผดุงครรภ์อื่น ๆ | 其他助产士"
    },
    {
        "id":683,
        "name":"324120  :  Traditional Medicine | แพทย์แผนโบราณ | 传统医学"
    },
    {
        "id":684,
        "name":"324130  :  Traditional Masseuse | หมอนวดแผนโบราณ | 传统按摩师"
    },
    {
        "id":685,
        "name":"324190  :  Other Traditional Medicine Professionals | ผู้ประกอบอาชีพแพทย์แผนโบราณอื่นๆ | 其他传统医学专业人员"
    },
    {
        "id":686,
        "name":"324220  :  A Person Who Cures Disease Using Psychic Powers, Beliefs, Faith. | ผู้รักษาโรคโดยใช้พลังจิต, ความเชื่อ , ความศรัทธา | 使用心灵力量、信仰、信仰来治愈疾病的人。"
    },
    {
        "id":687,
        "name":"324290  :  Healers Based On Other Faiths | ผู้รักษาโรคโดยอาศัยความศรัทธาอื่น ๆ | 基于其他信仰的治疗师"
    },
    {
        "id":688,
        "name":"331020  :  Primary Teacher (Certificate) | ครูประถม (ประกาศนียบัตร) | 小学教师（证书）"
    },
    {
        "id":689,
        "name":"332020  :  Kindergarten Teacher (Certificate), Assistant Teacher | ครูอนุบาล (ประกาศนียบัตร) ,ครูผู้ช่วย | 幼儿园教师（证书）、助理教师"
    },
    {
        "id":690,
        "name":"333020  :  Assistant Teacher (Special Education) | ครูผู้ช่วย (การศึกษาพิเศษ) | 助理教师（特殊教育）"
    },
    {
        "id":691,
        "name":"333030  :  Teacher For The Mentally Disabled, Assistant Teacher | ครูสอนคนพิการทางจิต , ครูผู้ช่วย | 智障教师、助理教师"
    },
    {
        "id":692,
        "name":"333040  :  Specialized Teachers For Disabled People | ครูสอนคนพิการเฉพาะทาง | 残疾人专业教师"
    },
    {
        "id":693,
        "name":"334020  :  Flight Instructor | ครูการบิน | 飞行教练"
    },
    {
        "id":694,
        "name":"334030  :  Driving Instructor | ครูสอนขับรถยนต์ | 驾驶教练"
    },
    {
        "id":695,
        "name":"334040  :  Boat Driving Instructor, Sailing Instructor | ครูสอนการขับเรือ, ครูสอนแล่นเรือใบ | 船舶驾驶教练、帆船教练"
    },
    {
        "id":696,
        "name":"334090  :  Practitioners Involved In Teaching In Other Areas | ผู้ปฏิบัติงานที่เกี่ยวข้องกับการสอนในด้านอื่น ๆ | 参与其他领域教学的从业者"
    },
    {
        "id":697,
        "name":"341120  :  Marketing Officer (Securities) | เจ้าหน้าที่การตลาด (หลักทรัพย์) | 市场主任（证券）"
    },
    {
        "id":698,
        "name":"341130  :  Securities Trading Operations Officer | เจ้าหน้าที่ปฏิบัติการซื้อขายหลักทรัพย์ | 证券交易业务主管"
    },
    {
        "id":699,
        "name":"341140  :  Investment Advisor, Investment Advisor, Financial Advisor | ผู้ให้คำแนะนำการลงทุน , ที่ปรึกษาการลงทุน , ที่ปรึกษาการเงิน | 投资顾问、投资顾问、财务顾问"
    },
    {
        "id":700,
        "name":"341220  :  Insurance Agent, Insurance Broker | ตัวแทนประกันภัย , นายหน้าประกันภัย | 保险代理人，保险经纪人"
    },
    {
        "id":701,
        "name":"341230  :  Guarantor | ผู้รับประกัน | 担保人"
    },
    {
        "id":702,
        "name":"341320  :  Real Estate Broker, Real Estate Agent | นายหน้าซื้อขายอสังหาริมทรัพย์ , ตัวแทนซื้อขายอสังหาริมทรัพย์ | 房地产经纪人、房地产经纪人"
    },
    {
        "id":703,
        "name":"341420  :  Travel Program Organizer | ผู้จัดรายการท่องเที่ยว | 旅行计划组织者"
    },
    {
        "id":704,
        "name":"341430  :  Travel Advice Consultant | ผู้ให้คำปรึกษาแนะนำการท่องเที่ยว | 旅游咨询顾问"
    },
    {
        "id":705,
        "name":"341520  :  Product Sales Representative | ตัวแทนขายผลิตภัณฑ์ | 产品销售代表"
    },
    {
        "id":706,
        "name":"341525  :  Customer Service Staff | พนักงานบริการลูกค้า | 客户服务人员"
    },
    {
        "id":707,
        "name":"341530  :  Technical Salesperson | พนักงานขายด้านเทคนิค | 技术销售员"
    },
    {
        "id":708,
        "name":"341540  :  Provider Of Advice And After-Sales Service | ผู้ให้คำแนะนำและบริการหลังการขาย | 咨询和售后服务提供商"
    },
    {
        "id":709,
        "name":"341550  :  Market Employee | พนักงานเดินตลาด | 市场员工"
    },
    {
        "id":710,
        "name":"341610  :  General Purchaser | ผู้จัดซื้อทั่วไป | 一般采购员"
    },
    {
        "id":711,
        "name":"341620  :  Purchasing Agent | ตัวแทนจัดซื้อ | 采购代理"
    },
    {
        "id":712,
        "name":"341720  :  Appraisal Staff, Appraisal Staff | พนักงานประเมินราคา , พนักงานตีราคา | 评估人员、评估人员"
    },
    {
        "id":713,
        "name":"341730  :  Auction Salesperson | พนักงานขายทอดตลาด | 拍卖业务员"
    },
    {
        "id":714,
        "name":"341740  :  Accident Investigator | พนักงานตรวจสอบอุบัติเหตุ | 事故调查员"
    },
    {
        "id":715,
        "name":"341750  :  Negotiators Agree On Damages. | ผู้เจรจาตกลงความเสียหาย | 谈判人员就损害赔偿达成一致。"
    },
    {
        "id":716,
        "name":"341755  :  Negotiator Agrees On Compensation | ผู้เจรจาตกลงค่าสินไหมทดแทน | 谈判人员就赔偿达成一致"
    },
    {
        "id":717,
        "name":"341920  :  Workers Involved In Finance And Sales Not Elsewhere Classified. | ผู้ปฏิบัติงานที่เกี่ยวข้องกับงานด้านการเงินและการขายที่มิได้จัดประเภทไว้ในที่อื่น | 未分类的涉及财务和销售的工人。"
    },
    {
        "id":718,
        "name":"342120  :  Basic Raw Material Trade Broker | นายหน้าการค้าวัตถุดิบพื้นฐาน | 基础原材料贸易经纪人"
    },
    {
        "id":719,
        "name":"342130  :  Product Procurement Broker, Transportation Representative | นายหน้าจัดหาสินค้า , ผู้แทนการขนส่ง | 产品采购经纪人、运输代表"
    },
    {
        "id":720,
        "name":"342140  :  Ship Brokers Or Ship Tonnage | นายหน้าจัดหาเรือหรือระวางเรือ | 船舶经纪人或船舶吨位"
    },
    {
        "id":721,
        "name":"342220  :  Customs Clearance Agent, Customs\/Cargo Broker | ตัวแทนดำเนินพิธีการศุลกากร, ตัวแทนออกของ\/สินค้า | 报关代理、报关\/货运经纪人"
    },
    {
        "id":722,
        "name":"342230  :  International Shipping Agent (Land, Sea, Air) | ตัวแทนผู้รับจัดการขนส่งระหว่างประเทศ (ทางบก , ทางทะเล , ทางอากาศ) | 国际海运代理（陆运、海运、空运）"
    },
    {
        "id":723,
        "name":"342240  :  Shipping Line Representative | ตัวแทนสายเดินเรือ | 船公司代表"
    },
    {
        "id":724,
        "name":"342320  :  Employment Broker | นายหน้าจัดหางาน | 就业经纪人"
    },
    {
        "id":725,
        "name":"342330  :  Labor Contractor | ผู้จ้างเหมาแรงงาน | 劳务承包商"
    },
    {
        "id":726,
        "name":"342910  :  Brokerage Agent Selling Business Services | ตัวแทนนายหน้าขายบริการธุรกิจ | 经纪代理销售商业服务"
    },
    {
        "id":727,
        "name":"342930  :  Domestic Leather Strap Distributor | ผู้จัดจำหน่ายสายหนังในประเทศ | 国内皮表带经销商"
    },
    {
        "id":728,
        "name":"342940  :  Advertising And Program Salesperson (Radio And Television Station) | พนักงานขายโฆษณาและรายการ (สถานีวิทยุและโทรทัศน์) | 广告及节目销售员（广播电视台）"
    },
    {
        "id":729,
        "name":"342945  :  Advertising Salesperson, Advertising Sales Representative (Newspaper, Journal, Etc.) | พนักงานขายโฆษณา , ตัวแทนขายโฆษณา ( หนังสือพิมพ์ วารสาร ฯลฯ) | 广告业务员、广告销售代表（报纸、期刊等）"
    },
    {
        "id":730,
        "name":"342990  :  Sales Brokers, Other Business Services | ตัวแทนนายหน้าขายบริการธุรกิจอื่น ๆ | 销售经纪人、其他商业服务"
    },
    {
        "id":731,
        "name":"343120  :  Administrative Secretary | เลขานุการฝ่ายบริหาร | 行政秘书"
    },
    {
        "id":732,
        "name":"343130  :  Correspondence Assistant Staff | พนักงานผู้ช่วยงานโต้ตอบจดหมาย | 通讯助理人员"
    },
    {
        "id":733,
        "name":"343135  :  Report Preparation Officer (Operation) | เจ้าหน้าที่จัดทำรายงาน (การดำเนินงาน) | 报告准备官员（手术）"
    },
    {
        "id":734,
        "name":"343220  :  Attorney'S Assistant, Attorney'S Clerk | ผู้ช่วยทนายความ , เสมียนทนาย | 律师助理、律师文员"
    },
    {
        "id":735,
        "name":"343225  :  Legal Clerk | เสมียนฝ่ายกฎหมาย | 法律文员"
    },
    {
        "id":736,
        "name":"343230  :  Confiscation Officer | พนักงานยึดทรัพย์ | 没收官"
    },
    {
        "id":737,
        "name":"343240  :  Insurance Assessment Assistant, Insurance Clerk | ผู้ช่วยการประเมินการประกัน , เสมียนประกันภัย | 保险评估助理、保险文员"
    },
    {
        "id":738,
        "name":"343290  :  Workers Involved In Legal And Other Business Matters | ผู้ปฏิบัติงานที่เกี่ยวข้องกับงานด้านกฎหมายและธุรกิจอื่น ๆ | 涉及法律和其他商业事务的工人"
    },
    {
        "id":739,
        "name":"343320  :  Accountant | พนักงานบัญชี | 会计"
    },
    {
        "id":740,
        "name":"343410  :  Assistant Statistician | ผู้ช่วยนักสถิติ | 助理统计师"
    },
    {
        "id":741,
        "name":"343420  :  Mathematician'S Assistant | ผู้ช่วยนักคณิตศาสตร์ | 数学家助理"
    },
    {
        "id":742,
        "name":"343430  :  Assistant Actuary | ผู้ช่วยนักคณิตศาสตร์ประกันภัย | 助理精算师"
    },
    {
        "id":743,
        "name":"343440  :  Accountant Assistant | ผู้ช่วยนักบัญชี | 会计助理"
    },
    {
        "id":744,
        "name":"343490  :  Statistics Workers Mathematics And Related Work Which Are Not Classified Elsewhere | ผู้ปฏิบัติงานเกี่ยวกับงานสถิติ คณิตศาสตร์และงานที่เกี่ยวข้อง ซึ่งมิได้จัดประเภทไว้ในที่อื่น | 统计工作者数学及相关工作未分类于其他地方的"
    },
    {
        "id":745,
        "name":"343920  :  Executive Secretary (Committee) | เลขานุการบริหาร (คณะกรรมการ) | 执行秘书（委员会）"
    },
    {
        "id":746,
        "name":"343930  :  Meeting Coordinator | ผู้ประสานงานจัดประชุม | 会议协调员"
    },
    {
        "id":747,
        "name":"343990  :  General Service Workers Which Are Not Classified Elsewhere | ผู้ปฎิบัติงานด้านบริการงานทั่วไป ซึ่งมิได้จัดประเภทไว้ในที่อื่น | 一般服务人员未分类于其他地方的"
    },
    {
        "id":748,
        "name":"344120  :  Customs Officer | เจ้าหน้าที่ประจำด่านศุลกากร | 海关官员"
    },
    {
        "id":749,
        "name":"344130  :  Passport Inspection Officer | เจ้าหน้าที่ตรวจสอบหนังสือเดินทาง | 护照检查官"
    },
    {
        "id":750,
        "name":"344140  :  Border Checkpoint Officers | เจ้าหน้าที่ประจำด่านตรวจชายแดน | 边境检查站官员"
    },
    {
        "id":751,
        "name":"344220  :  Revenue Officer | เจ้าหน้าที่สรรพากร | 税务员"
    },
    {
        "id":752,
        "name":"344230  :  Excise Officer | เจ้าหน้าที่สรรพสามิต | 税务官"
    },
    {
        "id":753,
        "name":"344320  :  Pension Officer | เจ้าหน้าที่งานบำเหน็จบำนาญ | 养老金官员"
    },
    {
        "id":754,
        "name":"344330  :  Social Benefits Officer (Insurance Academic) | เจ้าหน้าที่งานสิทธิประโยชน์ทางสังคม (นักวิชาการประกันภัย) | 社会福利官员（保险学术）"
    },
    {
        "id":755,
        "name":"344420  :  Passport Issuing Officer | เจ้าหน้าที่ออกหนังสือเดินทาง | 护照签发官"
    },
    {
        "id":756,
        "name":"344430  :  Immigration Officer | เจ้าหน้าที่ตรวจคนเข้าเมือง | 入境事务官"
    },
    {
        "id":757,
        "name":"344490  :  Various Licensing Officials | เจ้าหน้าที่ออกใบอนุญาตต่าง ๆ | 各种许可官员"
    },
    {
        "id":758,
        "name":"344920  :  Workers Involved In Customs Work Revenue Department And Other Government Work | ผู้ปฏิบัติงานที่เกี่ยวข้องกับงานศุลกากร สรรพากรและงาน ราชการอื่น ๆ | 从事海关工作的工人税务局和其他政府工作"
    },
    {
        "id":759,
        "name":"344990  :  Workers Involved In Customs Work Revenue Department And Other Government Work | ผู้ปฎิบัติงานที่เกี่ยวข้องกับงานศุลกากร สรรพากรและงานราชการอื่นๆ | 从事海关工作的工人税务局和其他政府工作"
    },
    {
        "id":760,
        "name":"345020  :  Police Officers Investigate Investigating | เจ้าหน้าที่ตำรวจ สืบสวน สอบสวน | 警方正在调查调查"
    },
    {
        "id":761,
        "name":"345030  :  Detective | นักสืบ | 侦探"
    },
    {
        "id":762,
        "name":"346020  :  Assistant Social Worker, Social Welfare | ผู้ช่วยเจ้าหน้าที่สังคมสงเคราะห์ , สวัสดิการสังคม | 助理社会工作者，社会福利"
    },
    {
        "id":763,
        "name":"347110  :  Interior Designer Or Decorator | นักออกแบบตกแต่งภายในหรือมัณฑนากร | 室内设计师或装潢师"
    },
    {
        "id":764,
        "name":"347115  :  Interior Decorator | ช่างตกแต่งภายใน | 室内装饰师"
    },
    {
        "id":765,
        "name":"347117  :  Storefront Decorator And Product Display Technician | ช่างตกแต่งหน้าร้านและแสดงสินค้า | 店面装修及产品陈列技术员"
    },
    {
        "id":766,
        "name":"347120  :  Industrial And Commercial Product Designer | นักออกแบบผลิตภัณฑ์อุตสาหกรรมและพาณิชยกรรม | 工商业产品设计师"
    },
    {
        "id":767,
        "name":"347130  :  Print Designer | นักออกแบบสิ่งพิมพ์ | 印刷设计师"
    },
    {
        "id":768,
        "name":"347135  :  Graphic Designer | นักออกแบบภาพกราฟฟิก | 平面设计师"
    },
    {
        "id":769,
        "name":"347140  :  Jewelry Designer | ช่างออกแบบเครื่องประดับ | 珠宝设计师"
    },
    {
        "id":770,
        "name":"347150  :  Clothing Designers, Textile Products (Textile Product Designer | นักออกแบบเสื้อผ้า, ผลิตภัณฑ์สิ่งทอสิ่งถัก (นักออกแบบผลิตภัณฑ์สิ่งทอ | 服装设计师、纺织产品（纺织产品设计师"
    },
    {
        "id":771,
        "name":"347155  :  Performance Costume Designer | นักออกแบบเครื่องแต่งกายการแสดง | 表演服装设计师"
    },
    {
        "id":772,
        "name":"347160  :  The Designer Made A Special Image. | ผู้ออกแบบทำภาพพิเศษ | 设计师做了一个特别的形象。"
    },
    {
        "id":773,
        "name":"347165  :  Prop Supplier | ผู้จัดหาอุปกรณ์ประกอบฉาก | 道具供应商"
    },
    {
        "id":774,
        "name":"347170  :  Advertising Illustrator | นักวาดภาพประกอบโฆษณา | 广告插画师"
    },
    {
        "id":775,
        "name":"347175  :  Advertising Sketch Artist | ผู้ร่างภาพโฆษณา | 广告素描师"
    },
    {
        "id":776,
        "name":"347180  :  Traffic Staff | พนักงานแทรฟฟิค | 交通工作人员"
    },
    {
        "id":777,
        "name":"347182  :  Advertising Art Officer (Newspaper) | เจ้าหน้าที่งานศิลป์โฆษณา (หนังสือพิมพ์) | 广告艺术官（报纸）"
    },
    {
        "id":778,
        "name":"347184  :  Art Staff | เจ้าหน้าที่งานศิลป์ | 美术人员"
    },
    {
        "id":779,
        "name":"347190  :  Designers Not Classified Elsewhere | นักออกแบบซึ่งมิได้จัดประเภทไว้ในที่อื่น | 未分类于其他地方的设计师"
    },
    {
        "id":780,
        "name":"347220  :  Radio Station Announcer | ผู้ประกาศสถานีวิทยุกระจายเสียง | 广播电台播音员"
    },
    {
        "id":781,
        "name":"347225  :  Radio News Announcer | ผู้ประกาศข่าววิทยุกระจายเสียง | 广播新闻播音员"
    },
    {
        "id":782,
        "name":"347230  :  Television Announcer | ผู้ประกาศรายการทางโทรทัศน์ | 电视播音员"
    },
    {
        "id":783,
        "name":"347235  :  Television News Announcer | ผู้ประกาศข่าวทางโทรทัศน์ | 电视新闻播音员"
    },
    {
        "id":784,
        "name":"347240  :  Radio Presenter, Radio Broadcast Operator | นักจัดรายการวิทยุ , ผู้ดำเนินรายการวิทยุกระจายเสียง | 电台主持人、电台广播操作员"
    },
    {
        "id":785,
        "name":"347250  :  Television Program Host, Television Program Host | พิธีกรรายการโทรทัศน์ , ผู้ดำเนินรายการโทรทัศน์ | 电视节目主持人, 电视节目主持人"
    },
    {
        "id":786,
        "name":"347260  :  Screenplay Voice Actor | ผู้พากย์บทภาพยนตร์ | 剧本配音演员"
    },
    {
        "id":787,
        "name":"347262  :  Television Voice Actor Or Commentator | นักพากย์หรือผู้บรรยายทางโทรทัศน์ | 电视配音演员或评论员"
    },
    {
        "id":788,
        "name":"347265  :  A Person Who Provides The Sound Of A Radio Spot Or Documentary. | ผู้ให้เสียงสปอตหรือสารคดีทางวิทยุกระจายเสียง | 提供广播节目或纪录片声音的人。"
    },
    {
        "id":789,
        "name":"347320  :  Musicians, Singers, Street Dancers, Nightclubs, Etc. | นักดนตรี นักร้อง นักเต้นรำตามถนน ไนท์คลับอื่น ๆ | 音乐家、歌手、街舞者、夜总会等。"
    },
    {
        "id":790,
        "name":"347420  :  Comedian | นักแสดงตลก | 喜剧演员"
    },
    {
        "id":791,
        "name":"347430  :  Magician | นักมายากล | 魔术师"
    },
    {
        "id":792,
        "name":"347440  :  Acrobat | นักกายกรรม | 杂技演员"
    },
    {
        "id":793,
        "name":"347450  :  Puppeteer | นักชักหุ่นกระบอก | 木偶师"
    },
    {
        "id":794,
        "name":"347490  :  Comedians, Magicians, And Other Acrobats | นักแสดงตลก นักมายากล และนักกายกรรมอื่น ๆ | 喜剧演员、魔术师和其他杂技演员"
    },
    {
        "id":795,
        "name":"347520  :  Athletes (Athletes, Boxers, Wrestlers, Swimmers, Jockeys) | นักกีฬา (นักกรีฑา , นักมวย , นักมวยปล้ำ , นักว่ายน้ำ ,นักขี่ม้าแข่ง) | 运动员（运动员、拳击手、摔跤手、游泳运动员、骑师）"
    },
    {
        "id":796,
        "name":"347530  :  Sports Trainer | ผู้ฝึกสอนกีฬา | 运动教练"
    },
    {
        "id":797,
        "name":"347535  :  Sports Supervisor | เจ้าหน้าที่ดูแลด้านการกีฬา | 体育督导员"
    },
    {
        "id":798,
        "name":"347540  :  Referee (Sports) | กรรมการตัดสิน (กีฬา) | 裁判员（体育）"
    },
    {
        "id":799,
        "name":"347550  :  Physical Exercise Practitioner | ผู้ฝึกซ้อมการบริหารร่างกาย | 体育锻炼实践者"
    },
    {
        "id":800,
        "name":"347590  :  Athletes And Other Sports Coaches | นักกีฬาและผู้ฝึกสอนกีฬาอื่น ๆ | 运动员和其他体育教练"
    },
    {
        "id":801,
        "name":"348010  :  Churchwarden | ไวยาวัจกร | 教堂管理员"
    },
    {
        "id":802,
        "name":"348020  :  The Path | มรรคนายก | 路径"
    },
    {
        "id":803,
        "name":"348030  :  Parent (Religion) | ผู้ปกครอง (ศาสนา) | 家长（宗教）"
    },
    {
        "id":804,
        "name":"348090  :  Religious Workers Not Classified Elsewhere | ผู้ปฏิบัติงานที่เกี่ยวข้องกับศาสนาซึ่งมิได้จัดประเภทไว้ในที่อื่น | 未分类于其他地方的宗教工作者"
    },
    {
        "id":805,
        "name":"411120  :  Shorthand Officer | เจ้าหน้าที่จดชวเลข | 速记员"
    },
    {
        "id":806,
        "name":"411130  :  Typist, Typist | เจ้าหน้าที่พิมพ์ดีด , พนักงานพิมพ์ดีด | 打字员，打字员"
    },
    {
        "id":807,
        "name":"411220  :  Computer Operator, Word Processing Machine Operator | เจ้าหน้าที่คอมพิวเตอร์ , เจ้าหน้าที่ประจำเครื่องประมวลผลคำ | 计算机操作员、文字处理机操作员"
    },
    {
        "id":808,
        "name":"411230  :  Computer Graphics Officer | เจ้าหน้าที่คอมพิวเตอร์กราฟิก | 计算机图形官"
    },
    {
        "id":809,
        "name":"411240  :  Fax\/Telex Machine Operator | เจ้าหน้าที่ประจำเครื่องโทรสาร \/เทเล็กซ์ | 传真\/电传机操作员"
    },
    {
        "id":810,
        "name":"411320  :  Data Recording Staff, Data Recording Staff | พนักงานบันทึกข้อมูล , เจ้าหน้าที่บันทึกข้อมูล | 数据记录人员，数据记录人员"
    },
    {
        "id":811,
        "name":"411420  :  Calculator Staff | เจ้าหน้าที่เครื่องคำนวณ | 计算器人员"
    },
    {
        "id":812,
        "name":"411520  :  Secretary | เลขานุการ | 秘书"
    },
    {
        "id":813,
        "name":"411530  :  Television News Editorial Secretary | เลขานุการกองบรรณาธิการข่าวโทรทัศน์ | 电视新闻编辑秘书"
    },
    {
        "id":814,
        "name":"412120  :  Accounting Officer | เจ้าหน้าที่ลงบัญชี | 会计人员"
    },
    {
        "id":815,
        "name":"412130  :  Production Cost Calculator | เจ้าหน้าที่คำนวณต้นทุนการผลิต | 生产成本计算器"
    },
    {
        "id":816,
        "name":"412140  :  Wage Calculator | เจ้าหน้าที่คำนวณค่าจ้าง | 工资计算器"
    },
    {
        "id":817,
        "name":"412190  :  Accounting Staff And Other Calculations | เจ้าหน้าที่ลงบัญชีและการคำนวณอื่น ๆ | 会计人员和其他计算"
    },
    {
        "id":818,
        "name":"412220  :  Statistical Officer | เจ้าหน้าที่สถิติ | 统计员"
    },
    {
        "id":819,
        "name":"412230  :  Loan Officer, Financial Officer | เจ้าหน้าที่สินเชื่อ , เจ้าหน้าที่การเงิน | 信贷员、财务员"
    },
    {
        "id":820,
        "name":"412240  :  Insurance Officer | เจ้าหน้าที่ประกันภัย | 保险员"
    },
    {
        "id":821,
        "name":"412290  :  Other Statistical And Financial Officers | เจ้าหน้าที่สถิติและการเงินอื่นๆ | 其他统计和财务官员"
    },
    {
        "id":822,
        "name":"413120  :  Importer Or Exporter Of Goods | ผู้นำเข้าหรือส่งออกสินค้า | 货物进口商或出口商"
    },
    {
        "id":823,
        "name":"413130  :  Inventory Recording Officer | เจ้าหน้าที่บันทึกสินค้าคงคลัง | 库存记录员"
    },
    {
        "id":824,
        "name":"413140  :  Warehouse Officer | เจ้าหน้าที่คลังพัสดุ | 仓管员"
    },
    {
        "id":825,
        "name":"413145  :  Product Weighing Officer, Freight Clerk | เจ้าหน้าที่ชั่งน้ำหนักสินค้า , เสมียนขนส่งสินค้า | 产品称重员、货运员"
    },
    {
        "id":826,
        "name":"413190  :  Other Warehouse Staff | เจ้าหน้าที่คลังสินค้าอื่น ๆ | 其他仓库工作人员"
    },
    {
        "id":827,
        "name":"413220  :  Production Planning Officer, Clerk | เจ้าหน้าที่วางแผนการผลิต , เสมียน | 生产计划员、文员"
    },
    {
        "id":828,
        "name":"413230  :  Material Preparation Staff For Production, Material Purchasing Staff | เจ้าหน้าที่เตรียมวัสดุเพื่อการผลิต , เจ้าหน้าที่จัดซื้อวัสดุ | 生产备料人员、材料采购人员"
    },
    {
        "id":829,
        "name":"413240  :  Media Purchasing Officer | เจ้าหน้าที่จัดซื้อสื่อ | 媒体采购官"
    },
    {
        "id":830,
        "name":"413310  :  Line Manager And Assistant Line Manager ; Station Master | ผู้จัดการสายและผู้ช่วยผู้จัดการสาย ; นายสถานีรถ | 直线经理和助理直线经理；站长"
    },
    {
        "id":831,
        "name":"413320  :  Car Inspector | นายตรวจรถ | 汽车检验员"
    },
    {
        "id":832,
        "name":"413325  :  Driver Releasing The Car | พนักงานปล่อยรถ | 司机释放汽车"
    },
    {
        "id":833,
        "name":"413327  :  Driver Of Vehicle By Public Transport ; Mr. Tha Wu | พนักงานควบคุมรถยนต์โดยการสารประจำทาง ; นายท่าอู่ | 乘坐公共交通工具的车辆司机；吴达先生"
    },
    {
        "id":834,
        "name":"413330  :  Traffic Inspector (Train) | สารวัตรเดินรถ (รถไฟ) | 交通督察（火车）"
    },
    {
        "id":835,
        "name":"413332  :  Freight Forwarding Inspector (Railway) | สารวัตรรับส่งสินค้า (รถไฟ) | 货运检验员（铁路）"
    },
    {
        "id":836,
        "name":"413334  :  Train Operator (Train) | พนักงานควบคุมการเดินรถ (รถไฟ) | 火车操作员（火车）"
    },
    {
        "id":837,
        "name":"413340  :  General Water Transport Officer, Water Transport Operator | เจ้าหน้าที่ขนส่งทางน้ำทั่วไป , ผู้ขนส่งทางน้ำ | 一般水运官、水运操作员"
    },
    {
        "id":838,
        "name":"413350  :  Air Transportation Officer\/Flight Operator | เจ้าหน้าที่ขนส่งทางอากาศ \/ พนักงานอำนวยการบิน | 航空运输官员\/飞行操作员"
    },
    {
        "id":839,
        "name":"413352  :  Flight Clearance Staff | พนักงานพิธีการบิน | 航班清关人员"
    },
    {
        "id":840,
        "name":"413353  :  Ground Traffic Control Staff | พนักงานควบคุมจราจรภาคพื้น | 地面交通管制人员"
    },
    {
        "id":841,
        "name":"413354  :  Airport Service Staff | พนักงานบริการท่าอากาศยาน | 机场服务人员"
    },
    {
        "id":842,
        "name":"413355  :  Personnel Arranges Cargo On Planes | เจ้าหน้าที่จัดระวางบรรทุกบนเครื่องบิน | 工作人员在飞机上安排货物"
    },
    {
        "id":843,
        "name":"413390  :  Other Transport Personnel | เจ้าหน้าที่ขนส่งอื่น ๆ | 其他运输人员"
    },
    {
        "id":844,
        "name":"414110  :  Library Staff | เจ้าหน้าที่ห้องสมุด | 图书馆工作人员"
    },
    {
        "id":845,
        "name":"414120  :  Clerk, Document Filing Officer | เสมียน, เจ้าหน้าที่จัดเก็บเอกสาร | 文员、文件归档员"
    },
    {
        "id":846,
        "name":"414130  :  Audiovisual Library Staff | เจ้าหน้าที่ห้องสมุดภาพและเสียง | 视听图书馆工作人员"
    },
    {
        "id":847,
        "name":"414190  :  Other Library Staff | เจ้าหน้าที่ห้องสมุดอื่น ๆ | 其他图书馆工作人员"
    },
    {
        "id":848,
        "name":"414220  :  Postman, Postman | พนักงานรับส่งไปรษณีย์ภัณฑ์ , บุรุษไปรษณีย์ | 邮递员，邮递员"
    },
    {
        "id":849,
        "name":"414230  :  Postal Sorting Worker | พนักงานคัดแยกไปรษณีย์ภัณฑ์ | 邮政分拣员"
    },
    {
        "id":850,
        "name":"414240  :  Postal Transport Employee | พนักงานขนส่งไปรษณีย์ภัณฑ์ | 邮政运输员工"
    },
    {
        "id":851,
        "name":"414290  :  Other Postal Workers | พนักงานไปรษณีย์อื่น ๆ | 其他邮政工作人员"
    },
    {
        "id":852,
        "name":"414320  :  Employee Enters Code | พนักงานลงรหัส | 员工输入代码"
    },
    {
        "id":853,
        "name":"414330  :  Proofreading Staff (Broof Inspector) | พนักงานพิสูจน์อักษร (ผู้ตรวจบรู๊ฟ) | 校对人员（布罗夫督察）"
    },
    {
        "id":854,
        "name":"414420  :  Secretariat Officer | เจ้าหน้าที่งานสารบรรณ | 秘书处干事"
    },
    {
        "id":855,
        "name":"414520  :  Museum Staff | เจ้าหน้าที่พิพิธภัณฑ์ | 博物馆工作人员"
    },
    {
        "id":856,
        "name":"414590  :  Other Museum Staff | เจ้าหน้าที่พิพิธภัณฑ์อื่น ๆ | 其他博物馆工作人员"
    },
    {
        "id":857,
        "name":"419010  :  Clerk, General Employee, Administrative Employee | เสมียนพนักงานทั่วไป,พนักงานธุรการ | 文员、普通员工、行政员工"
    },
    {
        "id":858,
        "name":"419020  :  Human Resources Officer | เจ้าหน้าที่ฝ่ายบุคคล | 人力资源官"
    },
    {
        "id":859,
        "name":"419030  :  Registration Officer | เจ้าหน้าที่ฝ่ายทะเบียน | 登记官"
    },
    {
        "id":860,
        "name":"419090  :  Other Office Staff | เจ้าหน้าที่สำนักงานอื่น ๆ | 其他办公室人员"
    },
    {
        "id":861,
        "name":"421120  :  Financial Officer | เจ้าหน้าที่การเงิน | 财务人员"
    },
    {
        "id":862,
        "name":"421130  :  Teller, Cashier | เจ้าหน้าที่เก็บเงิน , แคชเชียร์ | 出纳员、出纳员"
    },
    {
        "id":863,
        "name":"421140  :  Ticket Sales Officer ; Ticket Salesman | เจ้าหน้าที่ขายตั๋ว ; พนักงานจำหน่ายบัตร | 售票员；售票员"
    },
    {
        "id":864,
        "name":"421190  :  Cashiers And Other Ticket Sales Staff | เจ้าหน้าที่เก็บเงินและเจ้าหน้าที่ขายตั๋วอื่น ๆ | 收银员和其他售票人员"
    },
    {
        "id":865,
        "name":"421220  :  Bank Teller | เจ้าหน้าที่รับจ่ายเงินในธนาคาร | 银行柜员"
    },
    {
        "id":866,
        "name":"421230  :  Foreign Currency Exchange Officer | เจ้าหน้าที่รับแลกเปลี่ยนเงินตราต่างประเทศ | 外币兑换员"
    },
    {
        "id":867,
        "name":"421240  :  Postal Officer | เจ้าหน้าที่ไปรษณีย์ | 邮政官员"
    },
    {
        "id":868,
        "name":"421290  :  Counter Staff For Other Businesses | เจ้าหน้าที่ประจำเคาน์เตอร์กิจการอื่นๆ | 其他企业的柜台人员"
    },
    {
        "id":869,
        "name":"421320  :  Bookmaker | เจ้ามือรับพนัน | 博彩公司"
    },
    {
        "id":870,
        "name":"421330  :  Cashier (Gambling Table) | เจ้าหน้าที่รับจ่ายเงิน (โต๊ะพนัน) | 收银台（赌桌）"
    },
    {
        "id":871,
        "name":"421420  :  Pawnbroker (Long Zhu Pawn Shop) | ผู้รับจำนำทรัพย์สิน (หลงจู๊โรงรับจำนำ) | 当铺(龙珠当铺)"
    },
    {
        "id":872,
        "name":"421430  :  Money Lender, Loan Broker | ผู้ให้กู้ยืมเงิน , นายหน้าเงินกู้ | 放债人、贷款经纪人"
    },
    {
        "id":873,
        "name":"421520  :  Rent Collector | พนักงานเก็บค่าเช่า | 收租员"
    },
    {
        "id":874,
        "name":"421530  :  Debt Collector | พนักงานเร่งรัดหนี้สิน | 收债员"
    },
    {
        "id":875,
        "name":"421540  :  Cashier (Charity) | พนักงานเก็บเงิน (การกุศล) | 出纳员（慈善机构）"
    },
    {
        "id":876,
        "name":"422120  :  Travel Agent Office Clerk | เสมียนสำนักงานตัวแทนนำเที่ยว | 旅行社办公室文员"
    },
    {
        "id":877,
        "name":"422130  :  Ticket Issuing Staff | พนักงานออกบัตรโดยสาร | 出票人员"
    },
    {
        "id":878,
        "name":"422140  :  Recreation Officer | เจ้าหน้าสันทนาการ | 康乐主任"
    },
    {
        "id":879,
        "name":"422190  :  Tourism Workers And Other Related Workers | พนักงานท่องเที่ยวและผู้ปฏิบัติงานที่เกี่ยวข้องอื่นๆ | 旅游工作者及其他相关工作者"
    },
    {
        "id":880,
        "name":"422210  :  General Receptionist | พนักงานต้อนรับทั่วไป | 总接待员"
    },
    {
        "id":881,
        "name":"422220  :  Receptionist (Hotel) | พนักงานต้อนรับ (โรงแรม) | 接待员（酒店）"
    },
    {
        "id":882,
        "name":"422225  :  Reservation Staff | พนักงานรับจองห้องพัก | 订房人员"
    },
    {
        "id":883,
        "name":"422230  :  Receptionist (Health Care Facility) | พนักงานต้อนรับ (สถานพยาบาล) | 接待员（医疗机构）"
    },
    {
        "id":884,
        "name":"422240  :  Staff Giving Travel News | พนักงานให้ข่าวสารการท่องเที่ยว | 工作人员发布旅游新闻"
    },
    {
        "id":885,
        "name":"422290  :  Receptionist And Other Information Service Personnel | พนักงานต้อนรับ และพนักงานบริการข้อมูลข่าวสารอื่น ๆ | 接待员以及其他信息服务人员"
    },
    {
        "id":886,
        "name":"422320  :  Telephone Operator | พนักงานรับโทรศัพท์ | 电话接线员"
    },
    {
        "id":887,
        "name":"422390  :  Other Telephone Panel Operators | พนักงานควบคุมแผงโทรศัพท์อื่น ๆ | 其他电话接线员"
    },
    {
        "id":888,
        "name":"511120  :  Flight Attendant | พนักงานต้อนรับบนเครื่องบิน | 空姐"
    },
    {
        "id":889,
        "name":"511130  :  Ground Receptionist | พนักงานต้อนรับภาคพื้นดิน | 地面接待员"
    },
    {
        "id":890,
        "name":"511140  :  Stewardess On The Boat | พนักงานต้อนรับบนเรือ | 船上的空姐"
    },
    {
        "id":891,
        "name":"511150  :  Bus Attendant | พนักงานต้อนรับบนรถ | 公交车乘务员"
    },
    {
        "id":892,
        "name":"511190  :  Staff Provide Convenience During Other Trips. | พนักงานอำนวนความสะดวกในระหว่างการเดินทางอื่น ๆ | 工作人员会在其他旅行期间提供便利。"
    },
    {
        "id":893,
        "name":"511220  :  Fare Collector | พนักงานเก็บค่าโดยสาร | 售票员"
    },
    {
        "id":894,
        "name":"511230  :  Car Maintenance Staff (Train) | พนักงานรักษารถ (รถไฟ) | 汽车维修人员（火车）"
    },
    {
        "id":895,
        "name":"511235  :  Sleeping Car Employee (Train) | พนักงานรถนอน (รถไฟ) | 卧铺车员工（火车）"
    },
    {
        "id":896,
        "name":"511290  :  Employees Maintain Vehicles Used For Other Transportation. | พนักงานรักษารถที่ใช้ในการขนส่งอื่น ๆ | 员工维护用于其他运输的车辆。"
    },
    {
        "id":897,
        "name":"511310  :  Guide | มัคคุเทศก์ | 指导"
    },
    {
        "id":898,
        "name":"511320  :  Museum Guide | มัคคุเทศก์พิพิธภัณฑ์ | 博物馆指南"
    },
    {
        "id":899,
        "name":"511330  :  Leader \/ Tour Leader | หัวหน้า \/ ผู้นำคณะท่องเที่ยว | 领队\/领队"
    },
    {
        "id":900,
        "name":"511390  :  Other Guides | มัคคุเทศก์อื่น ๆ | 其他指南"
    },
    {
        "id":901,
        "name":"512110  :  Housekeeper (Hotel) | แม่บ้าน (โรงแรม ) | 管家（酒店）"
    },
    {
        "id":902,
        "name":"512120  :  Maid (School) | แม่บ้าน (โรงเรียน ) | 女佣（学校）"
    },
    {
        "id":903,
        "name":"512130  :  Housekeeper (Office) | แม่บ้าน (สำนักงาน) | 管家（办公室）"
    },
    {
        "id":904,
        "name":"512140  :  Flower Arrangement Staff; Flower Arranger | พนักงานประจำห้องจัดดอกไม้ ; พนักงานจัดดอกไม้ | 插花人员；插花师"
    },
    {
        "id":905,
        "name":"512145  :  Housekeeper (Personal) | แม่บ้าน (ส่วนบุคคล) | 管家（个人）"
    },
    {
        "id":906,
        "name":"512150  :  General Service Provider In Hotels | ผู้ให้บริการทั่วไปในโรงแรม | 酒店综合服务提供商"
    },
    {
        "id":907,
        "name":"512190  :  Housekeepers And Other Related Workers | แม่บ้านและผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 管家及其他相关工作人员"
    },
    {
        "id":908,
        "name":"512220  :  Head Cook ; Head Chef | หัวหน้าผู้ปรุงอาหาร ; หัวหน้าพ่อครัว | 厨师长；主厨"
    },
    {
        "id":909,
        "name":"512225  :  Assistant Chef \/ Deputy Chef | ผู้ช่วยหัวหน้าพ่อครัว \/ รองหัวหน้าพ่อครัว | 助理厨师\/副厨师"
    },
    {
        "id":910,
        "name":"512230  :  Chef ; Cook | พ่อครัว ; ผู้ปรุงอาหาร | 厨师；厨师"
    },
    {
        "id":911,
        "name":"512240  :  Assistant Chef | ผู้ช่วยพ่อครัว | 助理厨师"
    },
    {
        "id":912,
        "name":"512290  :  Other Chefs | พ่อครัวอื่น ๆ | 其他厨师"
    },
    {
        "id":913,
        "name":"512320  :  Head Waiter\/Captain | หัวหน้าพนักงานเสริฟ \/ กัปตัน | 服务员领班\/队长"
    },
    {
        "id":914,
        "name":"512330  :  Waiter, Waiter | บริกร, พนักงานเสริฟ | 服务员，服务员"
    },
    {
        "id":915,
        "name":"512340  :  Drink Mixer, Bartender | ผู้ผสมเครื่องดื่ม , บาร์เทนเดอร์ | 调酒师、调酒师"
    },
    {
        "id":916,
        "name":"512350  :  Receptionist In The Restaurant | พนักงานต้อนรับในห้องอาหาร | 餐厅接待员"
    },
    {
        "id":917,
        "name":"512390  :  Other Service Staff | พนักงานบริการอื่น ๆ | 其他服务人员"
    },
    {
        "id":918,
        "name":"513120  :  Nanny Teacher | ครูพี่เลี้ยง | 保姆老师"
    },
    {
        "id":919,
        "name":"513130  :  Babysitter | พี่เลี้ยงเด็ก | 保姆"
    },
    {
        "id":920,
        "name":"513220  :  Dental Assistant, Dental Assistant | ผู้ช่วยทันตแพทย์ , ผู้ช่วยด้านทันตกรรม | 牙科助理, 牙科助理"
    },
    {
        "id":921,
        "name":"513230  :  Nursing Assistant (Hospital) | ผู้ช่วยพยาบาล (โรงพยาบาล) | 护理助理（医院）"
    },
    {
        "id":922,
        "name":"513231  :  Nursing Assistant (Clinic) | ผู้ช่วยพยาบาล (คลินิก) | 护理助理（诊所）"
    },
    {
        "id":923,
        "name":"513235  :  Nursing Assistant (Clinic) | ผู้ช่วยพยาบาล (คลินิก) | 护理助理（诊所）"
    },
    {
        "id":924,
        "name":"513240  :  Ambulance Staff | เจ้าหน้าที่ประจำรถพยาบาล | 救护人员"
    },
    {
        "id":925,
        "name":"513320  :  Carers For The Elderly And Children (At Home) | ผู้ดูแลผู้ป่วยคนชรา และเด็ก (ตามบ้าน) | 老人和儿童的照顾者（在家）"
    },
    {
        "id":926,
        "name":"513920  :  Veterinarian'S Staff | ลูกมือสัตวแพทย์ | 兽医工作人员"
    },
    {
        "id":927,
        "name":"513930  :  Pharmacist Assistant, Pharmacist Assistant | ผู้ช่วยเภสัชกร , ลูกมือเภสัชกร | 药剂师助理、药剂师助理"
    },
    {
        "id":928,
        "name":"514120  :  Hairdresser | ช่างตัดแต่งผม | 理发师"
    },
    {
        "id":929,
        "name":"514130  :  Beautician (Facial Massage, Body Massage, Sauna) | ช่างเสริมสวย (นวดหน้า , นวดตัว , อบซาวน่า ) | 美容师（面部按摩、全身按摩、桑拿）"
    },
    {
        "id":930,
        "name":"514140  :  Manicurist | ช่างแต่งเล็บ | 美甲师"
    },
    {
        "id":931,
        "name":"514150  :  Hair Stylist | ช่างออกแบบทรงผม | 发型师"
    },
    {
        "id":932,
        "name":"514160  :  Makeup Artist (Stage); Studio | ช่างแต่งหน้า (เวที) ; สตูดิโอ | 化妆师（舞台）；工作室"
    },
    {
        "id":933,
        "name":"514190  :  Hairdresser Beauticians And Other Related Workers | ช่างตัดแต่งผม ช่างเสริมสวยและผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 理发师美容师及其他相关工作人员"
    },
    {
        "id":934,
        "name":"514220  :  Servant | คนรับใช้ | 仆人"
    },
    {
        "id":935,
        "name":"514230  :  Activity Friends | เพื่อนร่วมกิจกรรม | 活动好友"
    },
    {
        "id":936,
        "name":"514240  :  Garment Caretaker (Personal) | ผู้ดูแลเสื้อผ้า (ส่วนตัว) | 服装管理员（个人）"
    },
    {
        "id":937,
        "name":"514250  :  Garment Attendant (Hotel) | ผู้ดูแลเสื้อผ้า (โรงแรม) | 服装服务员（酒店）"
    },
    {
        "id":938,
        "name":"514320  :  Undertaker; Waiter | สัปเหร่อ ; บริกรมรณกิจ | 承办人；服务员"
    },
    {
        "id":939,
        "name":"514330  :  Embalmer | ผู้อาบยาศพ | 防腐剂"
    },
    {
        "id":940,
        "name":"514390  :  Undertakers And Other Embalmers | สัปเหร่อ และผู้อาบยาศพอื่น ๆ | 殡仪员和其他防腐人员"
    },
    {
        "id":941,
        "name":"514920  :  Travel Companion | เพื่อนเที่ยว | 旅伴"
    },
    {
        "id":942,
        "name":"514930  :  Dancing Couple (Partner) | คู่เต้นรำ (พาร์ตเนอร์) | 跳舞情侣（搭档）"
    },
    {
        "id":943,
        "name":"514940  :  Receptionist (Club) | พนักงานต้อนรับ (คลับ) | 接待员（俱乐部）"
    },
    {
        "id":944,
        "name":"514950  :  Massage Parlor Employee | พนักงานอาบอบนวด | 按摩院员工"
    },
    {
        "id":945,
        "name":"514990  :  Personal Service Provider Which Has Not Been Classified Elsewhere | ผู้ให้บริการส่วนบุคคล ซื่งมิได้จัดประเภทไว้ในที่อื่น | 个人服务提供商尚未分类于其他地方的"
    },
    {
        "id":946,
        "name":"515120  :  Astrologer Astrologer | โหร นักโหรศาสตร์ | 占星家 占星家"
    },
    {
        "id":947,
        "name":"515220  :  Fortune Teller (Palmist, Foot Print, Poker) | หมอดู ( นักดูลายมือ , ลายเท้า , ไพ่ป๊อก ) | 算命先生（手相、脚印、扑克）"
    },
    {
        "id":948,
        "name":"516120  :  Fireman, Fire Police | พนักงานดับเพลิง , ตำรวจดับเพลิง | 消防员、消防警察"
    },
    {
        "id":949,
        "name":"516130  :  Forest Fire Extinguisher, Forest Fire Prevention Officer | พนักงานดับไฟป่า , เจ้าหน้าที่ป้องกันไฟป่า | 森林灭火器、森林防火员"
    },
    {
        "id":950,
        "name":"516140  :  Aircraft Rescue Personnel | เจ้าหน้าที่กู้ภัยอากาศยาน | 飞机救援人员"
    },
    {
        "id":951,
        "name":"516220  :  Police Officer | เจ้าหน้าที่ตำรวจ | 警官"
    },
    {
        "id":952,
        "name":"516230  :  Detective | นักสืบ | 侦探"
    },
    {
        "id":953,
        "name":"516320  :  Prison Guard, Warden | ผู้คุมนักโทษ , พัศดี | 狱警、典狱长"
    },
    {
        "id":954,
        "name":"516920  :  Bodyguard (Personal) | ผู้คุ้มกัน (ส่วนบุคคล) | 保镖（个人）"
    },
    {
        "id":955,
        "name":"516930  :  Security Guard, Security Guard (Guard) | พนักงานดูแลความปลอดภัย, พนักงานรักษาความปลอดภัย(ยาม) | 保安员、保安员（门卫）"
    },
    {
        "id":956,
        "name":"516935  :  Search Officer | พนักงานตรวจค้น | 搜查官"
    },
    {
        "id":957,
        "name":"516940  :  Coast Guard | ยามรักษาการชายฝั่ง | 海岸警卫队"
    },
    {
        "id":958,
        "name":"516950  :  Wildlife Keeper | ผู้ดูแลสัตว์ป่า | 野生动物饲养员"
    },
    {
        "id":959,
        "name":"516960  :  Pool Staff | เจ้าหน้าที่ประจำสระน้ำ | 泳池工作人员"
    },
    {
        "id":960,
        "name":"516990  :  Other Related Defense Service Providers | ผู้ให้บริการด้านการป้องกันภัยที่เกี่ยวข้องอื่น ๆ | 其他相关国防服务提供商"
    },
    {
        "id":961,
        "name":"521020  :  Model, Model | นายแบบ นางแบบ | 模型，模型"
    },
    {
        "id":962,
        "name":"522010  :  Sales Staff In Wholesale Establishments | พนักงานขายในสถานประกอบการค้าส่ง | 批发机构的销售人员"
    },
    {
        "id":963,
        "name":"522015  :  Salesperson In A Retail Establishment | พนักงานขายในสถานประกอบการค้าปลีก | 零售机构的销售员"
    },
    {
        "id":964,
        "name":"522020  :  Salesperson (Store), Storefront Salesperson | พนักงานขายสินค้า (ประจำร้าน) , พนักงานขายของหน้าร้าน | 营业员（店）、店面营业员"
    },
    {
        "id":965,
        "name":"522030  :  Product Demonstration Staff, Product Sample Offerers, Product Solicitors | พนักงานสาธิตสินค้า , ผู้เสนอสินค้าตัวอย่าง , ผู้ชักชวนซื้อสินค้า | 产品演示人员、产品样品提供者、产品律师"
    },
    {
        "id":966,
        "name":"522040  :  Gas Station Employee | พนักงานประจำสถานีบริการน้ำมัน | 加油站员工"
    },
    {
        "id":967,
        "name":"522090  :  Salespeople And Other Product Presenters | พนักงานขาย และผู้นำเสนอสินค้าอื่น ๆ | 销售人员和其他产品演示者"
    },
    {
        "id":968,
        "name":"523020  :  Sellers Of Goods At Stalls And In Markets | ผู้ขายสินค้าตามแผงร้านค้าและในตลาด | 摊位和市场上的商品销售商"
    },
    {
        "id":969,
        "name":"611110  :  Farmers Of Field Crops And Vegetables, Farmers Of Field Crops And Vegetables | ผู้เพาะปลูกพืชไร่ และพืชผัก , เกษตรกรพืชไร่และพืชผัก | 大田蔬菜农民 大田蔬菜农民"
    },
    {
        "id":970,
        "name":"611115  :  Field And Vegetable Farming Craftsman | คนงานฝีมือพืชไร่และพืชผัก | 田间和蔬菜种植工匠"
    },
    {
        "id":971,
        "name":"611120  :  Rice Cultivator, Rice Farmer, Farmer | ผู้เพาะปลูกข้าว, เกษตรกรปลูกข้าว , ชาวนา | 稻农、稻农、农民"
    },
    {
        "id":972,
        "name":"611125  :  Cereal Growers (Except Rice) | ผู้เพาะปลูกธัญพืช (ยกเว้นข้าว) | 谷物种植者（水稻除外）"
    },
    {
        "id":973,
        "name":"611130  :  Sugarcane Cultivator, Sugarcane Farmer | ผู้เพาะปลูกอ้อย, เกษตรกรไร่อ้อย | 甘蔗种植者、甘蔗种植者"
    },
    {
        "id":974,
        "name":"611135  :  Cultivators Of Fiber Crops | ผู้เพาะปลูกพืชเส้นใย | 纤维作物中耕机"
    },
    {
        "id":975,
        "name":"611140  :  Tobacco Farmer, Tobacco Plant Grower | เกษตรกรชาวไร่ยาสูบ , ผู้เพาะปลูกต้นยาสูบ | 烟农、烟草种植者"
    },
    {
        "id":976,
        "name":"611145  :  Tobacco Farm Craftsman | คนงานฝีมือไร่ยาสูบ | 烟田工匠"
    },
    {
        "id":977,
        "name":"611147  :  Tobacco Station Master, Tobacco Station Head | นายสถานีใบยาสูบ , หัวหน้าสถานีใบยาสูบ | 烟草站站长、烟草站站长"
    },
    {
        "id":978,
        "name":"611148  :  Farm Inspector; Promotion Staff | พนักงานตรวจไร่ ; พนักงานส่งเสริม | 农场督察；推广人员"
    },
    {
        "id":979,
        "name":"611150  :  Oil Crop Cultivator | ผู้เพาะปลูกพืชน้ำมัน | 油料作物中耕机"
    },
    {
        "id":980,
        "name":"611190  :  Growers Of Horticulture, Field Crops, And Other Grains | ผู้ปลูกพืชสวน พืชไร่ และธัญพืชอื่น ๆ | 园艺、大田作物和其他谷物的种植者"
    },
    {
        "id":981,
        "name":"611210  :  Fruit Tree Growers, Fruit Orchard Farmers, Fruit Growers | ผู้เพาะปลูกไม้ผล , เกษตรกรสวนผลไม้ , ชาวสวนผลไม้ | 果树种植者、果园种植者、果农"
    },
    {
        "id":982,
        "name":"611215  :  Handicraftsman In The Perennial And Shrub Garden | คนงานฝีมือประจำสวนไม้ยืนและไม้พุ่ม | 多年生植物和灌木花园中的手工艺人"
    },
    {
        "id":983,
        "name":"611220  :  Rubber Growers, Rubber Farmers, Rubber Farmers | ผู้เพาะปลูกยางพารา , เกษตรกรสวนยาง , ชาวสวนยาง | 橡胶种植者、橡胶种植者、橡胶种植者"
    },
    {
        "id":984,
        "name":"611225  :  Rubber Plantation Worker, Rubber Plantation Foreman | คนงานสวนยาง , หัวหน้าคนงานประจำสวนยาง | 橡胶园工人、橡胶园工头"
    },
    {
        "id":985,
        "name":"611230  :  Rubber Tapper, Rubber Tapper (Latex) | คนงานกรีดยาง , ผู้กรีดยาง (น้ำยาง) | 橡胶攻丝机，橡胶攻丝机（乳胶）"
    },
    {
        "id":986,
        "name":"611240  :  Tea Grower, Tea Plantation Farmer | ผู้เพาะปลูกชา , เกษตรกรไร่ชา | 茶农、茶园农民"
    },
    {
        "id":987,
        "name":"611250  :  Coffee Growers, Coffee Farmers | ผู้เพาะปลูกกาแฟ , เกษตรกรไร่กาแฟ | 咖啡种植者, 咖啡种植者"
    },
    {
        "id":988,
        "name":"611260  :  Grape Grower ; Vineyard Farmer | ผู้เพาะปลูกองุ่น ; เกษตรกรไร่องุ่น | 葡萄种植者；葡萄园农夫"
    },
    {
        "id":989,
        "name":"611270  :  Coconut Farmers ; Coconut Farmer | ผู้เพาะปลูกมะพร้าว ; ชาวสวนมะพร้าว | 椰子种植者；椰农"
    },
    {
        "id":990,
        "name":"611280  :  Coconut Farmers, Coconut Farmers | ผู้เพาะปลูกมะพร้าว , ชาวสวนมะพร้าว | 椰农, 椰农"
    },
    {
        "id":991,
        "name":"611290  :  Grower Of Other Perennials And Shrubs | ผู้เพาะปลูกไม้ยืนต้นและไม้พุ่มอื่น ๆ | 其他多年生植物和灌木的种植者"
    },
    {
        "id":992,
        "name":"611310  :  General Tree Nursery | ผู้เพาะชำต้นไม้ทั่วไป | 一般苗圃"
    },
    {
        "id":993,
        "name":"611320  :  Flower And Ornamental Plant Grower | ผู้เพาะปลูกไม้ดอกไม้ประดับ | 花卉和观赏植物种植者"
    },
    {
        "id":994,
        "name":"611325  :  Garden Decorator, Garden Designer | ผู้ตบแต่งสวน , ผู้ออกแบบจัดสวน | 园林装饰师、园林设计师"
    },
    {
        "id":995,
        "name":"611330  :  Cultivator Of Medicinal Plants | ผู้เพาะปลูกพืชสมุนไพร | 药用植物栽培者"
    },
    {
        "id":996,
        "name":"611335  :  Mushroom Grower\\030 | ผู้เพาะเห็ด\\030 | 蘑菇种植者\\030"
    },
    {
        "id":997,
        "name":"611340  :  Park And Lawn Caretaker, Golf Course | ผู้ดูแลสวนสาธารณะและสนามหญ้า , สนามกอล์ฟ | 公园和草坪管理员、高尔夫球场"
    },
    {
        "id":998,
        "name":"611350  :  Plant Seed Grower | ผู้เพาะเมล็ดพันธุ์พืช | 植物种子种植者"
    },
    {
        "id":999,
        "name":"611355  :  Plant Propagator | นักขยายพันธุ์พืช | 植物繁殖器"
    },
    {
        "id":1000,
        "name":"611360  :  Horticulturist; Gardener | ผู้เพาะปลูกพืชสวน ; คนทำสวน | 园艺师；园丁"
    },
    {
        "id":1001,
        "name":"611390  :  Grower Of Garden Plants And Other Nursery Plants | ผู้ปลูกพืชสวนและพืชในเรือนเพาะชำอื่น ๆ | 园林植物和其他苗圃植物的种植者"
    },
    {
        "id":1002,
        "name":"611420  :  Farmers Grow Mixed Crops. | เกษตรกรปลูกพืชแบบผสมผสาน | 农民种植混合作物。"
    },
    {
        "id":1003,
        "name":"611490  :  Other Mixed Plant Growers | ผู้ปลูกพืชแบบผสมผสานอื่น ๆ | 其他混合植物种植者"
    },
    {
        "id":1004,
        "name":"612116  :  Stable Worker | คนงานประจำคอกม้า | 稳定工人"
    },
    {
        "id":1005,
        "name":"612120  :  Livestock Farmers, Except Dairy Cattle (Horse, Sheep, Cow, Buffalo Farms) | เกษตรกรฟาร์มปศุสัตว์ ยกเว้นโคนม (ฟาร์มม้า , แกะ ,วัว , ควาย) | 畜牧业农民，奶牛除外（马、羊、牛、水牛养殖场）"
    },
    {
        "id":1006,
        "name":"612125  :  Livestock Farm Worker | คนงานประจำฟาร์มปศุสัตว์ | 畜牧业工人"
    },
    {
        "id":1007,
        "name":"612130  :  Dairy Farmer, Dairy Farmer | ผู้ทำฟาร์มโคนม , เกษตรกรฟาร์มโคนม | 奶农, 奶农"
    },
    {
        "id":1008,
        "name":"612135  :  Dairy Farm Worker | คนงานประจำฟาร์มโคนม | 奶牛场工人"
    },
    {
        "id":1009,
        "name":"612140  :  Pig Farm Farmer | เกษตรกรฟาร์มสุกร | 养猪场农民"
    },
    {
        "id":1010,
        "name":"612145  :  Pig Farm Worker | คนงานประจำฟาร์มสุกร | 养猪场工人"
    },
    {
        "id":1011,
        "name":"612150  :  Farmers Farm Animals | เกษตรกรฟาร์มสัตว์เลี้ยง | 农民农场动物"
    },
    {
        "id":1012,
        "name":"612160  :  Stable Worker | คนงานประจำคอกม้า | 稳定工人"
    },
    {
        "id":1013,
        "name":"612190  :  Farmers Raising Other Livestock | เกษตรกรเลี้ยงปศุสัตว์อื่นๆ | 饲养其他牲畜的农民"
    },
    {
        "id":1014,
        "name":"612210  :  Poultry Farm Farmer | เกษตรกรฟาร์มสัตว์ปีก | 家禽养殖场农民"
    },
    {
        "id":1015,
        "name":"612215  :  Poultry Farm Worker\\024 | คนงานประจำฟาร์มสัตว์ปีก\\024 | 养鸡场工人\\024"
    },
    {
        "id":1016,
        "name":"612220  :  Poultry Egg Incubator Worker | พนักงานเครื่องฟักไข่สัตว์ปีก | 禽蛋孵化机工人"
    },
    {
        "id":1017,
        "name":"612230  :  Workers In A Poultry Hatchery | คนงานในโรงฟักไข่สัตว์ปีก | 家禽孵化场的工人"
    },
    {
        "id":1018,
        "name":"612290  :  Other Poultry Farm Workers | ผู้ทำงานในฟาร์มสัตว์ปีกอื่น ๆ | 其他家禽养殖场工人"
    },
    {
        "id":1019,
        "name":"612320  :  Beekeeper, Craft Worker (Bee Farm) | ผู้เพาะเลี้ยงผึ้ง , คนงานฝีมือ (ฟาร์มเลี้ยงผึ้ง) | 养蜂人、手工艺工人（养蜂场）"
    },
    {
        "id":1020,
        "name":"612325  :  Bee Farm Worker | คนงานประจำฟาร์มเลี้ยงผึ้ง | 养蜂场工人"
    },
    {
        "id":1021,
        "name":"612330  :  Sericulture Farmer, Craft Worker (Sericulture Farm) | ผู้เพาะเลี้ยงไหม , คนงานฝีมือ (ฟาร์มเลี้ยงตัวไหม) | 蚕农、手工业工人（蚕场）"
    },
    {
        "id":1022,
        "name":"612335  :  Do Farm Workers Raise Silkworms? | คนงานประจำฟาร์มเลี้ยงไหม | 农场工人养蚕吗？"
    },
    {
        "id":1023,
        "name":"612340  :  Economic Insect Breeder | ผู้เพาะเลี้ยงแมลงเศรษฐกิจ | 经济昆虫饲养员"
    },
    {
        "id":1024,
        "name":"612410  :  Farmers Raise Mixed Animals. | เกษตรกรเลี้ยงสัตว์แบบผสมผสาน | 农民饲养混合动物。"
    },
    {
        "id":1025,
        "name":"612920  :  Wild Animal Breeder | ผู้เพาะเลี้ยงสัตว์ป่า | 野生动物饲养员"
    },
    {
        "id":1026,
        "name":"612930  :  Bird Breeder | ผู้เพาะเลี้ยงนก | 鸟类饲养员"
    },
    {
        "id":1027,
        "name":"612940  :  Animal Trainer | ผู้ฝึกสัตว์ | 驯兽师"
    },
    {
        "id":1028,
        "name":"612950  :  Zoo Keeper | ผู้ดูแลสวนสัตว์ | 动物园管理员"
    },
    {
        "id":1029,
        "name":"612960  :  Amphibian Breeder | ผู้เพาะเลี้ยงสัตว์ครึ่งบกครึ่งน้ำ | 两栖动物饲养员"
    },
    {
        "id":1030,
        "name":"612970  :  Reptile Breeder | ผู้เพาะเลี้ยงสัตว์เลื้อยคลาน | 爬行动物饲养员"
    },
    {
        "id":1031,
        "name":"612990  :  Other Commercial Animal Breeders | ผู้เพาะเลี้ยงสัตว์ในเชิงการค้าอื่นๆ | 其他商业动物饲养者"
    },
    {
        "id":1032,
        "name":"613010  :  Commercial Mixed Farming Farmers | เกษตรกรการเกษตรแบบผสมผสานเชิงพาณิชย์ | 商业混合农业农民"
    },
    {
        "id":1033,
        "name":"614110  :  General Lumberjack, Lumberjack | ผู้ทำไม้ทั่วไป , คนทำไม้ | 一般伐木工, 伐木工"
    },
    {
        "id":1034,
        "name":"614120  :  Survey Officer Enumerates Trees, Surveyor Enumerates Forest Resources. | เจ้าพนักงานสำรวจนับแจงไม้ , ผู้สำรวจแจงนับทรัพยากรป่าไม้ | 调查员清点树木，测量员清点森林资源。"
    },
    {
        "id":1035,
        "name":"614125  :  Lumberjack, Tree Cutter | ผู้ตัดไม้ , ผู้โค่นต้นไม้ | 伐木工人、树木砍伐者"
    },
    {
        "id":1036,
        "name":"614130  :  Wood Measuring Worker | พนักงานวัดไม้ | 木材测量工"
    },
    {
        "id":1037,
        "name":"614140  :  Person Tying A Raft | คนผูกแพ | 绑木筏的人"
    },
    {
        "id":1038,
        "name":"614145  :  Rafter, Rafter | ผู้ล่องไม้ , ผู้ล่องแพ | 椽子，椽子"
    },
    {
        "id":1039,
        "name":"614150  :  Employees And Reforestation Workers | พนักงานและคนงานปลูกป่า | 员工和重新造林工人"
    },
    {
        "id":1040,
        "name":"614155  :  Forest Employees And Workers | พนักงานและคนงานประจำป่า | 森林雇员和工人"
    },
    {
        "id":1041,
        "name":"614190  :  Other Forest Workers | ผู้ทำงานป่าไม้อื่น ๆ | 其他森林工人"
    },
    {
        "id":1042,
        "name":"614220  :  Charcoal Burner | ผู้เผาถ่าน | 木炭燃烧器"
    },
    {
        "id":1043,
        "name":"615110  :  Aquatic Animal Farmer | ผู้เลี้ยงสัตว์น้ำ | 水产养殖户"
    },
    {
        "id":1044,
        "name":"615120  :  Aquatic Animal Breeder And Nurser | ผู้เพาะและอนุบาลสัตว์น้ำ | 水生动物饲养员和保育员"
    },
    {
        "id":1045,
        "name":"615130  :  Aquaculture Worker | คนงานเพาะเลี้ยงสัตว์น้ำ | 水产养殖工人"
    },
    {
        "id":1046,
        "name":"615210  :  Freshwater Fisherman | ชาวประมงน้ำจืด | 淡水渔民"
    },
    {
        "id":1047,
        "name":"615220  :  Local Fishing \/ Small-Scale Fishing | ประมงพื้นบ้าน \/ ประมงขนาดเล็ก | 当地捕鱼\/小规模捕鱼"
    },
    {
        "id":1048,
        "name":"615290  :  Fishermen And Other Related Workers | ชาวประมงและผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 渔民和其他相关工人"
    },
    {
        "id":1049,
        "name":"615320  :  Deep Sea Fisherman (Commercial Fishing, Fishing Outside Waters) | ชาวประมงน้ำลึก (ประมงพาณิชย์ , ประมงนอกน่านน้ำ) | 深海渔夫（商业捕鱼、水域外捕鱼）"
    },
    {
        "id":1050,
        "name":"615420  :  Hunter ; Hunter | นักล่าสัตว์ ; พราน | 猎人;猎人"
    },
    {
        "id":1051,
        "name":"615430  :  Trapper | ผู้วางกับดักสัตว์ | 捕手"
    },
    {
        "id":1052,
        "name":"615440  :  Swallow Nest Collector | ผู้เก็บรังนกนางแอ่น | 燕窝收集器"
    },
    {
        "id":1053,
        "name":"615490  :  Hunters, Trappers And Other Related Workers | พราน , ผู้วางกับดักสัตว์และผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 猎人、捕猎者和其他相关工人"
    },
    {
        "id":1054,
        "name":"621020  :  Skilled Farm Workers, Farms In A Self-Sufficiency Economy | ผู้ปฏิบัติงานฝีมือในไร่, ฟาร์มในเชิงเศรษฐกิจแบบพอเพียง | 熟练的农场工人，自给自足经济中的农场"
    },
    {
        "id":1055,
        "name":"711120  :  Mining Worker, General Mining Worker (Surface, Underground) | คนงานเหมืองแร่ , พนักงานเหมืองแร่ทั่วไป (บนผิวดิน , ใต้ดิน) | 采矿工人、普通采矿工人（露天、井下）"
    },
    {
        "id":1056,
        "name":"711130  :  Quarry Worker, General Quarry Worker | คนงานเหมืองหิน , พนักงานเหมืองหินทั่วไป | 采石场工人, 一般采石场工人"
    },
    {
        "id":1057,
        "name":"711190  :  Other Mining And Quarry Employees\/Workers | พนักงาน\/คนงานเหมืองแร่และเหมืองหินอื่น ๆ | 其他采矿和采石场雇员\/工人"
    },
    {
        "id":1058,
        "name":"711220  :  Explosive Workers In Mines And Quarries, Explosives Workers (Mining) | พนักงานวางระเบิดในเหมืองแร่และเหมืองหิน , พนักงานจุดระเบิด (เหมืองแร่) | 矿山和采石场的爆炸物工人、爆炸物工人（采矿）"
    },
    {
        "id":1059,
        "name":"711315  :  Stone Grading Technician | ช่างจัดเกรดหิน | 石材分级技术员"
    },
    {
        "id":1060,
        "name":"711320  :  Stone Cutter | ช่างตัดหิน | 石材切割机"
    },
    {
        "id":1061,
        "name":"711325  :  Stone Saw | ช่างเลื่อยหิน | 石锯"
    },
    {
        "id":1062,
        "name":"711330  :  Stone Polisher | ช่างขัดหิน | 石材抛光机"
    },
    {
        "id":1063,
        "name":"711335  :  Hand Polished Stone | ช่างขัดเงาหินด้วยมือ | 手工抛光石材"
    },
    {
        "id":1064,
        "name":"711340  :  Stone Polisher Using Machinery | ช่างขัดเงาหินด้วยเครื่องจักร | 使用机械的石材抛光机"
    },
    {
        "id":1065,
        "name":"711350  :  The Artist Carved The Letters Into Stone Shapes By Hand. | ช่างสลักหินเป็นรูปตัวอักษรด้วยมือ | 艺术家手工将字母雕刻成石头形状。"
    },
    {
        "id":1066,
        "name":"711355  :  Marble Carver By Hand (Acid) | ช่างสลักหินอ่อนด้วยมือ (น้ำกรด) | 手工大理石雕刻机（酸）"
    },
    {
        "id":1067,
        "name":"711360  :  Hand Carved Stone | ช่างแกะสลักหินด้วยมือ | 手工石雕"
    },
    {
        "id":1068,
        "name":"711390  :  Other Stone Cutters And Carvers | ช่างตัดและช่างแกะสลักหินอื่น ๆ | 其他石材切割师和雕刻师"
    },
    {
        "id":1069,
        "name":"712120  :  Construction Worker With Floor Materials | ช่างก่อสร้างด้วยวัสดุพื้น | 有地板材料的建筑工人"
    },
    {
        "id":1070,
        "name":"712220  :  Bricklayer (Construction) | ช่างก่ออิฐ (ก่อสร้าง) | 瓦工（建筑）"
    },
    {
        "id":1071,
        "name":"712225  :  Bricklayer (Refractory Brick) | ช่างก่ออิฐ (อิฐทนไฟ) | 砌砖工（耐火砖）"
    },
    {
        "id":1072,
        "name":"712230  :  Stone Mason (Construction) | ช่างก่อหิน (ก่อสร้าง) | 石匠（建筑）"
    },
    {
        "id":1073,
        "name":"712240  :  Pavement Paver | ช่างปูบาทวิถี | 路面摊铺机"
    },
    {
        "id":1074,
        "name":"712290  :  Bricklayers, Other Stonelayers | ช่างก่ออิฐ ช่างก่อหินอื่น ๆ | 瓦工、其他石工"
    },
    {
        "id":1075,
        "name":"712320  :  Concrete Formwork Maker | ช่างทำแบบหล่อคอนกรีต | 混凝土模板制造商"
    },
    {
        "id":1076,
        "name":"712330  :  Reinforced Concrete Bricklayer (Construction) | ช่างปูนคอนกรีตเสริมเหล็ก (การก่อสร้าง) | 钢筋混凝土砌砖工（建造）"
    },
    {
        "id":1077,
        "name":"712340  :  Concrete Surface Decorator | ช่างตกแต่งผิวคอนกรีต | 混凝土表面装饰剂"
    },
    {
        "id":1078,
        "name":"712390  :  Concrete Masons And Other Related Workers | ช่างปูนคอนกรีตและผู้ปฏิบัติงานที่เกี่ยวข้องอื่นๆ | 混凝土泥瓦匠及其他相关工人"
    },
    {
        "id":1079,
        "name":"712410  :  General Carpenter | ช่างไม้ทั่วไป | 普通木匠"
    },
    {
        "id":1080,
        "name":"712420  :  Carpenter Building | ช่างไม้ปลูกสร้าง | 木匠大楼"
    },
    {
        "id":1081,
        "name":"712430  :  Carpenter Building A Big Ship | ช่างไม้ต่อเรือใหญ่ | 建造一艘大船的木匠"
    },
    {
        "id":1082,
        "name":"712440  :  Small Boat Carpenter | ช่างไม้ต่อเรือเล็ก | 小船木匠"
    },
    {
        "id":1083,
        "name":"712450  :  Carpenter (Ships, Aircraft, Trains And Other Vehicles) | ช่างทำเครื่องไม้ (เรือ อากาศยาน รถไฟและยานพาหนะอื่นๆ) | 木匠（船舶、飞机、火车和其他车辆）"
    },
    {
        "id":1084,
        "name":"712490  :  Carpenters And Other Woodworkers | ช่างไม้และช่างทำเครื่องไม้อื่น ๆ | 木匠和其他木工"
    },
    {
        "id":1085,
        "name":"712920  :  Scaffolding Technician | ช่างยกตั้งนั่งร้าน | 脚手架技术员"
    },
    {
        "id":1086,
        "name":"712930  :  Demolition Technician (Building) | ช่างรื้อถอน (สิ่งก่อสร้าง) | 拆除技术员（建筑物）"
    },
    {
        "id":1087,
        "name":"713120  :  Roofer (Tiles And Similar Materials) | ช่างมุงหลังคา (กระเบื้องและวัสดุที่คล้ายคลึงกัน) | 屋顶工（瓷砖和类似材料）"
    },
    {
        "id":1088,
        "name":"713130  :  Roofer With Metal Sheets | ช่างมุงหลังคาด้วยแผ่นโลหะ | 有金属板的盖屋顶的人"
    },
    {
        "id":1089,
        "name":"713140  :  Roofing Technician Using Composite Materials Or Special Materials | ช่างมุงหลังคาด้วยวัสดุผสม หรือวัสดุพิเศษ | 使用复合材料的屋顶技术人员或特殊材料"
    },
    {
        "id":1090,
        "name":"713150  :  Roofing Technician From Natural Materials (Grass, Straw) | ช่างมุงหลังคาจากวัสดุธรรมชาติ (หญ้า ฟาง) | 天然材料（草、稻草）的屋顶技术人员"
    },
    {
        "id":1091,
        "name":"713190  :  Other Roofers | ช่างมุ่งหลังคาอื่น ๆ | 其他屋顶工"
    },
    {
        "id":1092,
        "name":"713210  :  Tiling Technician | ช่างปูกระเบื้อง | 瓷砖技师"
    },
    {
        "id":1093,
        "name":"713220  :  Marble Floor Paver | ช่างปูพื้นหินอ่อน | 大理石地板摊铺机"
    },
    {
        "id":1094,
        "name":"713230  :  Flooring Technician (Parquet) | ช่างปูพื้น (ไม้ปาร์เก้) | 地板技术员（镶木地板）"
    },
    {
        "id":1095,
        "name":"713240  :  The Floor Is Laid With Special Tiles. | ช่างปูพื้นด้วยกระเบื้องชนิดพิเศษ | 地板铺有特殊的瓷砖。"
    },
    {
        "id":1096,
        "name":"713290  :  Floor Paver And Other Tiling Plumbers | ช่างปูพื้น และ ช่างปูกระเบื้องอื่น ๆ | 地板摊铺机和其他瓷砖管道工"
    },
    {
        "id":1097,
        "name":"713310  :  Plasterer | ช่างฉาบปูน | 泥水匠"
    },
    {
        "id":1098,
        "name":"713320  :  Cement Plaster Artist | ช่างตบแต่งงานปูน | 水泥石膏艺术家"
    },
    {
        "id":1099,
        "name":"713330  :  Terrazzo Floor Technician | ช่างทำพื้นหินขัด | 水磨石地板技术员"
    },
    {
        "id":1100,
        "name":"713390  :  Other Plasterers | ช่างฉาบปูนอื่น ๆ | 其他抹灰工"
    },
    {
        "id":1101,
        "name":"713420  :  Insulation Installer (Sound) | ช่างติดตั้งฉนวน (เสียง) | 绝缘安装工（声音）"
    },
    {
        "id":1102,
        "name":"713430  :  Insulation Installer (Refrigeration Air Conditioner) | ช่างติดตั้งฉนวน (เครื่องทำความเย็น เครื่องปรับอากาศ) | 绝缘安装工（冷藏空调）"
    },
    {
        "id":1103,
        "name":"713440  :  Insulation Installer (Radiator And Pipe) | ช่างติดตั้งฉนวน (หม้อน้ำและท่อ) | 绝缘安装工（散热器和管道）"
    },
    {
        "id":1104,
        "name":"713490  :  Other Insulation Installers | ช่างติดตั้งฉนวนอื่น ๆ | 其他绝缘安装工"
    },
    {
        "id":1105,
        "name":"713520  :  Glass Installer (Building Construction), Glass Installer | ช่างติดกระจก (อาคารสิ่งก่อสร้าง) , ช่างติดตั้งกระจก | 玻璃安装工（建筑施工）、玻璃安装工"
    },
    {
        "id":1106,
        "name":"713530  :  Window Installer (Vehicle) , Window Installer (Vehicle) | ช่างติดกระจก (ยานพาหนะ) , ช่างติดบานกระจก (ยานพาหนะ) | 窗户安装工（车辆） , 窗户安装工（车辆）"
    },
    {
        "id":1107,
        "name":"713540  :  Special Glass Installer | ช่างติดกระจกชนิดพิเศษ | 特种玻璃安装工"
    },
    {
        "id":1108,
        "name":"713590  :  Other Glass Fitters | ช่างติดกระจกอื่น ๆ | 其他玻璃安装工"
    },
    {
        "id":1109,
        "name":"713610  :  General Pipe Installer For Building Work (Small Pipe) ; Pipe Repair Technician; Plumber | ช่างวางท่อทั่วไปสำหรับงานอาคาร (ท่อขนาดเล็ก) ; ช่างซ่อมท่อ ; ช่างประปา | 建筑工程通用管道安装工（小管）；管道维修技术员；水管工"
    },
    {
        "id":1110,
        "name":"713620  :  Pipe Fitter, Pipe Adjuster | ช่างประกอบท่อ , ช่างปรับท่อ | 管道安装工、管道调节工"
    },
    {
        "id":1111,
        "name":"713630  :  Sanitary Ware Installer | ช่างติดตั้งเครื่องสุขภัณฑ์ | 洁具安装工"
    },
    {
        "id":1112,
        "name":"713636  :  External Pipe Laying Technician (Large Pipes \/ Main Pipes) | ช่างวางท่อภายนอกอาคาร (ท่อขนาดใหญ่ \/ ท่อหลัก ) | 外部管道铺设技术人员（大管道\/主管）"
    },
    {
        "id":1113,
        "name":"713690  :  Pipe Fitters And Other Pipe Fitters | ช่างวางท่อและช่างปรับท่ออื่น ๆ | 管道安装工和其他管道安装工"
    },
    {
        "id":1114,
        "name":"713710  :  General Electrician | ช่างไฟฟ้าทั่วไป | 普通电工"
    },
    {
        "id":1115,
        "name":"713715  :  Building Electrician | ช่างไฟฟ้าประจำอาคาร | 建筑电工"
    },
    {
        "id":1116,
        "name":"713720  :  Aircraft Electrician | ช่างไฟฟ้าประจำอากาศยาน | 飞机电工"
    },
    {
        "id":1117,
        "name":"713730  :  Ship'S Electrician | ช่างไฟฟ้าประจำเรือ | 船舶电工"
    },
    {
        "id":1118,
        "name":"713740  :  Stage And Art Room Electrician | ช่างไฟฟ้าประจำเวทีและห้องศิลป์ | 舞台及美术室电工"
    },
    {
        "id":1119,
        "name":"713750  :  Maintenance Electrician | ช่างไฟฟ้าฝ่ายบำรุงรักษา | 维修电工"
    },
    {
        "id":1120,
        "name":"713790  :  Electricians And Other Electrical Connectors | ช่างไฟฟ้าและช่างต่อสายไฟอื่น ๆ | 电工和其他电气连接器"
    },
    {
        "id":1121,
        "name":"714120  :  Building Painter | ช่างทาสีอาคาร | 建筑油漆工"
    },
    {
        "id":1122,
        "name":"714130  :  Painter (Boat), Painter (Steel Frame And Hull) | ช่างทาสี (เรือ) , ช่างทาสี (โครงเหล็กกล้าและลำเรือ) | 油漆工（船）、油漆工（钢架和船体）"
    },
    {
        "id":1123,
        "name":"714140  :  Painter (Stage Scene) | ช่างทาสี (ฉากเวที) | 画家（舞台场景）"
    },
    {
        "id":1124,
        "name":"714150  :  Metal Painter | ช่างทาสีโลหะ | 金属画家"
    },
    {
        "id":1125,
        "name":"714160  :  Wall Paper Covering Technician, Wallpaper Technician | ช่างปิดกระดาษปุผนัง , ช่างวอลเปเปอร์ | 壁纸覆盖技术员、壁纸技术员"
    },
    {
        "id":1126,
        "name":"714190  :  Painters And Other Related Workers | ช่างทาสีและผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 油漆工及其他相关工人"
    },
    {
        "id":1127,
        "name":"714210  :  Painter With Brush (Products And Appliances) | ช่างทาสีด้วยแปรง (ผลิตภัณฑ์และเครื่องใช้) | 画家用画笔（产品及器具）"
    },
    {
        "id":1128,
        "name":"714215  :  Paint Spray Technician (Products And Equipment) | ช่างพ่นสี (ผลิตภัณฑ์และเครื่องใช้) | 喷漆技术员（产品及设备）"
    },
    {
        "id":1129,
        "name":"714220  :  Marker Painter | ช่างทาสีเครื่องหมาย | 马克笔画家"
    },
    {
        "id":1130,
        "name":"714230  :  Car Paint Technician, Car Paint Technician | ช่างพ่นสีรถยนต์ , ช่างสีรถยนต์ | 汽车喷漆技师、汽车喷漆技师"
    },
    {
        "id":1131,
        "name":"714240  :  The Painter Applied The Paint Using Hand Dipping. | ช่างเคลือบสีโดยใช้การจุ่มด้วยมือ | 画家采用手工蘸漆的方式涂漆。"
    },
    {
        "id":1132,
        "name":"714290  :  Coating Technicians And Other Related Workers | ช่างเคลือบผิวและผู้ปฏิบัติงานที่เกี่ยวข้องอื่นๆ | 涂装技术人员及其他相关人员"
    },
    {
        "id":1133,
        "name":"714320  :  Building Cleaner (External) | ผู้ทำความสะอาดอาคาร (ภายนอก) | 建筑清洁工（外部）"
    },
    {
        "id":1134,
        "name":"714330  :  Sand Blaster (Building), Cleaner | ผู้ฉีดพ่นทราย (อาคาร) , ทำความสะอาด | 喷砂机（建筑）、清洁工"
    },
    {
        "id":1135,
        "name":"714340  :  Termite, Ant, And Insect Exterminator | ผู้กำจัดปลวก มด แมลง | 白蚁、蚂蚁和昆虫消灭剂"
    },
    {
        "id":1136,
        "name":"714390  :  Other Building Structure Cleaners | ผู้ทำความสะอาดโครงสร้างอาคารสิ่งปลูกสร้างอื่น ๆ | 其他建筑结构清洁剂"
    },
    {
        "id":1137,
        "name":"721120  :  Hand-Made Metal Mold Maker, Metal Casting Maker | ช่างทำแบบหล่อโลหะด้วยมือ, ช่างกระสวนหล่อโลหะ | 手工金属模具制造商、金属铸造制造商"
    },
    {
        "id":1138,
        "name":"721130  :  Hand-Made Metal Mold Core Maker | ช่างทำแกนแบบหล่อโลหะด้วยมือ | 手工金属模具制芯机"
    },
    {
        "id":1139,
        "name":"721190  :  Metal Mold Makers And Other Metal Mold Core Makers | ช่างทำแบบหล่อโลหะและช่างทำแกนแบบหล่อโลหะอื่น ๆ | 金属模具制造商和其他金属模芯制造商"
    },
    {
        "id":1140,
        "name":"721220  :  Gas Metal Welder | ช่างเชื่อมโลหะด้วยแก๊ซ | 气体金属焊机"
    },
    {
        "id":1141,
        "name":"721230  :  Electric Metal Welder | ช่างเชื่อมโลหะด้วยไฟฟ้า | 金属电焊机"
    },
    {
        "id":1142,
        "name":"721240  :  Welder And Cut Various Types Of Metal (Tig, Mig, X - Ray, Flux Cored Arc) | ช่างเชื่อมและตัดโลหะแบบต่าง ๆ (แบบ Tig , Mig , X - ray , Flux cored arc ) | 焊接和切割各种类型的金属（Tig、Mig、X 射线、药芯焊丝电弧）"
    },
    {
        "id":1143,
        "name":"721290  :  Other Flame Welders And Metal Cutters | ช่างเชื่อมและตัดโลหะด้วยเปลวไฟอื่น ๆ | 其他火焰焊机和金属切割机"
    },
    {
        "id":1144,
        "name":"721310  :  General Sheet Metal Worker | ช่างโลหะแผ่นทั่วไป | 普通钣金工"
    },
    {
        "id":1145,
        "name":"721320  :  Sheet Metal Technician (Vehicle) | ช่างโลหะแผ่น (ยานพาหนะ) | 钣金技师（车辆）"
    },
    {
        "id":1146,
        "name":"721325  :  Auto Body Repair Technician; Car Paint Sprayer | ช่างซ่อมตัวถังรถยนต์ ; ช่างเคาะพ่นสีรถยนต์ | 汽车车身维修技师；汽车喷漆机"
    },
    {
        "id":1147,
        "name":"721330  :  Sheet Metal Technician (Furniture) | ช่างโลหะแผ่น (เครื่องเรือน) | 钣金技师（家具方向）"
    },
    {
        "id":1148,
        "name":"721340  :  Metal Product Repair Technician (Tin Technician, Solder Technician, Copper Technician) | ช่างซ่อมผลิตภัณฑ์โลหะ (ช่างดีบุก , ช่างบัดกรี, ช่างทองแดง) | 金属制品维修技师（锡技师、焊锡技师、铜技师）"
    },
    {
        "id":1149,
        "name":"721350  :  Metal Worker (Jewelry) | ช่างโลหะ (เครื่องประดับ) | 金属工（珠宝）"
    },
    {
        "id":1150,
        "name":"721390  :  Other Sheet Metal Workers | ช่างโลหะแผ่นอื่น ๆ | 其他钣金工"
    },
    {
        "id":1151,
        "name":"721410  :  Metal Worker, Metal Marking Technician | ช่างทำโลหะนำ , ช่างทำเครื่องหมายบนโลหะ | 金属工人、金属打标技术员"
    },
    {
        "id":1152,
        "name":"721420  :  Metal Structure Installer And Assembler; Steel Frame Construction Worker | ช่างติดตั้งและประกอบโครงสร้างโลหะ; ช่างก่อสร้างโครงเหล็ก | 金属结构安装工和装配工；钢架建筑工人"
    },
    {
        "id":1153,
        "name":"721425  :  Worker Making Steel Frames In A Factory | ช่างทำโครงเหล็กในโรงงาน | 工人在工厂制作钢架"
    },
    {
        "id":1154,
        "name":"721430  :  Technician Rivets Metal Structures With An Air Hammer. | ช่างย้ำหมุดงานโครงสร้างโลหะด้วยค้อนลม | 技术人员用气锤铆接金属结构。"
    },
    {
        "id":1155,
        "name":"721435  :  Manual Riveter (Metal Structure Work) | ช่างย้ำหมุดด้วยมือ (งานโครงส้รางโลหะ) | 手动铆接机（金属结构工程）"
    },
    {
        "id":1156,
        "name":"721440  :  Shipbuilder (Metal) | ช่างต่อเรือ (โลหะ) | 造船厂（金属）"
    },
    {
        "id":1157,
        "name":"721445  :  Boat Steel Sheet Maker | ช่างทำแผ่นเหล็กตัวเรือ | 船用钢板制造商"
    },
    {
        "id":1158,
        "name":"721450  :  Boiler Installer | ช่างติดตั้งหม้อน้ำ | 锅炉安装工"
    },
    {
        "id":1159,
        "name":"721460  :  Aluminum Technician | ช่างอลูมิเนียม | 铝材技术员"
    },
    {
        "id":1160,
        "name":"721465  :  Steel Plate Bender | ช่างดัดแผ่นเหล็กกล้า | 钢板折弯机"
    },
    {
        "id":1161,
        "name":"721490  :  Technician Prepares And Sets Up Other Metal Structures. | ช่างเตรียมและตั้งโครงสร้างโลหะอื่น ๆ | 技术人员准备并安装其他金属结构。"
    },
    {
        "id":1162,
        "name":"721510  :  General Lifting Equipment Installer | ช่างติดตั้งเครื่องยกทั่วไป | 一般起重设备安装工"
    },
    {
        "id":1163,
        "name":"721520  :  Cable Installer, Rope And Cable Cutter | ช่างติดตั้งสายเคเบิ้ล , ช่างฟั่นต่อเชือกและสายเคเบิ้ล | 电缆安装器、绳索和电缆剪"
    },
    {
        "id":1164,
        "name":"721530  :  Technician Installs Equipment (Ropes, Wires, Cables) On Boats. | ช่างติดตั้งเครื่องประกอบ (เชือก ลวด สายเคเบิ้ล) ในเรือ | 技术人员在船上安装设备（绳索、电线、电缆）。"
    },
    {
        "id":1165,
        "name":"721540  :  Lifting Machine Installer (Construction) | ช่างติดตั้งเครื่องยก (การก่อสร้าง) | 起重机械安装工（建造）"
    },
    {
        "id":1166,
        "name":"721550  :  Drilling Machine Installer (Oil Well Drilling) | ผู้ติดตั้งเครื่องเจาะ (การเจาะบ่อน้ำมัน) | 钻孔机安装工（油井钻探）"
    },
    {
        "id":1167,
        "name":"721590  :  Hoist Installers And Other Cable Splicers | ช่างติดตั้งเครื่องยกและผู้ฟั่นต่อสายเคเบิ้ลอื่น ๆ | 提升机安装工和其他电缆接合工"
    },
    {
        "id":1168,
        "name":"721620  :  Diver, Underwater Rescuer | นักประดาน้ำ , ผู้กู้ภัยใต้น้ำ | 潜水员、水下救援人员"
    },
    {
        "id":1169,
        "name":"721630  :  Underwater Worker (Construction And Maintenance Of Ports And Shipyards) | ผู้ปฏิบัติงานใต้น้ำ (ก่อสร้างและบำรุงรักษาท่าเรือและอู่เรือ) | 水下工人（港口、造船厂的建设、维护）"
    },
    {
        "id":1170,
        "name":"722120  :  Ironworker, Ironworker | ช่างเหล็ก , ช่างผูกเหล็ก | 炼铁工，炼铁工"
    },
    {
        "id":1171,
        "name":"722130  :  Blacksmith | คนตีเหล็ก | 铁匠"
    },
    {
        "id":1172,
        "name":"722140  :  Steel Cutter | ช่างตัดเหล็ก | 钢刀"
    },
    {
        "id":1173,
        "name":"722150  :  Metal Pressing Worker, Metal Rolling Worker | ช่างอัดบีบโลหะ, ช่างรีดโลหะ | 金属冲压工、金属轧制工"
    },
    {
        "id":1174,
        "name":"722160  :  Metal Crusher Worker | พนักงานเครื่องทุบอัดโลหะ | 金属破碎机工人"
    },
    {
        "id":1175,
        "name":"722190  :  Blacksmiths, Blacksmiths, And Other Metal Press Workers | ช่างเหล็ก ช่างตีเหล็ก และพนักงานเครื่องทุบอัดโลหะอื่น ๆ | 铁匠、铁匠和其他金属冲压工人"
    },
    {
        "id":1176,
        "name":"722210  :  General Tool Maker (Metal Work) | ช่างทำเครื่องมือทั่วไป (งานโลหะ) | 通用工具制造商（金属加工）"
    },
    {
        "id":1177,
        "name":"722220  :  Locksmith | ช่างทำกุญแจ | 锁匠"
    },
    {
        "id":1178,
        "name":"722230  :  Firearms Maker | ช่างทำอาวุธปืน | 枪械制造商"
    },
    {
        "id":1179,
        "name":"722240  :  Bullet Maker | ช่างทำกระสุน | 子弹制造者"
    },
    {
        "id":1180,
        "name":"722260  :  Mold Maker (Metal) | ช่างทำแม่พิมพ์ (โลหะ) | 模具制造商（金属）"
    },
    {
        "id":1181,
        "name":"722290  :  Tool Makers And Other Related Workers | ช่างทำเครื่องมือและผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 工具制造商和其他相关工人"
    },
    {
        "id":1182,
        "name":"722310  :  Mechanic Who Adjusts And Uses Machine Tools (General Metal Work) | ช่างปรับตั้งและใช้เครื่องมือกล (งานโลหะทั่วไป) | 调整和使用机床的机械师（一般金属制品）"
    },
    {
        "id":1183,
        "name":"722320  :  Technician Adjusting And Using A Lathe (Metal Work) | ช่างปรับตั้งและใช้เครื่องกลึง (งานโลหะ) | 技术员调整和使用车床（金属加工）"
    },
    {
        "id":1184,
        "name":"722330  :  Technician Adjusting And Using Drilling Machines (Metal Work) | ช่างปรับตั้งและใช้เครื่องเจาะ (งานโลหะ) | 技术员调整和使用钻床（金属加工）"
    },
    {
        "id":1185,
        "name":"722340  :  Technician Adjusting And Using A Saw (Metal Work) | ช่างปรับตั้งและใช้เครื่องเลื่อย(งานโลหะ) | 技术员调整和使用锯（金属加工）"
    },
    {
        "id":1186,
        "name":"722350  :  Technician Adjusting And Using Planers (Metal Work) | ช่างปรับตั้งและใช้เครื่องไส (งานโลหะ) | 技术员调整和使用刨床（金属加工）"
    },
    {
        "id":1187,
        "name":"722360  :  Technician Adjusting And Using A Winch (Metal Work) | ช่างปรับตั้งและใช้เครื่องกว้าน (งานโลหะ) | 技术员调整和使用绞车（金属加工）"
    },
    {
        "id":1188,
        "name":"722370  :  Technician Sets Up And Uses A Gear Cutting Machine. | ช่างตั้งและใช้เครื่องตัดเฟือง | 技术人员安装并使用齿轮切削机床。"
    },
    {
        "id":1189,
        "name":"722390  :  Mechanic Adjusts And Uses Other Mechanical Tools. | ช่างปรับตั้งและใช้เครื่องมือกลอื่น ๆ | 机械师调整和使用其他机械工具。"
    },
    {
        "id":1190,
        "name":"722420  :  Metal Grinder, Grinder Operator | ช่างเจียระไนโลหะ , พนักงานเครื่องเจียระไน | 金属磨床、磨床操作员"
    },
    {
        "id":1191,
        "name":"722430  :  Cylinder Polishing Machine Operator | พนักงานเครื่องขัดมันกระบอกสูบ | 圆筒抛光机操作工"
    },
    {
        "id":1192,
        "name":"722440  :  Metal Polisher, Polishing Machine Operator | ช่างขัดผิวโลหะ , พนักงานเครื่องขัดเงา | 金属抛光工、抛光机操作员"
    },
    {
        "id":1193,
        "name":"722450  :  Machine Tool Sharpener | ช่างลับเครื่องมือกล | 机床磨刀机"
    },
    {
        "id":1194,
        "name":"722460  :  Saw Sharpener, Saw Repairman | ช่างลับเลื่อย, ช่างซ่อมเลื่อย | 修锯工、修锯工"
    },
    {
        "id":1195,
        "name":"722470  :  Cutting Tool Sharpener (Except Mechanical) | ช่างลับเครื่องมือตัด (ยกเว้นเครื่องกล) | 切削工具磨刀器（机械除外）"
    },
    {
        "id":1196,
        "name":"722490  :  Metal Cutter Metal Polishers And Other Tool Sharpeners | ช่างเจียระไนโลหะ ช่างขัดเงาโลหะ และ ช่างลับเครื่องมืออื่นๆ | 金属刀具金属抛光机和其他工具磨刀机"
    },
    {
        "id":1197,
        "name":"723120  :  Engine Tuner; Engine Fitter ;Automotive Repair Technician | ช่างปรับแต่งเครื่องยนต์ ; ช่างฟิตเครื่องยนต์ ;ช่างซ่อมยานยนต์ | 发动机调谐器；发动机装配工;汽车维修技师"
    },
    {
        "id":1198,
        "name":"723130  :  Motorcycle Mechanic | ช่างซ่อมจักรยานยนต์ | 摩托车修理工"
    },
    {
        "id":1199,
        "name":"723190  :  Mechanic And Other Automotive Repair Technicians | ช่างซ่อมเครื่องจักรกลและยานยนต์อื่น ๆ | 机械师和其他汽车维修技术人员"
    },
    {
        "id":1200,
        "name":"723220  :  Aircraft Technician (Engines, Instruments, And Equipment); Aircraft Mechanical Repair Technician; Engine Repair Technician (Aircraft) ; Aircraft Fitter | ช่างเทคนิคอากาศยาน (เครื่องยนต์ เครื่องวัด และอุปกรณ์) ; ช่างซ่อมเครื่องจักรกลอากาศยาน ; ช่างซ่อมปรับแต่งเครื่องยนต์ (อากาศยาน) ; ช่างฟิตอากาศยาน | 飞机技术员（发动机、仪器和设备）；飞机机械维修技师；发动机维修技师（飞机）；飞机装配工"
    },
    {
        "id":1201,
        "name":"723310  :  General Machinery Repair And Adjustment Technician | ช่างซ่อมและปรับแต่งเครื่องจักรกลทั่วไป | 通用机械维修调整技术员"
    },
    {
        "id":1202,
        "name":"723320  :  Machinery Repair And Adjustment Technician (Mining) | ช่างซ่อมและปรับแต่งเครื่องจักรกล (เหมืองแร่) | 机械维修与调整技术员（采矿）"
    },
    {
        "id":1203,
        "name":"723330  :  Machinery Repair And Adjustment Technician (Textile, Knitted Items) | ช่างซ่อมและปรับแต่งเครื่องจักรกล (สิ่งทอ , สิ่งถัก) | 机械维修和调整技术员（纺织、针织品）"
    },
    {
        "id":1204,
        "name":"723340  :  Mechanical Repair And Adjustment Technician (Agricultural) | ช่างซ่อมและปรับแต่งเครื่องจักรกล (ทางเกษตรกรรม) | 机械修理和调整技术员（农业）"
    },
    {
        "id":1205,
        "name":"723350  :  Mechanical Repair And Adjustment Technician (Manufacturing Industry) | ช่างซ่อมและปรับแต่งเครื่องจักรกล (ทางอุตสาหกรรมการผลิต) | 机械修理和调整技术员（制造业）"
    },
    {
        "id":1206,
        "name":"723360  :  Mechanical Repair Technician (Road Construction) | ช่างซ่อมเครื่องจักรกล (ก่อสร้างถนน) | 机械维修技术员（道路建设）"
    },
    {
        "id":1207,
        "name":"723370  :  Mechanical Repair Technician (Ship Engine) | ช่างซ่อมเครื่องจักรกล (เครื่องยนต์เรือ) | 机械维修技术员（船舶发动机）"
    },
    {
        "id":1208,
        "name":"723380  :  Oil And Grease Workers (Engines And Machinery) | พนักงานหยอดน้ำมันและอัดจาระบี (เครื่องยนต์และเครื่องจักร) | 石油和油脂工人（发动机和机械）"
    },
    {
        "id":1209,
        "name":"723390  :  Mechanics And Adjusters Of Agricultural Machinery Or Other Industries | ช่างเครื่องและช่างปรับแต่งเครื่องจักรกลทางการเกษตรหรือ อุตสาหกรรมอื่น ๆ | 农业机械的机械师和调节器或其他行业"
    },
    {
        "id":1210,
        "name":"724110  :  General Electrician | ช่างปรับไฟฟ้าทั่วไป | 普通电工"
    },
    {
        "id":1211,
        "name":"724120  :  Electrical Adjuster (Electrical Power Equipment) | ช่างปรับไฟฟ้า (อุปกรณ์ไฟฟ้ากำลัง) | 电动调节器（电力设备）"
    },
    {
        "id":1212,
        "name":"724125  :  Electrical Technician (Electricity) | ช่างปรับไฟฟ้า (กระแสไฟฟ้า) | 电气技术员（电力）"
    },
    {
        "id":1213,
        "name":"724130  :  Electrical Adjuster (Power Tools) | ช่างปรับไฟฟ้า (เครื่องมือไฟฟ้า) | 电动调节器（电动工具）"
    },
    {
        "id":1214,
        "name":"724140  :  Electrical Adjuster (Office Machinery) | ช่างปรับไฟฟ้า (เครื่องจักรกลสำนักงาน) | 电动调节器（办公机械）"
    },
    {
        "id":1215,
        "name":"724145  :  Electrical Adjuster (Signal Light System) | ช่างปรับไฟฟ้า (ระบบไฟสัญญาณ) | 电动调节器（信号灯系统）"
    },
    {
        "id":1216,
        "name":"724150  :  Electrical Technician (Automotive) | ช่างปรับไฟฟ้า (ยานยนต์) | 电气技术员（汽车方向）"
    },
    {
        "id":1217,
        "name":"724155  :  Electrical Adjuster (Elevators And Related Equipment) | ช่างปรับไฟฟ้า (ลิฟท์และอุปกรณ์ที่เกี่ยวข้องกัน) | 电动调节器（电梯及相关设备）"
    },
    {
        "id":1218,
        "name":"724160  :  Electrical Adjuster (Refrigeration And Air Equipment) | ช่างปรับไฟฟ้า (อุปกรณ์ทำความเย็นและอากาศ) | 电动调节器（制冷及空气设备）"
    },
    {
        "id":1219,
        "name":"724165  :  Electrical Adjuster (Household Appliances) | ช่างปรับไฟฟ้า (เครื่องใช้ในบ้านเรือน) | 电动调节器（家用电器）"
    },
    {
        "id":1220,
        "name":"724190  :  Other Electrical Technicians | ช่างปรับไฟฟ้าอื่น ๆ | 其他电气技术人员"
    },
    {
        "id":1221,
        "name":"724210  :  General Electronics Adjuster | ช่างปรับอิเล็กทรอนิกส์ทั่วไป | 通用电子调节器"
    },
    {
        "id":1222,
        "name":"724220  :  Electronic Adjuster (Radio And Television Transmitter) | ช่างปรับอิเล็กทรอนิกส์ (เครื่องส่งวิทยุโทรทัศน์) | 电子调节器（广播电视发射机）"
    },
    {
        "id":1223,
        "name":"724230  :  Electronic Adjuster (Medical Equipment) | ช่างปรับอิเล็กทรอนิกส์ (อุปกรณ์ทางการแพทย์) | 电子调节器（医疗设备）"
    },
    {
        "id":1224,
        "name":"724240  :  Electronic Adjuster (Industrial Equipment) | ช่างปรับอิเล็กทรอนิกส์ (อุปกรณ์ทางอุตสาหกรรม) | 电子调节器（工业设备）"
    },
    {
        "id":1225,
        "name":"724250  :  Electronic Adjuster (Telecommunications Equipment) | ช่างปรับอิเล็กทรอนิกส์ (อุปกรณ์โทรคมนาคม) | 电子调节器（电信设备）"
    },
    {
        "id":1226,
        "name":"724260  :  Electronic Adjuster (Computer) | ช่างปรับอิเล็กทรอนิกส์ (คอมพิวเตอร์) | 电子调节器（电脑）"
    },
    {
        "id":1227,
        "name":"724270  :  Electronic Adjuster (Office Machinery) | ช่างปรับอิเล็กทรอนิกส์ (เครื่องจักรกลสำนักงาน) | 电子调节器（办公机械）"
    },
    {
        "id":1228,
        "name":"724290  :  Other Electronic Equipment Customizer | ช่างปรับแต่งอุปกรณ์อิเล็กทรอนิกส์อื่น ๆ | 其他电子设备定制商"
    },
    {
        "id":1229,
        "name":"724320  :  Electronics Mechanic, Electronics Repair Technician | ช่างเครื่องอิเล็กทรอนิกส์ , ช่างซ่อมเครื่องอิเล็กทรอนิกส์ | 电子机械师、电子维修技师"
    },
    {
        "id":1230,
        "name":"724325  :  Electronics Repair Technician (Office Equipment) | ช่างซ่อมเครื่องอิเล็กทรอนิกส์ (เครื่องใช้ในสำนักงาน) | 电子维修技师（办公设备）"
    },
    {
        "id":1231,
        "name":"724330  :  Radio And Television Repair Technician | ช่างซ่อมวิทยุและโทรทัศน์ | 广播电视维修技师"
    },
    {
        "id":1232,
        "name":"724340  :  Movie Projector Repair Technician | ช่างซ่อมเครื่องฉายภาพยนตร์ | 电影放映机维修技术员"
    },
    {
        "id":1233,
        "name":"724350  :  Antenna Installation Technician (Radio\/Television) | ช่างซ่อมติดตั้งเสาอากาศ (วิทยุ\/โทรทัศน์) | 天线安装技术员（广播\/电视）"
    },
    {
        "id":1234,
        "name":"724420  :  Telephone And Telegraph Installer | ช่างติดตั้งโทรศัพท์และโทรเลข | 电话和电报安装工"
    },
    {
        "id":1235,
        "name":"724430  :  Telephone And Telegraph Repair Technician | ช่างซ่อมเครื่องโทรศัพท์และโทรเลข | 电话和电报维修技术员"
    },
    {
        "id":1236,
        "name":"724520  :  Wiring Technician (Electrical Power) | ช่างวางสายไฟ (ไฟฟ้ากำลัง ) | 布线技术员（电力）"
    },
    {
        "id":1237,
        "name":"724530  :  Cable Welder, Electrical Cable Installer | ช่างต่อเชื่อมสายเคเบิ้ล , ช่างวางสายเคเบิ้ล ไฟฟ้า | 电缆焊工、电缆安装工"
    },
    {
        "id":1238,
        "name":"724540  :  Plumbing Technician (Telephone, Telegraph Lines); The Technician Hung Up The Phone. | ช่างวางท่อ (โทรศัพท์ , สายโทรเลข) ; ช่างวางสาย | 管道技术员（电话、电报线）；技术人员挂断了电话。"
    },
    {
        "id":1239,
        "name":"724590  :  Electrical Cable Fitters And Other Electrical Cable Fitters | ช่างวางสายไฟและช่างต่อสายเคเบิ้ลไฟฟ้าอื่น ๆ | 电缆安装工和其他电缆安装工"
    },
    {
        "id":1240,
        "name":"731120  :  Medical Equipment Technician | ช่างเครื่องมืออุปกรณ์ทางการแพทย์ | 医疗设备技术员"
    },
    {
        "id":1241,
        "name":"731125  :  Dental Technician (Denture), Dental Technician, Dental Technician | ช่างทำฟัน (ปลอม) , ช่างทันตกรรม , ช่างด้านฟัน | 牙科技师（假牙）、牙科技师、牙科技师"
    },
    {
        "id":1242,
        "name":"731130  :  Technician Who Makes Prosthetic Arms And Legs (Devices To Assist With Disabilities) | ช่างทำอุปกรณ์แขน - ขาเทียม (อุปกรณ์ช่วยความพิการ) | 制造假肢的技术人员（帮助残疾人的设备）"
    },
    {
        "id":1243,
        "name":"731140  :  Watchmaker ; Watch Repairman | ช่างทำนาฬิกา ; ช่างซ่อมนาฬิกา | 钟表匠;手表修理工"
    },
    {
        "id":1244,
        "name":"731150  :  Meteorological Precision Measuring Instrument Technician | ช่างเครื่องมือวัดที่มีความเที่ยงตรงทางอุตุนิยมวิทยา | 气象精密测量仪器技术员"
    },
    {
        "id":1245,
        "name":"731190  :  Mechanic Of Tools And Other Precision Equipment | ช่างเครื่องมือและอุปกรณ์ที่มีความเที่ยงตรงแม่นยำอื่น ๆ | 工具和其他精密设备机械师"
    },
    {
        "id":1246,
        "name":"731220  :  Musical Instrument Maker (Stringed Instruments) | ช่างทำเครื่องดนตรี (เครื่องสาย) | 乐器制造商（弦乐器）"
    },
    {
        "id":1247,
        "name":"731230  :  Musical Instrument Maker (Wooden Dryer) | ช่างทำเครื่องดนตรี (เครื่องเป่าที่ทำด้วยไม้) | 乐器制造商（木制烘干机）"
    },
    {
        "id":1248,
        "name":"731240  :  Musical Instrument Maker (Metal Dryer) | ช่างทำเครื่องดนตรี (เครื่องเป่าจากโลหะ) | 乐器制造商（金属干燥机）"
    },
    {
        "id":1249,
        "name":"731250  :  Piano Tuner | ช่างปรับเสียงเปียโน | 钢琴调音师"
    },
    {
        "id":1250,
        "name":"731290  :  Musical Instrument Makers And Other Music Tuners | ช่างทำเครื่องดนตรีและช่างปรับเสียงดนตรีอื่น ๆ | 乐器制造商和其他音乐调音师"
    },
    {
        "id":1251,
        "name":"731310  :  General Jeweler | ช่างเพชรพลอยทั่วไป | 一般珠宝商"
    },
    {
        "id":1252,
        "name":"731320  :  A Technician Makes A Prototype Of A Body Using Wax (Candle). | ช่างทำต้นแบบตัวเรือนด้วยขี้ผึ้ง (เทียน) | 技术人员使用蜡（蜡烛）制作人体原型。"
    },
    {
        "id":1253,
        "name":"731322  :  Metal Case Prototype Maker | ช่างทำต้นแบบตัวเรือนด้วยโลหะ | 金属外壳原型制造商"
    },
    {
        "id":1254,
        "name":"731325  :  Body Casting Technician | ช่างหล่อตัวเรือน | 车身铸造技术员"
    },
    {
        "id":1255,
        "name":"731326  :  Rubber Mold Maker | ช่างทำแม่พิมพ์ยาง | 橡胶模具制造商"
    },
    {
        "id":1256,
        "name":"731328  :  Wax Injection Technician (Candle) Candle Technician (Wax) | ช่างฉีดขี้ผึ้ง (เทียน) ช่างเทียน ( Wax) | 喷蜡技术员（蜡烛） 蜡烛技术员（蜡）"
    },
    {
        "id":1257,
        "name":"731330  :  The Implanter | ช่างฝัง | 植入者"
    },
    {
        "id":1258,
        "name":"731335  :  House Polisher | ช่างขัดตกแต่งตัวเรือน | 家用抛光机"
    },
    {
        "id":1259,
        "name":"731340  :  Gem Cutter | ช่างตัดพลอย | 宝石切割机"
    },
    {
        "id":1260,
        "name":"731341  :  Stir The Gems With A Machine (Gem Block Technician) | ช่างโกลนพลอยด้วยเครื่อง (ช่างบล๊อกพลอย) | 用机器搅拌宝石（宝石块技术员）"
    },
    {
        "id":1261,
        "name":"731342  :  Gem Cutter | ช่างตัดเหลี่ยมพลอย | 宝石切割机"
    },
    {
        "id":1262,
        "name":"731343  :  Gem Polisher | ช่างขัดเงาพลอย | 宝石抛光机"
    },
    {
        "id":1263,
        "name":"731345  :  Diamond Cutter | ช่างเจียระไนเพชร | 金刚石刀具"
    },
    {
        "id":1264,
        "name":"731346  :  Diamond Saw Technician (Sawing) | ช่างเลื่อยเพชร (Sawing) | 金刚石锯技术员（锯切）"
    },
    {
        "id":1265,
        "name":"731347  :  Chang Khon Phet (Bruting) | ช่างโกลนเพชร (Bruting) | Chang Khon Phet（布鲁廷）"
    },
    {
        "id":1266,
        "name":"731348  :  Diamond Stirrup Technician With Automatic Machine | ช่างโกลนเพชรด้วยเครื่องอัตโนมัติ | 带自动机器的金刚石马镫技术员"
    },
    {
        "id":1267,
        "name":"731350  :  Silversmith Goldsmith | ช่างเงิน ช่างทอง | 银匠 金匠"
    },
    {
        "id":1268,
        "name":"731355  :  Silver\/Gold Knitter | ช่างถักเงิน\/ทอง | 银\/金针织机"
    },
    {
        "id":1269,
        "name":"731359  :  Gold And Silver Smith (Flame) | ช่างตีทองและเงิน (เปลว) | 金银匠（火焰）"
    },
    {
        "id":1270,
        "name":"731360  :  General Metal Plating And Coating Technician | ช่างชุบและเคลือบโลหะทั่วไป | 普通金属电镀及涂装技术员"
    },
    {
        "id":1271,
        "name":"731365  :  The Metal Is Plated By Hand. | ผู้ชุบโลหะโดยการจุ่มด้วยมือ | 金属是手工电镀的。"
    },
    {
        "id":1272,
        "name":"731370  :  House Dresser | ช่างแต่งตัวเรือน | 家居梳妆台"
    },
    {
        "id":1273,
        "name":"731375  :  House Decorator | ช่างแต่งประกอบตัวเรือน | 房屋装修师"
    },
    {
        "id":1274,
        "name":"731376  :  Gem And Jewelry Repair Technician | ช่างซ่อมอัญมณีและเครื่องประดับ | 宝石和珠宝修复技师"
    },
    {
        "id":1275,
        "name":"731380  :  Filling Machine Maker | ช่างทำเครื่องถม | 灌装机制造商"
    },
    {
        "id":1276,
        "name":"731385  :  Lacquer Maker | ช่างทำเครื่องเขิน | 漆工"
    },
    {
        "id":1277,
        "name":"731390  :  Jewelers And Other Jewelry Makers | ช่างอัญมณีและช่างประดิษฐ์เครื่องประดับอื่น ๆ | 珠宝商和其他珠宝制造商"
    },
    {
        "id":1278,
        "name":"732110  :  Pottery Technician | ช่างเครื่องดินเผา | 陶艺技师"
    },
    {
        "id":1279,
        "name":"732115  :  Pottery Mold Maker | ช่างทำแบบพิมพ์เครื่องดินเผา | 陶器模具制造商"
    },
    {
        "id":1280,
        "name":"732120  :  Sculptor With A Dial (Terracotta) | ช่างปั้นด้วยแป้นหมุน (เครื่องดินเผา) | 有表盘的雕刻家（红陶）"
    },
    {
        "id":1281,
        "name":"732125  :  Sculptor With Jigger (Terracotta) | ช่างปั้นด้วยจิกเกอร์ (เครื่องดินเผา) | 有跳汰机的雕塑家（红陶）"
    },
    {
        "id":1282,
        "name":"732130  :  Technician Turning Pottery Using A Lathe | ช่างกลึงเครื่องดินเผาด้วยเครื่องกลึง | 技术人员使用车床车削陶器"
    },
    {
        "id":1283,
        "name":"732135  :  Slip Casting Technician | ช่างหล่อสลิป | 粉浆浇注技术员"
    },
    {
        "id":1284,
        "name":"732140  :  A Brick Maker Makes Bricks From Molds By Hand. | ช่างทำอิฐจากแบบพิมพ์ด้วยมือ | 制砖师用模具手工制作砖块。"
    },
    {
        "id":1285,
        "name":"732145  :  A Technician Makes Firebricks From Molds By Hand. | ช่างทำอิฐทนไฟจากแบบพิมพ์ด้วยมือ | 技术人员用模具手工制作耐火砖。"
    },
    {
        "id":1286,
        "name":"732150  :  The Artist Makes Tiles From Molds By Hand. | ช่างทำกระเบื้องจากแบบพิมพ์ด้วยมือ | 艺术家用模具手工制作瓷砖。"
    },
    {
        "id":1287,
        "name":"732160  :  Hand Pressed Clay Pottery | ช่างอัดเครื่องดินเผาด้วยมือ | 手压粘土陶器"
    },
    {
        "id":1288,
        "name":"732165  :  Tile Press By Hand | ช่างอัดกระเบื้องด้วยมือ | 手动压砖机"
    },
    {
        "id":1289,
        "name":"732170  :  Technician Shapes Products By Rolling Clay. | ช่างขึ้นรูปผลิตภัณฑ์โดยการรีดดิน | 技术人员通过滚动粘土来塑造产品。"
    },
    {
        "id":1290,
        "name":"732190  :  Other Pottery Technicians | ช่างเครื่องดินเผาอื่น ๆ | 其他陶艺技师"
    },
    {
        "id":1291,
        "name":"732220  :  Glass Blower | ช่างเป่าแก้ว | 玻璃吹制机"
    },
    {
        "id":1292,
        "name":"732230  :  Glass Tube Cutter Neon Tube Cutter | ช่างตัดหลอดแก้ว ช่างตัดหลอดนีออน | 玻璃管切割机霓虹灯管切割机"
    },
    {
        "id":1293,
        "name":"732240  :  Glass Cutter | ช่างตัดกระจก | 玻璃切割机"
    },
    {
        "id":1294,
        "name":"732250  :  Technician Who Grinds Or Grinds Glass Edges | ช่างฝนหรือเจียรขอบกระจก | 打磨或打磨玻璃边缘的技术人员"
    },
    {
        "id":1295,
        "name":"732260  :  Glass Polisher | ช่างขัดฝ้ากระจก | 玻璃抛光机"
    },
    {
        "id":1296,
        "name":"732270  :  Glass Press By Hand, Glass Press Worker | ช่างอัดแก้วด้วยมือ ช่างปั๊มแก้ว | 手工玻璃压机，玻璃压机工"
    },
    {
        "id":1297,
        "name":"732290  :  Formers, Cutters, Molders And Other Glass Decorators. | ช่างขึ้นรูป ช่างตัด ช่างฝนและช่างตกแต่งแก้วอื่น ๆ | 成型工、切割工、模制工和其他玻璃装饰工。"
    },
    {
        "id":1298,
        "name":"732320  :  Glass Cutter | ช่างเจียระไนแก้ว | 玻璃切割机"
    },
    {
        "id":1299,
        "name":"732330  :  Technician Etching Glass With Acid | ช่างกัดลายแก้วด้วยน้ำกรด | 技术人员用酸蚀刻玻璃"
    },
    {
        "id":1300,
        "name":"732390  :  Glass Cutters And Glass Etchers Using Other Acids | ช่างเจียระไนแก้วและช่างกัดลายแก้วด้วยน้ำกรดอื่น ๆ | 使用其他酸的玻璃切割机和玻璃蚀刻机"
    },
    {
        "id":1301,
        "name":"732420  :  Mirror Floor Plaster Technician | ช่างฉาบพื้นกระจกเงา | 镜面地板抹灰技师"
    },
    {
        "id":1302,
        "name":"732430  :  Silver Mirror Maker | ช่างทำกระจกเงาด้วยสารเงิน | 银镜制造商"
    },
    {
        "id":1303,
        "name":"732435  :  A Technician Who Makes Mirrors Or Glass Into Frosted Patterns. | ช่างทำกระจกหรือแก้วให้เป็นลายฝ้า | 将镜子或玻璃制作成磨砂图案的技术人员。"
    },
    {
        "id":1304,
        "name":"732440  :  Glass Printer | ช่างพิมพ์แก้ว | 玻璃打印机"
    },
    {
        "id":1305,
        "name":"732450  :  Artist Paints Pottery Patterns By Hand | ช่างเขียนลายเครื่องดินเผาด้วยมือ | 艺术家手工绘制陶器图案"
    },
    {
        "id":1306,
        "name":"732460  :  Pottery Painter | ช่างพ่นสีเครื่องดินเผา | 陶艺师"
    },
    {
        "id":1307,
        "name":"732470  :  Pottery Plated By Hand | ช่างชุบเครื่องดินเผาด้วยมือ | 手工镀陶器"
    },
    {
        "id":1308,
        "name":"732490  :  Writer And Glass Decorator Pottery And Others | ช่างเขียนและช่างตกแต่งเครื่องแก้ว เครื่องดินเผา และอื่น ๆ | 作家和玻璃装饰师陶器及其他"
    },
    {
        "id":1309,
        "name":"733120  :  Craftsman Making Products From Bamboo (Blinds, Mats) | ช่างทำผลิตภัณฑ์จากไม้ไผ่ (มู่ลี่ เสื่อ ) | 工匠用竹子制作产品（百叶窗、垫子）"
    },
    {
        "id":1310,
        "name":"733130  :  Handicraft Technician (Woodworking) | ช่างหัตถกรรม (งานไม้) | 手工艺技师（木工）"
    },
    {
        "id":1311,
        "name":"733140  :  Craftsman (Stone Work) | ช่างหัตถกรรม (งานหิน) | 工匠（石工）"
    },
    {
        "id":1312,
        "name":"733150  :  Handicraft (Paper) Artist, Producer Of Mulberry Paper And Handmade Paper Boxes. | ช่างหัตถกรรม (กระดาษ) , ผู้ผลิตกระดาษสาและกล่องกระดาษด้วยมือ | 手工艺（纸）艺术家，桑皮纸和手工纸盒生产商。"
    },
    {
        "id":1313,
        "name":"733220  :  Weaver With Hand Loom | ช่างทอผ้าด้วยหูกมือ | 有手织机的织布工"
    },
    {
        "id":1314,
        "name":"733225  :  Carpet Weaver With Hand Loom | ช่างทอพรมด้วยหูกมือ | 带手织机的地毯编织工"
    },
    {
        "id":1315,
        "name":"733230  :  Hand Knitter | ช่างถักด้วยมือ | 手工编织者"
    },
    {
        "id":1316,
        "name":"733240  :  Hand Embroidery Artist (Folk) | ช่างปักผ้าด้วยมือ (พื้นบ้าน) | 手工刺绣艺术家（民间）"
    },
    {
        "id":1317,
        "name":"733250  :  Hand Dyed Yarn | ช่างย้อมเส้นด้ายด้วยมือ | 手染纱"
    },
    {
        "id":1318,
        "name":"733255  :  Craftsman Dyes Fabric By Hand | ช่างย้อมผืนผ้าด้วยมือ | 工匠手工给布料染色"
    },
    {
        "id":1319,
        "name":"733260  :  Costume Dyer | ช่างย้อมเครื่องแต่งกาย | 服装染色工"
    },
    {
        "id":1320,
        "name":"733270  :  Handicraft Technician (Leather) | ช่างหัตถกรรม (เครื่องหนัง) | 手工艺技师（皮革）"
    },
    {
        "id":1321,
        "name":"733290  :  Artisans Handicraft Textiles, Leather Goods, And Other Related Products. | ช่างฝีมือหัตถกรรมสิ่งทอ เครื่องหนัง และผลิตภัณฑ์ที่เกี่ยวข้องอื่น ๆ | 工匠手工艺纺织品、皮革制品和其他相关产品。"
    },
    {
        "id":1322,
        "name":"734120  :  Machine Operator Casts A Line Of Ludlow Typefaces. | พนักงานเครื่องหล่อแถวตัวพิมพ์แบบลัดโลว์ | 机器操作员铸造一系列勒德洛字体。"
    },
    {
        "id":1323,
        "name":"734130  :  Typesetting Technician | ช่างเรียงพิมพ์ | 排版技术员"
    },
    {
        "id":1324,
        "name":"734140  :  Film Assembler | ช่างประกอบฟิล์ม | 胶片组装工"
    },
    {
        "id":1325,
        "name":"734150  :  Film Camera Operator, Film Photographer | พนักงานเครื่องถ่ายฟิล์ม , ช่างถ่ายฟิล์ม | 电影摄影机操作员、电影摄影师"
    },
    {
        "id":1326,
        "name":"734160  :  Film Arranging Staff (Layout), Film Placement Technician, Layout Technician (Layout Technician) | พนักงานจัดเรียงแผ่นฟิล์ม (เลเอาท์) ช่างจัดวางฟิล์ม,ช่างเลย์เอาต์ (ช่างเลย์) | 排片人员（排版）、排片技术员、排版技术员（排版技术员）"
    },
    {
        "id":1327,
        "name":"734170  :  Color Separator | ช่างแยกสี | 分色器"
    },
    {
        "id":1328,
        "name":"734190  :  Typesetting Artist Typographer And Related Workers | ช่างเรียงตัวพิมพ์ ช่างจัดตัวพิมพ์ และผู้ปฏิบัติงานที่เกี่ยวข้อง | 排版师印刷师及相关工作人员"
    },
    {
        "id":1329,
        "name":"734220  :  Pattern Maker And Mold Pourer | ช่างตบแบบและเทแบบ | 制模师和模具浇注师"
    },
    {
        "id":1330,
        "name":"734290  :  The Artist Makes Molds Using Replication And Other Metal Plating Methods. | ช่างทำแบบพิมพ์ด้วยวิธีการจำลองแบบและการชุบโลหะอื่นๆ | 艺术家使用复制和其他金属电镀方法制作模具。"
    },
    {
        "id":1331,
        "name":"734320  :  Offset Mold Maker | ช่างทำแม่พิมพ์ออฟเซท | 偏置模具制造商"
    },
    {
        "id":1332,
        "name":"734330  :  Letterpress Mold Maker | ช่างทำแม่พิมพ์เลตเตอร์เพรส์ส | 凸版模具制造商"
    },
    {
        "id":1333,
        "name":"734340  :  Flexographic Mold Maker | ช่างทำแม่พิมพ์เฟล็กโซกราฟี | 柔印模具制造商"
    },
    {
        "id":1334,
        "name":"734350  :  Deep Groove Mold Maker Inthayo Mold Maker | ช่างทำแม่พิมพ์ร่องลึก ช่างทำแม่พิมพ์อินทาโย | 深沟模具制造商Inthayo模具制造商"
    },
    {
        "id":1335,
        "name":"734360  :  Deep Mold Maker Gravure Mold Maker | ช่างทำแม่พิมพ์พื้นลึก ช่างทำแม่พิมพ์กราวัวร์ | 深模制造商凹版模具制造商"
    },
    {
        "id":1336,
        "name":"734370  :  Screen Mold Maker | ช่างทำแม่พิมพ์สกรีน | 屏幕模具制造商"
    },
    {
        "id":1337,
        "name":"734390  :  Other Mold Makers | ช่างทำแม่พิมพ์อื่น ๆ | 其他模具制造商"
    },
    {
        "id":1338,
        "name":"734420  :  Color Film Developer | ช่างล้างฟิล์มสี | 彩色胶片显影剂"
    },
    {
        "id":1339,
        "name":"734430  :  Black And White Film Developer | ช่างล้างฟิล์มขาว-ดำ | 黑白胶片显影机"
    },
    {
        "id":1340,
        "name":"734440  :  Image Compressor And Enlarger | ช่างอัดและขยายภาพ | 图像压缩器和放大器"
    },
    {
        "id":1341,
        "name":"734490  :  Photographers And Other Related Workers | ช่างถ่ายภาพและผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 摄影师及其他相关工作者"
    },
    {
        "id":1342,
        "name":"734520  :  Paper Cutter | ช่างตัดกระดาษ | 切纸机"
    },
    {
        "id":1343,
        "name":"734530  :  Folder | ช่างพับ | 文件夹"
    },
    {
        "id":1344,
        "name":"734540  :  Book Collector | ช่างเก็บเล่ม | 藏书家"
    },
    {
        "id":1345,
        "name":"734550  :  Seamstress (Printing) | ช่างเย็บ (การพิมพ์) | 裁缝（印刷）"
    },
    {
        "id":1346,
        "name":"734560  :  Stamping Maker (Die-Cutting) | ช่างทำแบบปั๊ม (die-cutting) | 冲压机（模切）"
    },
    {
        "id":1347,
        "name":"734570  :  Cover Maker By Hand | ช่างทำปกด้วยมือ | 手工封面机"
    },
    {
        "id":1348,
        "name":"734590  :  Bookbinders And Other Related Workers | ช่างทำเล่มหนังสือและผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 装订工及其他相关工人"
    },
    {
        "id":1349,
        "name":"734620  :  Silk Screen Maker (Printing, Textiles, Knitted Things) | ช่างทำซิลด์สกรีน (การพิมพ์สิ่งทอสิ่งถัก) | 丝印机（印刷、纺织品、针织品）"
    },
    {
        "id":1350,
        "name":"734630  :  Copper Screen Printing Technician (Textiles) By Hand, Workers Ironing Paint On A Screen | ช่างพิมพ์สกรีนทองแดง (สิ่งทอสิ่งถัก) ด้วยมือ , คนงานรีดสีบนสกรีน | 铜丝网印刷技术员（纺织品）手工，工人们在屏幕上熨烫油漆"
    },
    {
        "id":1351,
        "name":"734640  :  Hand-Printed Paper Screen Printr | ช่างพิมพ์สกรีนกระดาษด้วยมือ | 手工印刷纸丝网印刷机"
    },
    {
        "id":1352,
        "name":"734690  :  Paper And Textile Screen Printing Technician | ช่างพิมพ์สกรีนกระดาษและสิ่งทอสิ่งถักอื่น ๆ | 纸张和纺织品丝网印刷技术员"
    },
    {
        "id":1353,
        "name":"741110  :  A Person Who Kills Animals And\/Or Butchers Meat. | ผู้ฆ่าสัตว์และ\/หรือชำแหละเนื้อสัตว์ | 杀死动物和\/或屠宰肉类的人。"
    },
    {
        "id":1354,
        "name":"741120  :  Slaughterer In The Slaughterhouse | ผู้ฆ่าสัตว์ในโรงฆ่าสัตว์ | 屠宰场里的屠夫"
    },
    {
        "id":1355,
        "name":"741130  :  Meat Cutter And Butcher | ผู้ตัดและชำแหละเนื้อสัตว์ | 切肉机和屠夫"
    },
    {
        "id":1356,
        "name":"741135  :  Fish Filler | ผู้แล่ปลา | 鱼填料"
    },
    {
        "id":1357,
        "name":"741140  :  Meat Preserver And Processor | ผู้ถนอมและแปรรูปเนื้อสัตว์ | 肉类保存器和加工机"
    },
    {
        "id":1358,
        "name":"741150  :  Basic Aquatic Animal Processor | ผู้แปรรูปสัตว์น้ำเบื้องต้น | 基本水产动物处理器"
    },
    {
        "id":1359,
        "name":"741155  :  Preserver And Processor Of Aquatic Meat | ผู้ถนอมและแปรรูปเนื้อสัตว์น้ำ | 水产肉的保存和加工"
    },
    {
        "id":1360,
        "name":"741160  :  Fish Sauce Maker | ผู้ทำน้ำปลา | 鱼露机"
    },
    {
        "id":1361,
        "name":"741190  :  Butchers, Butchers And Other Related Workers | ผู้ฆ่า ชำแหละเนื้อสัตว์และผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 屠夫、屠夫及其他相关工人"
    },
    {
        "id":1362,
        "name":"741220  :  Who Makes Various Types Of Bread And Pastries (By Hand) | ผู้ทำขนมปังและขนมอบประเภทต่าง ๆ (ด้วยมือ) | 谁制作各种类型的面包和糕点（手工）"
    },
    {
        "id":1363,
        "name":"741230  :  Sugar Dessert Maker (Chocolate, Candy) | ผู้ทำขนมหวานจากน้ำตาล (ช็อกโกแลต ลูกกวาด) | 糖甜点机（巧克力、糖果）"
    },
    {
        "id":1364,
        "name":"741240  :  Who Makes Snacks From Grains | ผู้ทำขนมจากธัญชาติ | 谁用谷物制作零食"
    },
    {
        "id":1365,
        "name":"741250  :  Chinese Noodle Maker | ผู้ทำเส้นขนมจีน | 中国面条机"
    },
    {
        "id":1366,
        "name":"741255  :  Noodle Maker | ผู้ทำเส้นหมี่ | 面条机"
    },
    {
        "id":1367,
        "name":"741258  :  Noodle Maker | ผู้ทำเส้นก๋วยเตี๋ยว | 面条机"
    },
    {
        "id":1368,
        "name":"741260  :  Vermicelli Maker | ผู้ทำวุ้นเส้น | 粉丝机"
    },
    {
        "id":1369,
        "name":"741265  :  Noodle Maker | ผู้ทำเส้นบะหมี่ | 面条机"
    },
    {
        "id":1370,
        "name":"741290  :  Manufacturers Produce Products From Flour And Other Sugars. | ผู้ทำผลิตผลิตภัณฑ์จากแป้งและน้ำตาลอื่น ๆ | 制造商用面粉和其他糖生产产品。"
    },
    {
        "id":1371,
        "name":"741310  :  General Butter Milk Producer | ผู้ผลิตนมเนยทั่วไป | 一般酪乳生产商"
    },
    {
        "id":1372,
        "name":"741320  :  Butter Maker | ผู้ผลิตเนย | 黄油机"
    },
    {
        "id":1373,
        "name":"741330  :  Manual Ice Cream Maker | ผู้ผลิตไอศกรีมด้วยมือ | 手动冰淇淋机"
    },
    {
        "id":1374,
        "name":"741390  :  Manufacturers Of Other Dairy Products | ผู้ผลิตผลิตภัณฑ์จากนมอื่น ๆ | 其他乳制品制造商"
    },
    {
        "id":1375,
        "name":"741420  :  Preserver Of Plants, Vegetables, And Dried Fruits | ผู้ถนอมพืช ผัก ผลไม้ตากแห้ง | 植物、蔬菜和干果的保存剂"
    },
    {
        "id":1376,
        "name":"741430  :  Those Who Preserve Plants, Vegetables, And Fruits Using Fermentation, Pickling, And Canning Methods. | ผู้ถนอมพืช ผัก ผลไม้ ด้วยวิธีการหมัก ดองและเชื่อม | 使用发酵、腌制和罐装方法保存植物、蔬菜和水果的人。"
    },
    {
        "id":1377,
        "name":"741440  :  Processor Of Plant Juice Products, Vegetables, And Fruits | ผู้แปรรูปผลิตภัณฑ์น้ำพืช ผัก ผลไม้ | 植物汁产品、蔬菜和水果加工商"
    },
    {
        "id":1378,
        "name":"741490  :  Those Who Preserve And Process Plant Products, Vegetables, And Fruits Which Are Not Classified Anywhere Else. | ผู้ถนอมและแปรรูปผลิตภัณฑ์พืช ผัก ผลไม้ ซึ่งมิได้จัดประเภทไว้ในที่อื่น | 保存和加工未分类的植物产品、蔬菜和水果的人。"
    },
    {
        "id":1379,
        "name":"741520  :  A Person Who Sorts And Grades The Quality Of Food, Vegetables, And Fruits. | ผู้คัดแยกและจัดระดับชั้นคุณภาพอาหาร ผักและผลไม้ | 对食品、蔬菜和水果的质量进行分类和分级的人。"
    },
    {
        "id":1380,
        "name":"741530  :  Tea Taster, Coffee | ผู้ชิมชา, กาแฟ | 品茶师、咖啡师"
    },
    {
        "id":1381,
        "name":"741540  :  Spirits, Wine And Fruit Wine Tasters | ผู้ชิมสุรา, ไวน์และไวน์ผลไม้ | 烈酒、葡萄酒和果酒品酒师"
    },
    {
        "id":1382,
        "name":"741550  :  Beer Taster | ผู้ชิมเบียร์ | 啤酒品尝师"
    },
    {
        "id":1383,
        "name":"741590  :  Taste Makers And Graders Of Quality Of Food And Beverages, Etc. | ผู้ชิมรสชาดและจัดลำดับชั้นคุณภาพของอาหารและเครื่องดื่ม อื่น ๆ | 食品和饮料质量的口味制定者和分级者等"
    },
    {
        "id":1384,
        "name":"741610  :  Tobacco Curer, Independent Curer | ผู้บ่มใบยาสูบ , ผู้บ่มอิสระ | 烟草固化师、独立固化师"
    },
    {
        "id":1385,
        "name":"741620  :  Someone Who Sorts And Classifies Cured Tobacco Leaves. | ผู้คัดและจัดชั้นใบยาสูบที่บ่มแล้ว | 对烤烟叶进行分类和分类的人。"
    },
    {
        "id":1386,
        "name":"741625  :  Medicine Leaf Compressor, Medicine Leaf Compressor | ผู้อัดห่อใบยา , พนักงานอัดห่อใบยา | 药叶压缩机, 药叶压缩机"
    },
    {
        "id":1387,
        "name":"741630  :  Tobacco Leaf Quality Inspector | ผู้ตรวจคุณภาพใบยาสูบ | 烟叶质检员"
    },
    {
        "id":1388,
        "name":"741640  :  A Person Who Plucks Tobacco Leaf Stalks By Hand | ผู้รูดก้านใบยาสูบด้วยมือ | 用手采摘烟叶梗的人"
    },
    {
        "id":1389,
        "name":"741650  :  Manual Tobacco Maker | ผู้ผลิตยาเส้นด้วยมือ | 手动烟草机"
    },
    {
        "id":1390,
        "name":"741660  :  One Who Rolls Other Cigarettes By Hand | ผู้มวนบุหรี่อื่นด้วยมือ | 用手卷其他香烟的人"
    },
    {
        "id":1391,
        "name":"741665  :  Hand Cigar Roller | ผู้มวนบุหรี่ซิการ์ด้วยมือ | 手动雪茄卷轴"
    },
    {
        "id":1392,
        "name":"741670  :  Snuff Maker | ผู้ทำยานัตถุ์ | 鼻烟机"
    },
    {
        "id":1393,
        "name":"741690  :  Tobacco Leaf Preparer Manufacturers Of Tobacco And Other Tobacco Products | ผู้เตรียมใบยาสูบ ผู้ผลิตยาสูบและผลิตภัณฑ์ยาสูบอื่น ๆ | 烟叶准备机烟草和其他烟草制品制造商"
    },
    {
        "id":1394,
        "name":"742120  :  Wood Press; Wood Press Machine Operator | ผู้อัดน้ำยาไม้ ; พนักงานเครื่องอัดน้ำยาไม้ | 木材压榨机；木材压机操作员"
    },
    {
        "id":1395,
        "name":"742130  :  Wood Dryer; Wood Drying Operator | ผู้อบไม้ ; ผู้ควบคุมการอบไม้ | 木材干燥机；木材干燥操作员"
    },
    {
        "id":1396,
        "name":"742190  :  Other Wood Presses And Curers | ผู้อัดและอบน้ำยาไม้อื่น ๆ | 其他木材压榨机和固化机"
    },
    {
        "id":1397,
        "name":"742210  :  Wooden Furniture Maker | ช่างทำเครื่องเรือนไม้ | 木制家具制造商"
    },
    {
        "id":1398,
        "name":"742220  :  Wood Model Maker | ช่างทำแบบไม้ | 木模型制作者"
    },
    {
        "id":1399,
        "name":"742225  :  Wooden Furniture Designer | ช่างออกแบบเครื่องเรือนไม้ | 木制家具设计师"
    },
    {
        "id":1400,
        "name":"742230  :  Wood Carver | ช่างแกะสลักไม้ | 木雕师"
    },
    {
        "id":1401,
        "name":"742235  :  Pearl Decorator | ช่างประดับมุก | 珍珠装饰师"
    },
    {
        "id":1402,
        "name":"742237  :  Wood Carving Technician | ช่างฝังรอยไม้ | 木雕技师"
    },
    {
        "id":1403,
        "name":"742240  :  Wood Furniture Painter | ช่างสีเครื่องเรือนไม้ | 木家具油漆工"
    },
    {
        "id":1404,
        "name":"742250  :  Building Carpenter | ช่างไม้ในอาคาร | 建筑木匠"
    },
    {
        "id":1405,
        "name":"742260  :  Wooden Toy Maker | ช่างทำของเล่นไม้ | 木制玩具制造商"
    },
    {
        "id":1406,
        "name":"742270  :  Building Interior Decorator Using Wood | ช่างตกแต่งภายในอาคารด้วยไม้ | 使用木材的建筑室内装饰师"
    },
    {
        "id":1407,
        "name":"742275  :  Wood Flooring Technician | ช่างปูพื้นไม้ | 木地板技术员"
    },
    {
        "id":1408,
        "name":"742280  :  Inspector And Sorter Of Wood Types And Quality Classes | ผู้ตรวจและคัดแยกประเภทและชั้นคุณภาพไม้ | 木材类型和质量等级的检验员和分选员"
    },
    {
        "id":1409,
        "name":"742290  :  Furniture Makers And Other Related Workers | ช่างทำเครื่องเรือนไม้และผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 家具制造商及其他相关工人"
    },
    {
        "id":1410,
        "name":"742310  :  General Woodworking Tool Adjuster | ช่างปรับตั้งเครื่องมือทำงานไม้ทั่วไป | 通用木工刀具调节器"
    },
    {
        "id":1411,
        "name":"742320  :  Technician Adjusts And Uses A Manual Wood Saw. | ช่างปรับตั้งและใช้เครื่องเลื่อยไม้ด้วยมือ | 技术人员调整并使用手动木锯。"
    },
    {
        "id":1412,
        "name":"742330  :  Technician Adjusting And Using A Wood Lathe; Wood Turner | ช่างปรับตั้งและใช้เครื่องกลึงไม้ ; ช่างกลึงไม้ | 技术人员调整和使用木工车床；木车工"
    },
    {
        "id":1413,
        "name":"742340  :  The Technician Adjusts And Uses The Machine To Make Cornices Or Grooves By Hand. | ช่างปรับตั้งและใช้เครื่องทำบัวหรือร่องด้วยมือ | 技术人员调整并使用机器手工制作檐口或凹槽。"
    },
    {
        "id":1414,
        "name":"742350  :  Technician Adjusts And Uses A Manual Wood Planer. | ช่างปรับตั้งและใช้เครื่องไสไม้ด้วยมือ | 技术人员调整并使用手动木刨。"
    },
    {
        "id":1415,
        "name":"742360  :  Technicians Adjust And Use Wood Carving Machines By Hand. | ช่างปรับตั้งและใช้เครื่องแกะสลักงานไม้ด้วยมือ | 技术人员手工调整和使用木雕机。"
    },
    {
        "id":1416,
        "name":"742390  :  Technician Adjusts And Uses Other Woodworking Tools. | ช่างปรับตั้งและใช้เครื่องมืองานไม้อื่น ๆ | 技术人员调整和使用其他木工工具。"
    },
    {
        "id":1417,
        "name":"742420  :  Basket Weaver, Basket Weaver, Basketry Product Maker | ช่างสานตะกร้า กระจาด ,ช่างทำผลิตภัณฑ์จักสาน | 篮子编织工, 篮子编织工, 篮子产品制造商"
    },
    {
        "id":1418,
        "name":"742425  :  Furniture Weaver | ช่างจักสานเครื่องเรือน | 家具编织工"
    },
    {
        "id":1419,
        "name":"742430  :  Brush Maker | ช่างทำแปรง | 制刷机"
    },
    {
        "id":1420,
        "name":"742440  :  Broom Maker | ช่างทำไม้กวาด | 扫帚制造者"
    },
    {
        "id":1421,
        "name":"742490  :  Basket Makers, Brush Makers And Other Related Workers | ช่างจักสาน ช่างทำแปรงและผู้ปฏิบัติงานที่เกี่ยวข้องอื่นๆ | 篮子制造者、刷子制造者及其他相关工人"
    },
    {
        "id":1422,
        "name":"743120  :  Graders And Classifiers Of Cotton Fibers | ผู้จัดเกรดและผู้จัดประเภทเส้นใยฝ้าย | 棉纤维分级机和分级机"
    },
    {
        "id":1423,
        "name":"743130  :  Jute Selector Jute Selection Staff | ผู้คัดเลือกปอ พนักงานคัดเลือกปอ | 黄麻选择器黄麻精选人员"
    },
    {
        "id":1424,
        "name":"743140  :  Fiber Beater, Cotton Crusher | ผู้ตีเส้นใย ผู้หีบฝ้าย | 纤维打浆机、棉花破碎机"
    },
    {
        "id":1425,
        "name":"743150  :  Women Twist And Twist Silk Threads By Hand Young Women Twist And Twist Silk Threads From Cocoons | ผู้สาวและบิดเกลียวไหมด้วยมือ ผู้สาวและบิดเกลียวไหมจาก รังไหม | 妇女们用手捻捻丝线年轻妇女捻着蚕茧里的丝线"
    },
    {
        "id":1426,
        "name":"743160  :  Silk Glue Peeler | ผู้ลอกกาวเส้นไหม | 丝胶剥离器"
    },
    {
        "id":1427,
        "name":"743190  :  Other Fiber Preparators | ผู้เตรียมเส้นใยอื่น ๆ | 其他纤维制备器"
    },
    {
        "id":1428,
        "name":"743220  :  Hand Spinner | ผู้ปั่นด้ายด้วยมือ | 手动旋转器"
    },
    {
        "id":1429,
        "name":"743225  :  Worker Collects Yarn By Hand | พนักงานควบเส้นด้ายด้วยมือ | 工人手工收集纱线"
    },
    {
        "id":1430,
        "name":"743230  :  Yarn Threader By Hand | ช่างทำเกลียวเส้นด้ายด้วยมือ | 手工穿线器"
    },
    {
        "id":1431,
        "name":"743240  :  Employee Winds Thread By Hand | พนักงานกรอด้ายด้วยมือ | 员工手工绕线"
    },
    {
        "id":1432,
        "name":"743245  :  Workers String Tack For Use In Hand Weaving; Hand Stringer | พนักงานร้อยตะกรอเพื่อใช้ในการทอมือ ; ผู้ร้อยตะกรอด้วยมือ | 工人手工编织时使用的线钉；手纵梁"
    },
    {
        "id":1433,
        "name":"743250  :  Canvas Repairman | ช่างซ่อมผืนผ้า | 帆布修理工"
    },
    {
        "id":1434,
        "name":"743260  :  Weaver With Hand Loom | ช่างทอผ้าด้วยหูกมือ | 有手织机的织布工"
    },
    {
        "id":1435,
        "name":"743265  :  Carpet Weaver With Hand Loom | ช่างทอพรมด้วยหูกมือ | 带手织机的地毯编织工"
    },
    {
        "id":1436,
        "name":"743270  :  Knitter (Hand-Operated Machine) | ช่างถัก (เครื่องจักรที่ควบคุมด้วยมือ) | 针织机（手动机）"
    },
    {
        "id":1437,
        "name":"743275  :  Hand Crocheter | ช่างถักโครเชต์ด้วยมือ | 手工钩针编织"
    },
    {
        "id":1438,
        "name":"743290  :  Weavers, Knitters And Other Related Workers | ช่างทอ ช่างถัก และผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 织布工、针织工和其他相关工人"
    },
    {
        "id":1439,
        "name":"743320  :  Tailor (Individual) | ช่างตัดเย็บเสื้อผ้า (เฉพาะบุคคล) | 裁缝（个人）"
    },
    {
        "id":1440,
        "name":"743330  :  Tailor (Ready-Made Clothes) | ช่างตัดเย็บเสื้อผ้า (สำเร็จรูป) | 裁缝（成衣）"
    },
    {
        "id":1441,
        "name":"743340  :  Costume Maker | ช่างประดิษฐ์เครื่องแต่งกาย | 服装师"
    },
    {
        "id":1442,
        "name":"743350  :  Hat Maker | ช่างทำหมวก | 帽子制造商"
    },
    {
        "id":1443,
        "name":"743360  :  Hat Maker (Native) | ช่างทำหมวก (พื้นเมือง) | 制帽师（本地人）"
    },
    {
        "id":1444,
        "name":"743390  :  Costume Tailor And Other Hat Makers | ช่างตัดเย็บเครื่องแต่งกาย และช่างทำหมวกอื่น ๆ | 服装裁缝和其他帽子制造商"
    },
    {
        "id":1445,
        "name":"743420  :  Wool Screener | ช่างคัดผ้าขนสัตว์ | 羊毛筛选机"
    },
    {
        "id":1446,
        "name":"743430  :  Wool Tailor | ช่างตัดผ้าขนสัตว์ | 羊毛裁缝"
    },
    {
        "id":1447,
        "name":"743440  :  Fur Clothes Tailor | ช่างตัดเย็บเสื้อผ้าขนสัตว์ | 皮草服装裁缝"
    },
    {
        "id":1448,
        "name":"743490  :  Fur Tailors And Other Related Workers | ช่างตัดเย็บเสื้อผ้าที่ทำจากขนสัตว์และผู้ปฏิบัติงานที่เกี่ยวข้องอื่นๆ | 毛皮裁缝及其他相关工人"
    },
    {
        "id":1449,
        "name":"743520  :  Finished Pattern Maker (Wool) | ช่างสร้างแบบสำเร็จ (ผ้าขนสัตว์) | 成品打版师（羊毛）"
    },
    {
        "id":1450,
        "name":"743530  :  Successful Builder (Costume) | ช่างสร้างแบบสำเร็จ (เครื่องแต่งกาย) | 成功的建设者（戏服）"
    },
    {
        "id":1451,
        "name":"743535  :  Successful Author (Costume) | ผู้เขียนแบบสำเร็จ (เครื่องแต่งกาย) | 成功作家（戏服）"
    },
    {
        "id":1452,
        "name":"743540  :  Prefabricated Builder (Hat) | ช่างสร้างแบบสำเร็จ (หมวก) | 预制建筑（帽子）"
    },
    {
        "id":1453,
        "name":"743550  :  Tailor Of Ready-Made Clothing (Except Leather) | ช่างตัดเครื่องแต่งกายสำเร็จรูป (ยกเว้นหนัง) | 成衣裁缝（皮革除外）"
    },
    {
        "id":1454,
        "name":"743555  :  Costume Tailor (Movie) | ช่างตัดเครื่องแต่งกาย (หนัง) | 电影《服装裁缝》"
    },
    {
        "id":1455,
        "name":"743590  :  Pattern Makers And Other Costume Makers | ช่างสร้างแบบและช่างตัดเครื่องแต่งกายอื่น ๆ | 制版师和其他服装制作师"
    },
    {
        "id":1456,
        "name":"743620  :  Hand-Sewn Clothing | ช่างเย็บเครื่องแต่งกายด้วยมือ | 手工缝制的衣服"
    },
    {
        "id":1457,
        "name":"743625  :  General Hand And Machine Seamstress | ช่างเย็บด้วยมือและจักรทั่วไป | 一般手裁和机裁缝"
    },
    {
        "id":1458,
        "name":"743630  :  Hand Embroidery Artist | ช่างปักด้วยมือ | 手工刺绣艺术家"
    },
    {
        "id":1459,
        "name":"743640  :  Craftsman Who Makes Boat Canvas, Tents, And Awnings. | ช่างทำผ้าใบเรือ เต็นท์ และหลังคาผ้ากันสาด | 制作船用帆布、帐篷和遮阳篷的工匠。"
    },
    {
        "id":1460,
        "name":"743650  :  Umbrella Maker (Paper And Cloth) | ช่างทำร่ม (กระดาษและผ้า) | 制伞机（纸和布）"
    },
    {
        "id":1461,
        "name":"743690  :  Seamstresses, Embroiderers And Other Related Workers | ช่างเย็บ ช่างปัก และผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 裁缝师、刺绣师及其他相关工人"
    },
    {
        "id":1462,
        "name":"743720  :  Upholstery Maker (Furniture) | ช่างทำเบาะ (เครื่องเรือน) | 室内装潢制造商（家具）"
    },
    {
        "id":1463,
        "name":"743730  :  Upholstery Technician (Vehicle) | ช่างทำเบาะ (ยานพาหนะ) | 装潢技师（车辆）"
    },
    {
        "id":1464,
        "name":"743740  :  Mattress Maker | ช่างทำที่นอน | 床垫制造商"
    },
    {
        "id":1465,
        "name":"743790  :  Furniture Upholsterers, Furniture And Other Related Workers | ช่างหุ้มเบาะเครื่องเรือน เฟอร์นิเจอร์ และผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 家具装潢工、家具及其他相关工人"
    },
    {
        "id":1466,
        "name":"744120  :  The Technician Selects The Quality Of Leather. | ช่างคัดเลือกคุณภาพหนัง | 技术人员选择皮革的质量。"
    },
    {
        "id":1467,
        "name":"744130  :  The Leather Cutter Scrapes The Fur By Hand. | ช่างถากหนังขูดขนด้วยมือ | 皮革切割师用手刮毛皮。"
    },
    {
        "id":1468,
        "name":"744140  :  Leather Dye Technician | ช่างย้อมสีหนัง | 皮革染色技术员"
    },
    {
        "id":1469,
        "name":"744190  :  Fur Trimmers, Tanners, And Other Skin-Sharpers | ช่างตกแต่งขนสัตว์ ช่างฟอกหนัง และช่างถากหนังขูดขนอื่น ๆ | 毛皮修剪者、制革者和其他皮肤磨光者"
    },
    {
        "id":1470,
        "name":"744210  :  General Shoemaker | ช่างทำรองเท้าทั่วไป | 一般鞋匠"
    },
    {
        "id":1471,
        "name":"744215  :  Shoe Repairman (By Hand) | ช่างซ่อมรองเท้า (ด้วยมือ) | 修鞋工（手工）"
    },
    {
        "id":1472,
        "name":"744220  :  Shoe Tailor | ช่างตัดแบบรองเท้า | 鞋裁缝"
    },
    {
        "id":1473,
        "name":"744225  :  The Craftsman Cuts The Leather Parts Of The Shoe Soles By Hand. | ช่างตัดชิ้นส่วนหนังหน้ารองเท้าด้วยมือ | 工匠手工切割鞋底的皮革部分。"
    },
    {
        "id":1474,
        "name":"744230  :  Shoe Leather Assembler | ช่างประกอบหนังหน้ารองเท้า | 鞋革组装机"
    },
    {
        "id":1475,
        "name":"744235  :  Shoe Sole Assembler | ช่างประกอบพื้นรองเท้า | 鞋底组装工"
    },
    {
        "id":1476,
        "name":"744240  :  Shoemaker For Disabled People | ช่างตัดรองเท้าคนพิการ | 残疾人鞋匠"
    },
    {
        "id":1477,
        "name":"744250  :  Shoe Molder | ช่างขึ้นหุ่นรองเท้า | 鞋模工"
    },
    {
        "id":1478,
        "name":"744255  :  Shoe Decorator | ช่างตกแต่งรองเท้า | 鞋饰师"
    },
    {
        "id":1479,
        "name":"744260  :  Hand Seamstress (Except Shoes, Gloves And Clothing) | ช่างเย็บหนังด้วยมือ (ยกเว้นรองเท้า ถุงมือ และเครื่องแต่งกาย) | 手工裁缝（鞋子、手套和衣服除外）"
    },
    {
        "id":1480,
        "name":"744265  :  Leather Sewing Machine (Except Shoes, Gloves And Clothing) | ช่างเย็บหนังด้วยจักร (ยกเว้นรองเท้า ถุงมือ และเครื่องแต่งกาย) | 皮革缝纫机（鞋子、手套和衣服除外）"
    },
    {
        "id":1481,
        "name":"744270  :  General Leather Product Technician | ช่างผลิตภัณฑ์เครื่องหนังทั่วไป | 皮革制品通用技术员"
    },
    {
        "id":1482,
        "name":"744275  :  Animal Harness Maker | ช่างทำเครื่องเทียมสัตว์ | 动物挽具制造商"
    },
    {
        "id":1483,
        "name":"744278  :  Saddle Maker | ช่างทำอานม้า | 马鞍制造商"
    },
    {
        "id":1484,
        "name":"744290  :  Shoemakers And Other Related Workers | ช่างทำรองเท้าและผู้ปฏิบัติงานที่เกี่ยวข้องอื่น ๆ | 鞋匠及其他相关工人"
    },
    {
        "id":1485,
        "name":"811110  :  Mining Drilling Machine Operators, Drilling Machine Operators In Mines And Quarries | ผู้ควบคุมเครื่องขุดเจาะทำเหมืองแร่ , พนักงานเครื่องเจาะในเหมืองแร่และเหมืองหิน | 采矿钻机操作员、矿山和采石场的钻机操作员"
    },
    {
        "id":1486,
        "name":"811120  :  Rock Drill Operator, Rock Drill Technician | ผู้ควบคุมเครื่องเจาะหิน , ช่างเจาะหิน | 凿岩机操作员、凿岩机技术员"
    },
    {
        "id":1487,
        "name":"811190  :  Operators Of Other Mining And Drilling Equipment | ผู้ควบคุมเครื่องขุดและเจาะเหมืองแบบอื่น ๆ | 其他采矿和钻探设备的操作员"
    },
    {
        "id":1488,
        "name":"811220  :  Grinder Operator, Stone Crusher Operator | ผู้ควบคุมเครื่องบด โม่ , พนักงานเครื่องย่อยหิน | 粉碎机操作员、碎石机操作员"
    },
    {
        "id":1489,
        "name":"811230  :  Ore Separator Operator, Ore Separator Operator | ผู้ควบคุมเครื่องแยกแร่, พนักงานเครื่องแยกแร่ | 矿石分离机操作员，矿石分离机操作员"
    },
    {
        "id":1490,
        "name":"811240  :  Mineral Flotation Machine Operator, Mineral Flotation Machine Operator | ผู้ควบคุมเครื่องลอยแร่, พนักงานเครื่องลอยแร่ | 矿物浮选机操作员，矿物浮选机操作员"
    },
    {
        "id":1491,
        "name":"811250  :  Ore Crusher Operator, Ore Crusher Operator | ผู้ควบคุมเครื่องบดย่อยแร่, พนักงานเครื่องตำแร่ | 矿石破碎机操作员，矿石破碎机操作员"
    },
    {
        "id":1492,
        "name":"811260  :  Mineral Separation Table Employee | พนักงานโต๊ะแยกแร่ | 选矿台员工"
    },
    {
        "id":1493,
        "name":"811290  :  Other Mineral Processing And Extraction Machine Operators | ผู้ควบคุมเครื่องจักรในการแปรรูปและสกัดแร่อื่น ๆ | 其他矿物加工和提取机械操作员"
    },
    {
        "id":1494,
        "name":"811320  :  Oil And Gas Well Drilling Rig Operator, Drilling Rig Operator (Oil And Gas Wells) | ผู้ควบคุมแท่นขุดเจาะบ่อน้ำมันและบ่อก๊าซ , ช่างประจำปั่นจั่นเจาะ (บ่อน้ำมันและก๊าซ) | 油气井钻机操作员、钻机操作员（石油和天然气井）"
    },
    {
        "id":1495,
        "name":"811330  :  Rotary Machine Operator, Rotary Machine Operator | พนักงานเครื่องโรตารี่ , ผู้ควบคุมเครื่องโรตารี่ | 旋转机械操作员, 旋转机械操作员"
    },
    {
        "id":1496,
        "name":"811340  :  Well Drillers (Except Oil And Gas Wells) | ผู้เจาะบ่อ (ยกเว้นบ่อน้ำมันและก๊าซ) | 钻井工（油气井除外）"
    },
    {
        "id":1497,
        "name":"811390  :  Operators Of Other Drilling Equipment And Machines | ผู้ควบคุมอุปกรณ์และเครื่องขุดเจาะอื่น ๆ | 其他钻井设备和机器的操作员"
    },
    {
        "id":1498,
        "name":"812120  :  Smelting Furnace Operator, Metal | พนักงานคุมเตาถลุงแร่ , โลหะ | 熔炼炉操作员，金属"
    },
    {
        "id":1499,
        "name":"812130  :  Steel Furnace Operator | พนักงานคุมเตาหลอมเหล็กกล้า | 炼钢炉操作工"
    },
    {
        "id":1500,
        "name":"812140  :  Electric Furnace Operator (Mineral And Metal Smelting) | พนักงานคุมเตาหลอมไฟฟ้า (ถลุงแร่และโลหะ) | 电炉操作员（矿物和金属冶炼）"
    },
    {
        "id":1501,
        "name":"812150  :  Sleeping Furnace Operator (Mineral And Metal Smelting) | พนักงานคุมเตาหลอมแบบนอน (ถลุงแร่และโลหะ) | 炉操作员睡觉（矿物和金属冶炼）"
    },
    {
        "id":1502,
        "name":"812160  :  Worker Drilling A Stove (Electric Stove, Horizontal Stove) | พนักงานเจาะเตา (เตาไฟฟ้า, เตาแบบเตานอน) | 工人正在钻炉（电炉、卧式炉）"
    },
    {
        "id":1503,
        "name":"812190  :  Other Metal Smelting Furnace Operators | พนักงานคุมเตาถลุงโลหะอื่น ๆ | 其他金属冶炼炉经营者"
    },
    {
        "id":1504,
        "name":"812220  :  Metal Furnace Operator, Metal Furnace Operator (Cupola Type, Horizontal Type) | พนักงานคุมเตาหลอมโลหะ , ผู้ควบคุมเตาหลอมโลหะ (แบบคูโปลา , แบบนอน) | 金属炉操作机、金属炉操作机（冲天式、卧式）"
    },
    {
        "id":1505,
        "name":"812230  :  Metal Casting Machine Operator | ผู้ควบคุมเครื่องหล่อโลหะ | 金属铸造机操作员"
    },
    {
        "id":1506,
        "name":"812235  :  Tin Casting Machine Operator | ช่างคุมเครื่องหล่อดีบุก | 锡铸机操作员"
    },
    {
        "id":1507,
        "name":"812240  :  Mold Casting Machine Operator | ช่างคุมเครื่องหล่อแม่พิมพ์ | 模具铸造机操作员"
    },
    {
        "id":1508,
        "name":"812250  :  Metal Rolling Machine Operator, Metal Rolling Machine Operator (Hot Rolling) | ผู้ควบคุมเครื่องรีดโลหะ, พนักงานเครื่องรีดโลหะ (รีดร้อน) | 金属轧机操作员、金属轧机操作员（热轧）"
    },
    {
        "id":1509,
        "name":"812255  :  Operator Of Cold Rolling Metal Rolling Machine | พนักงานคุมเครื่องรีดโลหะแบบรีดเย็น | 冷轧金属轧机操作员"
    },
    {
        "id":1510,
        "name":"812260  :  Metal Rolling Machine Operator (Finished Product) | พนักงานควบคุมเครื่องรีดโลหะ (ผลิตภัณฑ์สำเร็จรูป) | 金属轧机操作员（成品）"
    },
    {
        "id":1511,
        "name":"812265  :  Metal Rolling Machine Operator (Semi-Finished Product) | พนักงานควบคุมเครื่องรีดโลหะ (ผลิตภัณฑ์กึ่งสำเร็จรูป) | 金属轧机操作员（半成品）"
    },
    {
        "id":1512,
        "name":"812290  :  Operator Of Other Metal Rolling Machines | พนักงานคุมเครื่องรีดโลหะอื่น ๆ | 其他金属轧机操作员"
    },
    {
        "id":1513,
        "name":"812310  :  General Heat Treatment Employee | พนักงานอบชุบทั่วไป | 一般热处理工"
    },
    {
        "id":1514,
        "name":"812320  :  Employees Heat Treatment Of Metal To Reduce Stress. | พนักงานอบชุบโลหะเพื่อลดความเครียด | 员工对金属进行热处理以减轻压力。"
    },
    {
        "id":1515,
        "name":"812330  :  An Employee Heats Metal To Increase Its Hardness. An Employee Heats Metal To Make It Hard. | พนักงานอบชุบโลหะเพื่อเพิ่มความแข็ง , พนักงานอบชุบให้โลหะแข็ง | 一名员工加热金属以增加其硬度。一名员工加热金属以使其变硬。"
    },
    {
        "id":1516,
        "name":"812340  :  Workers Change The Hardness And Toughness Of The Metal. | พนักงานเปลี่ยนความแข็งเหนียวของโลหะ | 工人们改变金属的硬度和韧性。"
    },
    {
        "id":1517,
        "name":"812390  :  Other Metal Treatment Employees | พนักงานอบชุบโลหะอื่น ๆ | 其他金属处理员工"
    },
    {
        "id":1518,
        "name":"812420  :  Wire Pulling Machine Operator, Metal Rolling Machine Operator | ผู้ควบคุมเครื่องดึงยึดเส้นลวด , ช่างรีดโลหะ | 拉线机操作员、金属滚压机操作员"
    },
    {
        "id":1519,
        "name":"812490  :  Pull Machine Operator Press And Squeeze Other Metals | ผู้ควบคุมเครื่องดึง อัดและบีบโลหะอื่น ๆ | 拉机操作员按压和挤压其他金属"
    },
    {
        "id":1520,
        "name":"813120  :  Glass Blower Worker | พนักงานเครื่องเป่าแก้ว | 玻璃吹制工"
    },
    {
        "id":1521,
        "name":"813130  :  The Machine Operator Turns Glass Water Into A Smooth Glass. | ช่างคุมเครื่องดึงน้ำแก้วให้เป็นกระจกแผ่นเรียบ | 机器操作员将玻璃水变成光滑的玻璃杯。"
    },
    {
        "id":1522,
        "name":"813135  :  The Machine Operator Turns Glass Water Into Patterned Glass Sheets. | ช่างคุมเครื่องดึงน้ำแก้วให้เป็นกระจกแผ่นลาย | 机器操作员将玻璃水变成有图案的玻璃板。"
    },
    {
        "id":1523,
        "name":"813140  :  An Employee Controls A Glass Product Pressing Machine. | พนักงานคุมเครื่องอัดผลิตภัณฑ์แก้วด้วยเครื่องจักร | 一名员工控制玻璃制品压制机。"
    },
    {
        "id":1524,
        "name":"813150  :  Glass Furnace Operator | ช่างคุมเตาหลอมแก้ว | 玻璃熔炉操作员"
    },
    {
        "id":1525,
        "name":"813152  :  Technician Building Or Repairing A Glass Furnace | ช่างก่อหรือซ่อมเตาหลอมแก้ว | 技术人员建造或修理玻璃熔炉"
    },
    {
        "id":1526,
        "name":"813155  :  Glass Oven Operator To Reduce Stress | ช่างคุมเตาอบแก้วเพื่อลดความเครียด | 玻璃烤箱操作员减轻压力"
    },
    {
        "id":1527,
        "name":"813160  :  Molding Machine Operator | พนักงานคุมเครื่องปั้น | 成型机操作员"
    },
    {
        "id":1528,
        "name":"813162  :  Pottery Kiln Operator | ช่างคุมเตาเผาเครื่องดินเผา | 陶窑操作工"
    },
    {
        "id":1529,
        "name":"813165  :  Forming Machine Operator Solid Cast Earthenware | พนักงานคุมเครื่องขึ้นรูป เครื่องดินเผาแบบหล่อตัน | 成型机操作员实心铸陶器"
    },
    {
        "id":1530,
        "name":"813166  :  Wood Stove Operator | ช่างคุมเตาฟืน | 柴火炉操作员"
    },
    {
        "id":1531,
        "name":"813168  :  Brick Burner | ช่างเผาอิฐ | 烧砖机"
    },
    {
        "id":1532,
        "name":"813190  :  Operator Of Glass Kilns And Other Pottery Kilns | ช่างคุมเตาหลอมแก้วและเตาเผาเครื่องดินเผาอื่น ๆ | 玻璃窑炉和其他陶瓷窑炉操作员"
    },
    {
        "id":1533,
        "name":"813920  :  Employee Preparing Ground Beef Pottery | พนักงานเตรียมเนื้อดิน เครื่องดินเผา | 员工正在准备碎牛肉陶器"
    },
    {
        "id":1534,
        "name":"813922  :  Soil Washing Machine Operator | พนักงานคุมเครื่องล้างดิน | 土壤清洗机操作员"
    },
    {
        "id":1535,
        "name":"813924  :  Employee Preparing Clay (Tiles) | พนักงานเตรียมดินเผา (กระเบื้อง) | 员工准备粘土（瓷砖）"
    },
    {
        "id":1536,
        "name":"813925  :  Soil Press Machine Operator (Soil Extruder Operator, Soil Feeder And Extruder Technician) | พนักงานเครื่องรีดดิน (พนักงานเครื่องอัดรีดดิน , ช่างป้อนและรีดดิน) | 压土机操作员（土壤挤压机操作员、土壤供给机和挤压机技术员）"
    },
    {
        "id":1537,
        "name":"813927  :  Tile Pressing Machine Operator | พนักงานเครื่องอัดกระเบื้อง | 压瓦机操作工"
    },
    {
        "id":1538,
        "name":"813930  :  Technician Pressing Bricks And Tiles Using Machines | ช่างอัดอิฐและกระเบื้องด้วยเครื่องจักร | 技术人员使用机器压制砖瓦"
    },
    {
        "id":1539,
        "name":"813935  :  Pottery Compressor | ช่างอัดเครื่องดินเผา | 陶压缩机"
    },
    {
        "id":1540,
        "name":"813940  :  Employees Prepare Clay To Be Molded Using Machines. | พนักงานเตรียมเนื้อดินปั้นด้วยเครื่องจักร | 员工准备用机器成型的粘土。"
    },
    {
        "id":1541,
        "name":"813945  :  Clay Kneader | พนักงานนวดดิน | 捏土机"
    },
    {
        "id":1542,
        "name":"813946  :  Mineral And Soil Workers | พนักงานย่อยแร่และดิน | 矿物和土壤工人"
    },
    {
        "id":1543,
        "name":"813950  :  Employee Making Pottery Glaze | พนักงานทำน้ำเคลือบเครื่องดินเผา | 员工制作陶釉"
    },
    {
        "id":1544,
        "name":"813960  :  Technician Mixing Raw Materials For Making Glass | ช่างผสมวัตถุดิบทำแก้ว | 技术人员混合制造玻璃的原材料"
    },
    {
        "id":1545,
        "name":"813990  :  Glass Production Machine Operator Pottery And Other Related Machinery | ผู้ควบคุมเครื่องจักรผลิตเครื่องแก้ว เครื่องดินเผาและเครื่องจักรที่เกี่ยวข้องอื่นๆ | 玻璃生产机器操作员陶器及其他相关机械"
    },
    {
        "id":1546,
        "name":"814110  :  Crossbow Smith; Mr. Horse | ช่างตีหน้าไม้ ; นายม้า | 弩铁匠；马先生"
    },
    {
        "id":1547,
        "name":"814120  :  Sawyer (Sawmill) | ช่างเลื่อยไม้ (โรงเลื่อย) | 索耶（锯木厂）"
    },
    {
        "id":1548,
        "name":"814130  :  Sawyer; Mr. Ma Saw Soi | ช่างเลื่อยซอย ; นายม้าเลื่อยซอย | 索耶；马苏瑞先生"
    },
    {
        "id":1549,
        "name":"814140  :  Lumberjack | ช่างตัดไม้ | 伐木工"
    },
    {
        "id":1550,
        "name":"814150  :  Technician Peels Or Slices Thin Pieces Of Wood. | ช่างปอกหรือฝานไม้แผ่นบาง | 技术人员将木片剥皮或切成薄片。"
    },
    {
        "id":1551,
        "name":"814160  :  Plywood Maker Alternating Layers; Smooth Plywood Maker | ช่างทำไม้อัดสลับชั้น ; ช่างทำไม้อัดแผ่นเรียบ | 胶合板制造商交替层；光滑胶合板制造商"
    },
    {
        "id":1552,
        "name":"814190  :  Other Processing Machinery Employees | พนักงานเครื่องจักรแปรรูปอื่นๆ | 其他加工机械员工"
    },
    {
        "id":1553,
        "name":"814220  :  A Machine Operator Grinds Or Chops Wood To Make Pulp. | พนักงานเครื่องบดหรือสับไม้เพื่อทำเยื่อกระดาษ | 机器操作员研磨或砍伐木材来制造纸浆。"
    },
    {
        "id":1554,
        "name":"814230  :  An Employee Of A Boiler Shreds Materials To Make Paper Pulp. | พนักงานเครื่องต้มย่อยวัสดุเพื่อทำเยื่อกระดาษ | 锅炉工人将材料切碎以制造纸浆。"
    },
    {
        "id":1555,
        "name":"814235  :  Hydra Machine Operators Shred Materials To Make Paper Pulp. | พนักงานเครื่องไฮดราย่อยวัสดุเพื่อทำเยื่อกระดาษ | Hydra 机器操作员将材料切碎以制造纸浆。"
    },
    {
        "id":1556,
        "name":"814240  :  Pulp Bleacher Worker | พนักงานเครื่องฟอกเยื่อกระดาษ | 纸浆看台工人"
    },
    {
        "id":1557,
        "name":"814250  :  Pulp Beater Operator, Pulp Grinder Operator | พนักงานเครื่องตีเยื่อกระดาษ , พนักงานเครื่องบดเยื่อ | 打浆机操作员、纸浆研磨机操作员"
    },
    {
        "id":1558,
        "name":"814290  :  Other Pulp Machine Workers | พนักงานเครื่องทำเยื่อกระดาษอื่น ๆ | 其他纸浆机工人"
    },
    {
        "id":1559,
        "name":"814320  :  Wet-And Paper Production Machine Employee (Wet -End) | พนักงานเครื่องผลิตกระดาษเวท - แอนด์ (WET -END) | 湿法造纸机员工 (Wet -End)"
    },
    {
        "id":1560,
        "name":"814330  :  Dry - End Paper Production Machine Operator (Dry - End) | พนักงานเครื่องผลิตกระดาษดราย - แอนด์ (DRY - END) | 干-End造纸机操作员（Dry-End）"
    },
    {
        "id":1561,
        "name":"814340  :  Paper Press Operator Polishes Paper | พนักงานเครื่องอัดรีดขัดมันกระดาษ | 压纸机操作员抛光纸张"
    },
    {
        "id":1562,
        "name":"814390  :  Other Paper Machine Workers | พนักงานเครื่องผลิตกระดาษอื่น ๆ | 其他造纸机工人"
    },
    {
        "id":1563,
        "name":"815120  :  Chemical Mill Operator, Crusher Operator (Chemical Processes And Related Processes) | ผู้ควบคุมเครื่องโม่สารเคมี , พนักงานเครื่องย่อย (กรรมวิธีทางเคมีและกรรมวิธีที่เกี่ยวข้องกัน) | 化工厂操作员、破碎机操作员（化学工艺及相关工艺）"
    },
    {
        "id":1564,
        "name":"815125  :  Chemical Grinder Operator, Grinder Operator (Chemical Processes And Related Processes) | ผู้ควบคุมเครื่องบดสารเคมี, พนักงานเครื่องบด (กรรมวิธีทางเคมีและกรรมวิธีที่เกี่ยวข้องกัน) | 化学研磨机操作员、研磨机操作员（化学工艺及相关工艺）"
    },
    {
        "id":1565,
        "name":"815130  :  User Of Closed System Rubber Mixer, User Of Banbury Rubber Mixer | ผู้ใช้เครื่องผสมยางระบบปิด , ผู้ใช้เครื่องผสมยางแบนบูรี | 密闭系统炼胶机用户、班伯里炼胶机用户"
    },
    {
        "id":1566,
        "name":"815135  :  User Of Two-Roller Rubber Mixer Grinder | ผู้ใช้เครื่องบดผสมยางแบบสองลูกกลิ้ง | 二辊炼胶研磨机用户"
    },
    {
        "id":1567,
        "name":"815140  :  Chemical Mixer Operator, Mixer Operator (Chemical Processes And Related Processes) | ผู้ควบคุมเครื่องผสมสารเคมี , พนักงานเครื่องผสม (กรรมวิธีทางเคมีและกรรมวิธีที่เกี่ยวข้องกัน) | 化学搅拌机操作员、搅拌机操作员（化学工艺及相关工艺）"
    },
    {
        "id":1568,
        "name":"815190  :  Grinder Operator Milling And Other Blends | ผู้ควบคุมเครื่องบด โม่และผสมอื่น ๆ | 磨床操作员铣削和其他混合"
    },
    {
        "id":1569,
        "name":"815220  :  Simmer Operator (Chemical Process And Related Methods), Simmer Operator | ผู้ต้มเคี่ยว (กรรมวิธีทางเคมีและกรรมวิธีที่เกี่ยวข้อง) , ผู้ควบคุมหม้อต้มเคี่ยว | 慢煮操作员（化学过程和相关方法）、慢煮操作员"
    },
    {
        "id":1570,
        "name":"815225  :  Baking Operator (Chemical Process And Related Processes), Baking Pot Operator | ผู้อบ (กรรมวิธีทางเคมีและกรรมวิธีที่เกี่ยวข้อง) , ผู้ควบคุมหม้ออบ | 烘焙操作工（化学工艺及相关工艺）、烤锅操作工"
    },
    {
        "id":1571,
        "name":"815230  :  Steamer Operator (Chemical Processes And Related Processes) | ผู้ควบคุมหม้อนึ่ง (กรรมวิธีทางเคมีและกรรมวิธีที่เกี่ยวข้อง) | 轮船操作员（化学工艺及相关工艺）"
    },
    {
        "id":1572,
        "name":"815240  :  Cement Kiln Operator | ผู้ควบคุมเตาผลิตซีเมนต์ | 水泥窑操作工"
    },
    {
        "id":1573,
        "name":"815250  :  Rubber Sheet Smoking Furnace Warden, Rubber Sheet Smoking Furnace, Rubber Sheet Smoking Furnace Fire Keeper | ผู้คุมเตารมควันยางแผ่น , ผู้รมควันยางแผ่น , คนเฝ้าไฟเตารมควันยางแผ่น | 橡胶板冒烟炉守护者，橡胶板冒烟炉，橡胶板冒烟炉防火守护者"
    },
    {
        "id":1574,
        "name":"815255  :  Manufacturer Of Dried Rubber Sheets | ผู้ทำยางแผ่นผึ่งแห้ง | 干燥橡胶板制造商"
    },
    {
        "id":1575,
        "name":"815257  :  Rubber Block Oven Operator | พนักงานควบคุมเตาอบยางแท่ง | 橡胶块烤箱操作员"
    },
    {
        "id":1576,
        "name":"815290  :  Boilers, Simmers, Bakers, And Other Heat-Related Workers (Chemical Processes And Related Processes) | ผู้ต้มเคี่ยว อบและผู้ปฏิบัติงานที่เกี่ยวกับการใช้ความร้อนอื่นๆ(กรรมวิธีทางเคมีและกรรมวิธีที่เกี่ยวข้อง) | 锅炉、慢煮器、面包师和其他与热相关的工人（化学工艺和相关工艺）"
    },
    {
        "id":1577,
        "name":"815320  :  Filter Press Operator | ผู้ควบคุมเครื่องอัดกรอง | 压滤机操作员"
    },
    {
        "id":1578,
        "name":"815340  :  Operator Of Liquid Separator With Centrifugal System | ผู้ควบคุมเครื่องแยกของเหลวด้วยระบบหนีศูนย์ | 带离心系统的液体分离器操作员"
    },
    {
        "id":1579,
        "name":"815350  :  Crude Oil Separator Operator; Crude Oil Separator | ผู้ควบคุมเครื่องแยกน้ำมันดิบ ; ผู้แยกน้ำมันดิบ | 原油分离器操作员；原油分离器"
    },
    {
        "id":1580,
        "name":"815390  :  Operator Of Other Chemical Filtration And Separation Machines | ผู้ควบคุมเครื่องกรองและแยกสารเคมีอื่น ๆ | 其他化学过滤和分离机器的操作员"
    },
    {
        "id":1581,
        "name":"815420  :  Chemical Process Equipment Operator; Operator Of Single And Continuous Chemical Distillation Tanks (Except Petroleum And Natural Gas) | ผู้ควบคุมอุปกรณ์ในกระบวนการทางเคมี ; พนักงานควบคุมถังกลั่นทางเคมีชนิดเดี่ยวและต่อเนื่อง (ยกเว้นปิโตรเลียมและก๊าซธรรมชาติ) | 化学工艺设备操作员；单一和连续化学蒸馏罐操作员（石油、天然气除外）"
    },
    {
        "id":1582,
        "name":"815430  :  Evaporator Operator | ผู้ควบคุมเครื่องทำระเหย | 蒸发器操作员"
    },
    {
        "id":1583,
        "name":"815490  :  Operators Of Distillers And Other Chemical Reactors (Except Petroleum And Natural Gas) | ผู้ควบคุมเครื่องกลั่นและเตาปฏิกรณ์ทางเคมีอื่น ๆ (ยกเว้นปิโตรเลียมและก๊าซธรรมชาติ) | 蒸馏器和其他化学反应器的操作员（石油和天然气除外）"
    },
    {
        "id":1584,
        "name":"815510  :  Distillation Worker (Petroleum Oil) General | พนักงานเครื่องกลั่น (น้ำมันปิโตรเลียม) ทั่วไป | 蒸馏工（石油）一般"
    },
    {
        "id":1585,
        "name":"815520  :  Oil Separator Operator | ผู้ควบคุมเครื่องแยกน้ำมัน | 油分离器操作员"
    },
    {
        "id":1586,
        "name":"815530  :  Distillation Tower Operator (Petroleum And Natural Gas) | ผู้ควบคุมหอกลั่น (น้ำมันปิโตรเลียมและก๊าซธรรมชาติ) | 蒸馏塔操作员（石油和天然气）"
    },
    {
        "id":1587,
        "name":"815540  :  Reactor Worker (Petroleum Oil) | พนักงานเครื่องปฏิกรณ์ (น้ำมันปิโตรเลียม) | 反应堆工人（石油）"
    },
    {
        "id":1588,
        "name":"815590  :  Other Oil Refining Workers | ผู้ปฏิบัติงานเกี่ยวกับการกลั่นน้ำมันอื่น ๆ | 其他炼油工人"
    },
    {
        "id":1589,
        "name":"815920  :  Bleach (Chemical) Users | ผู้ใช้เครื่องฟอกสี (สารเคมี) | 漂白剂（化学品）使用者"
    },
    {
        "id":1590,
        "name":"815930  :  Manufacturer Of Raw Rubber Sheets (Rubber Sheet Maker From Latex) | ผู้ทำยางแผ่นดิบ (ผู้ทำยางแผ่นจากน้ำยาง) | 生胶板生产商（乳胶橡胶板制造机）"
    },
    {
        "id":1591,
        "name":"815932  :  Crepe Rubber Maker, Crepe Rubber Maker From Raw Rubber Scraps | ผู้ทำยางเครป , ผู้ทำยางเครปจากเศษยางดิบ | 绉胶生产商，生胶边角料生产绉胶"
    },
    {
        "id":1592,
        "name":"815934  :  Rubber Block Maker | ผู้ทำยางแท่ง | 橡胶块制造商"
    },
    {
        "id":1593,
        "name":"815940  :  Concentrated Latex Maker | ผู้ทำน้ำยางข้น | 浓缩乳胶机"
    },
    {
        "id":1594,
        "name":"815945  :  Employee Of Plastic Pellet Production Machine | พนักงานประจำเครื่องผลิตเม็ดพลาสติก | 塑料颗粒生产机员工"
    },
    {
        "id":1595,
        "name":"815950  :  Workers In The Coke Production Process | ผู้ปฏิบัติงานในกระบวนการผลิตถ่านโค้ก | 焦炭生产过程中的工人"
    },
    {
        "id":1596,
        "name":"815960  :  Workers In The Fertilizer Production Process | ผู้ปฏิบัติงานในกระบวนการผลิตปุ๋ย | 化肥生产过程中的工人"
    },
    {
        "id":1597,
        "name":"815970  :  Workers In The Synthetic Fiber Production Process | ผู้ปฏิบัติงานในกระบวนการผลิตเส้นใยสังเคราะห์ | 合成纤维生产过程中的工人"
    },
    {
        "id":1598,
        "name":"815990  :  Workers In Other Chemical Processes | ผู้ปฏิบัติงานในกรรมวิธีทางเคมีอื่น ๆ | 其他化学流程的工人"
    },
    {
        "id":1599,
        "name":"816120  :  Electrical Generator Operator, Control Room Employee (Electricity Production) | ผู้ควบคุมเครื่องผลิตกระแสไฟฟ้า , พนักงานประจำห้องควบคุม (การผลิตกระแสไฟฟ้า) | 发电机操作员、控制室员工（电力生产）"
    },
    {
        "id":1600,
        "name":"816130  :  Electrical Generating Station Operator (Water Power), Turbine Operator (Produce Electricity) | ผู้ควบคุมสถานีผลิตไฟฟ้า (พลังงานน้ำ) , พนักงานเครื่องกังหัน (ผลิตกระแสไฟฟ้า) | 发电站操作员（水力发电）、涡轮机操作员（发电）"
    },
    {
        "id":1601,
        "name":"816140  :  Electrical Generating Station Operator (Nuclear Energy) | ผู้ควบคุมสถานีผลิตไฟฟ้า (พลังงานนิวเคลียร์) | 发电站操作员（核能）"
    },
    {
        "id":1602,
        "name":"816150  :  Electrical Generating Station Operator (Solar Energy) | ผู้ควบคุมสถานีผลิตไฟฟ้า (พลังงานแสงอาทิตย์) | 发电站操作员（太阳能）"
    },
    {
        "id":1603,
        "name":"816160  :  Air Compressor Worker | พนักงานเครื่องอัดอากาศ | 空气压缩机工人"
    },
    {
        "id":1604,
        "name":"816170  :  Electricity Distribution Controller, Electrical Distribution Station Employee | ผู้ควบคุมการจ่ายกระแสไฟฟ้า , พนักงานประจำสถานีจ่ายไฟ | 配电控制器、配电站员工"
    },
    {
        "id":1605,
        "name":"816190  :  Operators Of Other Electric Power Generating Machinery | ผู้ปฏิบัติงานเครื่องจักรในการผลิตพลังงานไฟฟ้าอื่น ๆ | 其他发电机械操作员"
    },
    {
        "id":1606,
        "name":"816220  :  Boiler Operator, Boiler Electrician | ผู้ควบคุมหม้อน้ำ , ช่างไฟประจำหม้อน้ำ | 锅炉操作工、锅炉电工"
    },
    {
        "id":1607,
        "name":"816230  :  Steam Engine (Ship) Operator | ผู้ควบคุมเครื่องจักรไอน้ำ (เรือ) | 蒸汽机（船）操作员"
    },
    {
        "id":1608,
        "name":"816290  :  Steam Engine Operator And Other Steam Generators | ผู้ควบคุมเครื่องจักรไอน้ำ และหม้อกำเนิดไอน้ำอื่น ๆ | 蒸汽机操作员和其他蒸汽发生器"
    },
    {
        "id":1609,
        "name":"816320  :  Garbage Incinerator Operator | ผู้ควบคุมเตาเผาขยะ | 垃圾焚烧炉操作员"
    },
    {
        "id":1610,
        "name":"816330  :  Water Pump Operator | ผู้ควบคุมเครื่องสูบน้ำ | 水泵操作员"
    },
    {
        "id":1611,
        "name":"816335  :  Wastewater Treatment Machine Operator | ผู้ควบคุมเครื่องบำบัดน้ำเสีย | 废水处理机操作员"
    },
    {
        "id":1612,
        "name":"816340  :  Water Purification Machine Worker | พนักงานเครื่องทำน้ำให้บริสุทธิ์ | 净水机工人"
    },
    {
        "id":1613,
        "name":"816350  :  Refrigeration System Operator, Refrigeration System Operator | ผู้ควบคุมเครื่องระบบทำความเย็น , พนักงานควบคุมระบบเครื่องทำความเย็น | 制冷系统操作员、制冷系统操作员"
    },
    {
        "id":1614,
        "name":"816390  :  Garbage Incinerator Operator Wastewater Treatment And Other Related Works | ผู้ควบคุมเตาเผาขยะ งานบำบัดน้ำเสียและงานที่เกี่ยวข้องอื่น ๆ | 垃圾焚烧炉操作员废水处理及其他相关工程"
    },
    {
        "id":1615,
        "name":"817120  :  Machine Operator For Automatic Assembly | ผู้ควบคุมเครื่องจักรในการประกอบชิ้นส่วนแบบอัตโนมัติ | 自动装配机器操作员"
    },
    {
        "id":1616,
        "name":"817130  :  Machine Operator For Semi-Automatic Assembly | ผู้ควบคุมเครื่องจักรในการประกอบชิ้นส่วนแบบกึ่งอัตโนมัติ | 半自动装配机器操作员"
    },
    {
        "id":1617,
        "name":"817220  :  Robot Operator | ผู้ควบคุมหุ่นยนต์ | 机器人操作员"
    },
    {
        "id":1618,
        "name":"821110  :  General Machine Tool Operator (Metal Work) | ผู้ควบคุมเครื่องมือกล (งานโลหะ) ทั่วไป | 通用机床操作员（金属加工）"
    },
    {
        "id":1619,
        "name":"821120  :  Lathe Operator (Metal Work), Lathe Operator (Swivel Base Type, Fixed) | ผู้ควบคุมเครื่องกลึง (งานโลหะ) , ช่างกลึง (แบบฐานหมุน , คงที่) | 车床操作员（金属加工）、车床操作员（旋转基座式、固定式）"
    },
    {
        "id":1620,
        "name":"821125  :  Planer Operator (Metal Work), Mobile Platform Type, Steel Platform Type | ผู้ควบคุมเครื่องไส (งานโลหะ) ชนิดแท่นเคลื่อนที่ , ชนิดแท่นเหล็ก | 刨床操作员（金属加工）、移动平台型、钢平台型"
    },
    {
        "id":1621,
        "name":"821130  :  Gear Cutter Operator (Metal Work), Gear Cutter | ผู้ควบคุมเครื่องตัดเฟือง (งานโลหะ) , ช่างตัดเฟือง | 齿轮铣刀操作员（金属加工）、齿轮铣刀"
    },
    {
        "id":1622,
        "name":"821135  :  Metal Saw Operator | ผู้ควบคุมเครื่องเลื่อยโลหะ | 金属锯操作员"
    },
    {
        "id":1623,
        "name":"821140  :  Winch Operator (Metal Work) | ผู้ควบคุมเครื่องกว้าน (งานโลหะ) | 绞车操作员（金属加工）"
    },
    {
        "id":1624,
        "name":"821145  :  Drilling Machine Operator (Metal Work) | ผู้ควบคุมเครื่องเจาะ (งานโลหะ) | 钻床操作员（金属加工）"
    },
    {
        "id":1625,
        "name":"821150  :  Precision Grinding Machine Operator (Metal Work) | ผู้ควบคุมเครื่องเจียระไนที่มีความเที่ยงตรงแม่นยำ (งานโลหะ) | 精密磨床操作员（金属加工）"
    },
    {
        "id":1626,
        "name":"821155  :  Machine Operator For Making Metal Formwork Cores | ผู้ควบคุมเครื่องจักรทำแกนแบบหล่อโลหะ | 制造金属模板芯的机器操作员"
    },
    {
        "id":1627,
        "name":"821160  :  Operator Of Barbed Wire Making Machine | พนักงานคุมเครื่องทำลวดหนาม | 刺绳制造机操作员"
    },
    {
        "id":1628,
        "name":"821190  :  Operators Of Machinery And Other Metal Processing Equipment | ผู้ควบคุมเครื่องจักรและอุปกรณ์แปรรูปโลหะอื่น ๆ | 机械和其他金属加工设备操作员"
    },
    {
        "id":1629,
        "name":"821220  :  Cement Block Molder, Cement Block Maker | ผู้หล่อซีเมนต์บล๊อค , ผู้ทำซีเมนต์บล๊อค | 水泥砌块成型机，水泥砌块成型机"
    },
    {
        "id":1630,
        "name":"821230  :  Operator Of Concrete Cement Casting Machine | ผู้ควบคุมเครื่องหล่อซีเมนต์คอนกรีต | 混凝土水泥浇注机操作员"
    },
    {
        "id":1631,
        "name":"821240  :  Concrete Mixer Work Wall | พนังงานเครื่องผสมคอนกรีต | 混凝土搅拌机工作墙"
    },
    {
        "id":1632,
        "name":"822120  :  Detergent Production Machine Operator | ผู้ควบคุมเครื่องผลิตผงซักฟอก | 洗涤剂生产机操作员"
    },
    {
        "id":1633,
        "name":"822130  :  Machine Operator Producing Medical Products | ผู้ควบคุมเครื่องผลิตผลิตภัณฑ์รักษาโรค | 生产医疗产品的机器操作员"
    },
    {
        "id":1634,
        "name":"822140  :  Operator Of A Machine That Produces Bathroom Products And Supplies | ผู้ควบคุมเครื่องผลิตผลิตภัณฑ์และของใช้สำหรับห้องน้ำ | 生产浴室产品和用品的机器操作员"
    },
    {
        "id":1635,
        "name":"822150  :  Cosmetic Product Production Machine Operator | ผู้ควบคุมเครื่องผลิตผลิตภัณฑ์เครื่องสำอาง | 化妆品生产机器操作员"
    },
    {
        "id":1636,
        "name":"822190  :  Machine Operators Producing Other Chemical Products | ผู้ควบคุมเครื่องจักรผลิตผลิตภัณฑ์เคมีอื่น ๆ | 生产其他化学产品的机器操作员"
    },
    {
        "id":1637,
        "name":"822210  :  Operator Of Gunpowder Bullet Production Machine | ผู้ควบคลุมเครื่องผลิตกระสุนดินปืน | 火药子弹生产机操作员"
    },
    {
        "id":1638,
        "name":"822220  :  Gunpowder Machine Operator | ผู้ควบคุมเครื่องผลิตกระสุนดินปืน | 火药机操作员"
    },
    {
        "id":1639,
        "name":"822225  :  Operator Of Explosives Production Machine | ผู้ควบคุมเครื่องผลิตวัตถุระเบิดh | 炸药生产机器操作员"
    },
    {
        "id":1640,
        "name":"822230  :  Match Making Machine Operator, Match Maker | ผู้ควบคุมเครื่องผลิตไม้ขีดไฟ , ผู้ทำไม้ขีดไฟ | 媒人、媒人"
    },
    {
        "id":1641,
        "name":"822290  :  Machine Operators For The Production Of Ammunition And Other Explosive Products | ผู้ควบคุมเครื่องจักรในการผลิตผลิตภัณฑ์กระสุนปืนและวัตถุระเบิดอื่น ๆ | 生产弹药和其他爆炸产品的机器操作员"
    },
    {
        "id":1642,
        "name":"822310  :  General Plating And Coating (Metal) Machine Operator | ผู้ควบคุมเครื่องชุบและเคลือบ (โลหะ) ทั่วไป | 一般电镀和涂层（金属）机器操作员"
    },
    {
        "id":1643,
        "name":"822320  :  Metal Finishing Machine Operator | ผู้ควบคุมเครื่องตกแต่งสำเร็จงานโลหะ | 金属精加工机操作员"
    },
    {
        "id":1644,
        "name":"822330  :  Sand Blasting Machine User (Metal) | ผู้ใช้เครื่องพ่นทราย (โลหะ) | 喷砂机用户（金属）"
    },
    {
        "id":1645,
        "name":"822390  :  Machine Operators For Decorating, Coating And Plating Metals, Etc. | ผู้ควบคุมเครื่องจักรในการตกแต่งการเคลือบและชุบผิวโลหะ อื่น ๆ | 装饰、涂层和电镀金属等机械操作员"
    },
    {
        "id":1646,
        "name":"822420  :  Film Developing Machine Operator, Film Development Technician | ผู้ควบคุมเครื่องล้างฟิล์ม , ช่างล้างฟิล์ม | 胶片冲洗机操作员、胶片冲洗技术员"
    },
    {
        "id":1647,
        "name":"822430  :  Photo Enlarger Operator | ผู้ควบคุมเครื่องอัดขยายภาพถ่าย | 照片放大操作员"
    },
    {
        "id":1648,
        "name":"822435  :  Photo Printer Operator (Color) | ผู้ควบคุมเครื่องพิมพ์ภาพถ่าย (สี) | 照片打印机操作员（彩色）"
    },
    {
        "id":1649,
        "name":"822440  :  Film Production Machine Operator | ผู้ควบคุมเครื่องผลิตฟิล์ม | 薄膜生产机操作员"
    },
    {
        "id":1650,
        "name":"822490  :  Machine Operators In The Production Of Other Photographic Products | ผู้ควบคุมเครื่องจักรในการผลิตผลิตภัณฑ์การถ่ายภาพอื่น ๆ | 其他摄影产品生产中的机器操作员"
    },
    {
        "id":1651,
        "name":"822920  :  Machine Operator For Candle Production | ผู้ควบคุมเครื่องจักรในการผลิตเทียนไข | 蜡烛生产机器操作员"
    },
    {
        "id":1652,
        "name":"822930  :  Operator Of Various Gas Production Machines (Chlorine, Hydrogen) | ผู้ควบคุมเครื่องผลิตก๊าซต่าง ๆ (คลอรีน , ไฮโดรเจน ) | 各种气体生产机器（氯气、氢气）操作员"
    },
    {
        "id":1653,
        "name":"822940  :  Linoleum Production Machine Operator | ผู้ควบคุมเครื่องผลิตเสื่อน้ำมัน | 油毡生产机器操作员"
    },
    {
        "id":1654,
        "name":"822950  :  Pencil Production Machine Operator | ผู้ควบคุมเครื่องผลิตดินสอ | 铅笔生产机操作员"
    },
    {
        "id":1655,
        "name":"822990  :  Machine Operators For The Production Of Other Chemical Products Not Classified Elsewhere | ผู้ควบคุมเครื่องจักรในการผลิตผลิตภัณฑ์เคมีอื่น ๆ ที่มิได้จัดประเภทไว้ในที่อื่น | 生产未分类于别处的其他化学产品的机器操作员"
    },
    {
        "id":1656,
        "name":"823110  :  Operator Of Rubber Product Extrusion Machine | พนักงานควบคุมเครื่องอัดขึ้นรูปผลิตภัณฑ์ยาง | 橡胶制品挤出机操作工"
    },
    {
        "id":1657,
        "name":"823115  :  Tire Retreading Worker | พนักงานหล่อดอกยาง | 轮胎翻新工"
    },
    {
        "id":1658,
        "name":"823120  :  An Employee Controls A Die-Pressing Rubber Product Forming Machine. | พนักงานควบคุมเครื่องขึ้นรูปผลิตภัณฑ์ยางแบบอัดผ่านดายน์ | 一名员工正在控制模压橡胶制品成型机。"
    },
    {
        "id":1659,
        "name":"823125  :  Rubber Extruder Machine Operator | พนักงานควบคุมเครื่องอัดรีดยาง | 橡胶挤出机操作员"
    },
    {
        "id":1660,
        "name":"823130  :  Rubber Injection Machine Operator | พนักงานควบคุมเครื่องฉีดยาง | 橡胶注射机操作员"
    },
    {
        "id":1661,
        "name":"823140  :  Operator Of Tire Molding Machine | พนักงานควบคุมเครื่องขึ้นรูปยางรถยนต์ | 轮胎成型机操作工"
    },
    {
        "id":1662,
        "name":"823150  :  Operator Of Machine To Produce Products From Latex Dip | พนักงานควบคุมเครื่องจักรผลิตผลิตภัณฑ์จากน้ำยางแบบจุ่ม | 机器操作员用乳胶浸胶生产产品"
    },
    {
        "id":1663,
        "name":"823155  :  An Operator Of A Machine That Produces Sponges From Latex. | พนักงานควบคุมเครื่องจักรผลิตฟองน้ำจากน้ำยาง | 用乳胶生产海绵的机器的操作员。"
    },
    {
        "id":1664,
        "name":"823160  :  An Operator Of A Machine Producing Rubber Yarn Made From Latex. | พนักงานควบคุมเครื่องจักรผลิตเส้นด้ายยางยึดจากน้ำยาง | 生产乳胶橡胶纱的机器的操作员。"
    },
    {
        "id":1665,
        "name":"823190  :  Machine Operators Producing Other Rubber Products | พนักงานควบคุมเครื่องจักรผลิตผลิตภัณฑ์ยางอื่น ๆ | 生产其他橡胶制品的机器操作员"
    },
    {
        "id":1666,
        "name":"823220  :  Operator Of Plastic Thermoforming Machine | พนักงานควบคุมเครื่องขึ้นรูปพลาสติกด้วยความร้อน | 塑料热成型机操作员"
    },
    {
        "id":1667,
        "name":"823230  :  Plastic Injection Machine Operator | พนักงานควบคุมเครื่องฉีดพลาสติก | 塑料注射机操作员"
    },
    {
        "id":1668,
        "name":"823240  :  Film Blowing Machine Operator | พนักงานควบคุมเครื่องเป่าฟิล์ม | 吹膜机操作员"
    },
    {
        "id":1669,
        "name":"823245  :  Operator Of Hollow Container Dryer | พนักงานควบคุมเครื่องเป่าภาชนะกลวง | 中空容器干燥机操作工"
    },
    {
        "id":1670,
        "name":"823250  :  Operator Of Plastic Extrusion Machine | พนักงานควบคุมเครื่องอัดขึ้นรูปพลาสติก | 塑料挤出机操作员"
    },
    {
        "id":1671,
        "name":"823260  :  Fiberglass Mold Maker | ช่างทำแม่แบบไฟเบอร์กลาส | 玻璃纤维模具制造商"
    },
    {
        "id":1672,
        "name":"823265  :  Fiberglass Product Maker | ช่างทำผลิตภัณฑ์ไฟเบอร์กลาส | 玻璃纤维制品制造商"
    },
    {
        "id":1673,
        "name":"823290  :  Machine Operators For Producing Other Plastic Products | พนักงานควบคุมเครื่องจักรในการผลิตผลิตภัณฑ์พลาสติกอื่น ๆ | 生产其他塑料制品的机器操作员"
    },
    {
        "id":1674,
        "name":"824010  :  General Woodworking Machinery Workers, Technicians Who Set Up And Use General Woodworking Machinery. | พนักงานเครื่องจักรทำงานไม้ทั่วไป , ช่างตั้งและใช้เครื่องจักรทำงานไม้ทั่วไป | 一般木工机械工人、安装和使用一般木工机械的技术人员。"
    },
    {
        "id":1675,
        "name":"824020  :  Technician Adjusts And Uses Wood Sawing Machinery. | ช่างปรับตั้งและใช้เครื่องจักรเลื่อยไม้ | 技术人员调整和使用木材锯切机械。"
    },
    {
        "id":1676,
        "name":"824030  :  Technician Adjusts And Uses An Automatic Lathe. | ช่างปรับตั้งและใช้เครื่องกลึงอัตโนมัติ | 技术人员调整并使用自动车床。"
    },
    {
        "id":1677,
        "name":"824040  :  Technician Adjusts And Uses Woodworking Machinery. | ช่างปรับตั้งและใช้เครื่องจักรขึ้นรูปงานไม้ | 技术人员调整和使用木工机械。"
    },
    {
        "id":1678,
        "name":"824045  :  Technician Adjusts And Uses Machinery To Make Cornices Or Grooves. | ช่างปรับตั้งและใช้เครื่องจักรทำบัวหรือร่อง | 技术人员调整并使用机械来制作檐口或凹槽。"
    },
    {
        "id":1679,
        "name":"824050  :  Technician Adjusts And Uses Wood Planing Machinery. | ช่างปรับตั้งและใช้เครื่องจักรไสไม้ | 技术人员调整和使用刨木机械。"
    },
    {
        "id":1680,
        "name":"824055  :  Technician Adjusts And Uses Machinery To Make Spurs. | ช่างปรับตั้งและใช้เครื่องจักรทำเดือย | 技术人员调整并使用机械制作马刺。"
    },
    {
        "id":1681,
        "name":"824060  :  Technician Adjusts And Uses Wood Carving Machinery. | ช่างปรับตั้งและใช้เครื่องจักรแกะสลักงานไม้ | 技术人员调整和使用木雕机械。"
    },
    {
        "id":1682,
        "name":"824080  :  Machine Worker Making Scientific Wood Panels | พนักงานเครื่องจักรทำแผ่นไม้วิทยาศาสตร์ | 机器工人制作科学木板"
    },
    {
        "id":1683,
        "name":"824085  :  Machine Operator Making Flat Plywood | พนักงานเครื่องจักรทำไม้อัดแผ่นเรียบ | 机器操作员制作平板胶合板"
    },
    {
        "id":1684,
        "name":"824087  :  Machine Worker Making Wooden Floor Panels | พนักงานเครื่องจักรทำแผ่นไม้ปูพื้น | 机械工人正在制作木地板"
    },
    {
        "id":1685,
        "name":"824090  :  Machinery Workers Producing Other Wood Products | พนักงานเครื่องจักรผลิตผลิตภัณฑ์ไม้อื่น ๆ | 生产其他木制品的机械工人"
    },
    {
        "id":1686,
        "name":"825120  :  Offset Printing Press Technician | ช่างแท่นพิมพ์ออฟเซท | 胶印机技术员"
    },
    {
        "id":1687,
        "name":"825130  :  Letterpress Printing Technician | ช่างแท่นพิมพ์เลตเตอร์เพรส์ส | 凸版印刷技术员"
    },
    {
        "id":1688,
        "name":"825140  :  Flexographic Printing Press Technician | ช่างแท่นพิมพ์เฟล็กโซกราฟี | 柔版印刷机技术员"
    },
    {
        "id":1689,
        "name":"825150  :  Deep Groove Press Technician, Inthayo | ช่างแท่นพิมพ์ร่องลึก , อินทาโย | 深槽压力机技术员，Inthayo"
    },
    {
        "id":1690,
        "name":"825160  :  Deep-Bed Press Technician, Gravure | ช่างแท่นพิมพ์พื้นลึก , กราวัวร์ | 凹版深床印刷技术员"
    },
    {
        "id":1691,
        "name":"825170  :  Screen Printing Press Technician | ช่างแท่นพิมพ์สกรีน | 丝网印刷机技术员"
    },
    {
        "id":1692,
        "name":"825190  :  Other Press Technicians | ช่างแท่นพิมพ์อื่น ๆ | 其他冲压技术人员"
    },
    {
        "id":1693,
        "name":"825210  :  Book Binding Technician (Book Binding Machine Operator) | ช่างเข้าเล่มหนังสือ (ผู้คุมเครื่องเข้าเล่มหนังสือ) | 书籍装订技术员（装订机操作员）"
    },
    {
        "id":1694,
        "name":"825220  :  Press Technician (Embossing Images And Letters On Books), Book Press Machine Operator | ช่างแท่นปั๊ม (ปั้มภาพและอักษรนูนบนหนังสือ) , พนักงานคุมเครื่องดุนหนังสือ | 压榨技术员（在书籍上压印图像和字母）、压书机操作员"
    },
    {
        "id":1695,
        "name":"825230  :  Plastic Coating Technician | ช่างเคลือบด้วยพลาสติก | 塑料涂装技术员"
    },
    {
        "id":1696,
        "name":"825235  :  Uv Varnish Technician (Printed) | ช่างเคลือบเงาระบบยูวี (สิ่งพิมพ์) | Uv光油技术员（印刷）"
    },
    {
        "id":1697,
        "name":"825240  :  Polisher | ช่างขัดมัน | 抛光机"
    },
    {
        "id":1698,
        "name":"825250  :  Cover Maker With Machine | ช่างทำปกด้วยเครื่อง | 封面机"
    },
    {
        "id":1699,
        "name":"825290  :  Other Book Binding Machine Operators | พนักงานคุมเครื่องเข้าเล่มหนังสืออื่น ๆ | 其他书籍装订机操作员"
    },
    {
        "id":1700,
        "name":"825320  :  Operator Of A Machine For Making Cardboard Sheets Or Making Corrugated Cardboard Sheets. | พนักงานคุมเครื่องทำแผ่นกระดาษแข็งหรือทำแผ่นกระดาษกล่องลูกฟูก | 制造纸板或制造瓦楞纸板的机器的操作员。"
    },
    {
        "id":1701,
        "name":"825330  :  Operator Of Cutting And Folding Machine (Making Paper Boxes), Machine Operator Cutting And Folding Paper Boxes | พนักงานคุมเครื่องตัดและรีดพับ (ทำกล่องกระดาษ) , พนักงานเครื่องตัดและพับกล่องกระดาษ | 剪折机操作工（制作纸盒），机器操作员切割和折叠纸盒"
    },
    {
        "id":1702,
        "name":"825335  :  Operator Of Machine To Make Envelopes And Paper Bags | พนักงานคุมเครื่องทำซองและถุงกระดาษ | 制造信封和纸袋的机器操作员"
    },
    {
        "id":1703,
        "name":"825340  :  Operator Of A Machine That Makes Thin Clear Bags | พนักงานคุมเครื่องทำถุงบางใส | 制造薄透明袋的机器的操作员"
    },
    {
        "id":1704,
        "name":"825345  :  Operator Of Paper Bag Making Machine | พนักงานคุมเครื่องทำถุงกระดาษ | 纸袋制袋机操作员"
    },
    {
        "id":1705,
        "name":"825350  :  Operator Of A Paper Bag Sewing Machine | พนักงานคุมเครื่องเย็บถุงกระดาษ | 纸袋缝纫机的操作员"
    },
    {
        "id":1706,
        "name":"825390  :  Machine Operator Producing Other Paper Products | พนักงานคุมเครื่องผลิตผลิตภัณฑ์กระดาษอื่น ๆ | 生产其他纸制品的机器操作员"
    },
    {
        "id":1707,
        "name":"826120  :  Workers Mix And Clean The Fibers. | พนักงานผสมและทำความสะอาดเส้นใย | 工人们混合并清洁纤维。"
    },
    {
        "id":1708,
        "name":"826130  :  Employee Carding Fibers | พนักงานสางเส้นใย | 员工梳理纤维"
    },
    {
        "id":1709,
        "name":"826135  :  Workers Ironing Fibers | พนักงานรีดปุยเส้นใย | 工人熨烫纤维"
    },
    {
        "id":1710,
        "name":"826140  :  Simplex Or Roving Machine Operator | พนักงานเครื่องซิมเพลกซ์หรือเครื่องโรฟวิ่ง | 单工或粗纱机操作员"
    },
    {
        "id":1711,
        "name":"826150  :  Worker Spinning Thread With Machine | พนักงานปั่นด้ายด้วยเครื่องจักร | 工人用机器纺线"
    },
    {
        "id":1712,
        "name":"826155  :  Yarn Spinning Worker | พนักงานปั่นเกลียวเส้นด้าย | 纺纱工"
    },
    {
        "id":1713,
        "name":"826160  :  Employees Combine Yarn With Machines. | พนักงานควบเส้นด้ายด้วยเครื่องจักร | 员工将纱线与机器结合起来。"
    },
    {
        "id":1714,
        "name":"826170  :  Thread Winder Employee | พนักงานกรอด้าย | 绕线工员工"
    },
    {
        "id":1715,
        "name":"826175  :  Employees Wind Threads Into Yarns. | พนักงานกรอด้ายให้เป็นไจ | 员工将线绕成纱线。"
    },
    {
        "id":1716,
        "name":"826180  :  Manufacturer Of Coconut Husk Fibers | ผู้ทำเส้นใยกาบมะพร้าว | 椰壳纤维制造商"
    },
    {
        "id":1717,
        "name":"826190  :  Employees Prepare Fibers With Other Machines. | พนักงานเตรียมเส้นใยด้วยเครื่องจักรอื่น ๆ | 员工用其他机器准备纤维。"
    },
    {
        "id":1718,
        "name":"826220  :  A Card Maker Weaves Brocade Cloth In The Form Of Handing Out Cards. | ช่างทำบัตรทอผ้ายกดอกแบบแจกการ์ดh | 制卡师将锦布编织成分发卡片的形式。"
    },
    {
        "id":1719,
        "name":"826225  :  Card Puncher And Weaver | ช่างเจาะบัตรทอผ้ายกดอก | 打卡机和织卡机"
    },
    {
        "id":1720,
        "name":"826230  :  Employees Prepare To Roll The Warp Thread. | พนักงานเตรียมม้วนด้ายยืน | 员工们准备卷绕经线。"
    },
    {
        "id":1721,
        "name":"826235  :  Workers String Spools For Use In Weaving With Machines. | พนักงานร้อยตะกรอเพื่อใช้ในการทอผ้าด้วยเครื่องจักร | 工人正在用机器编织线轴。"
    },
    {
        "id":1722,
        "name":"826238  :  Employees Powder The Warp Yarn. | พนักงานลงแป้งเส้นด้ายยืน | 员工给经纱撒粉。"
    },
    {
        "id":1723,
        "name":"826240  :  Weaving Machine Adjuster (Except For The Card-Distributing Loom) | ช่างปรับตั้งเครื่องจักรทอผ้า (ยกเว้นเครื่องทอผ้ายกดอกแบบแจกการ์ด) | 织机调节器（发卡机除外）"
    },
    {
        "id":1724,
        "name":"826245  :  Machine Weaver (Except For The Yoddok Weaving Machine) | ช่างทอผ้าด้วยเครื่องจักร (ยกเว้นเครื่องทอผ้ายกดอก) | 机织工（Yoddok 织机除外）"
    },
    {
        "id":1725,
        "name":"826250  :  Technician Who Adjusts The Weaving Machine For Giving Out Cards. | ช่างปรับตั้งเครื่องจักรทอผ้ายกดอกแบบแจกการ์ด | 调整织布机以发放卡片的技术人员。"
    },
    {
        "id":1726,
        "name":"826255  :  Weaver Using A Weaving Loom, Weaving Machine Operator (Card Distribution Form) | ช่างทอผ้าด้วยเครื่องทอผ้ายกดอก , ผู้ควบคุมเครื่องจักรทอผ้า (แบบแจกการ์ด) | 使用织机的织工、织机操作员（发卡表格）"
    },
    {
        "id":1727,
        "name":"826260  :  Dobby Loom Operator | พนักงานเครื่องทอผ้าแบบดอบบี้ | 多臂织机操作员"
    },
    {
        "id":1728,
        "name":"826270  :  Knitting Machine Adjuster | ช่างปรับตั้งเครื่องถัก | 针织机调节器"
    },
    {
        "id":1729,
        "name":"826275  :  Knitting Machine Operator | ผู้ควบคุมเครื่องถักผ้า | 针织机操作员"
    },
    {
        "id":1730,
        "name":"826278  :  Yarn Threader Using A Machine | ช่างทำเกลียวเส้นด้ายด้วยเครื่องจักร | 使用机器穿线器"
    },
    {
        "id":1731,
        "name":"826280  :  Net Weavers Using Machines, Net Machine Operators | ช่างทอแห อวน ด้วยเครื่องจักร , ผู้ควบคุมเครื่องผลิตตาข่าย | 使用机器的织网工、织网机操作员"
    },
    {
        "id":1732,
        "name":"826285  :  Carpet Weaver Using Machines | ช่างทอพรมด้วยเครื่องจักร | 使用机器的地毯编织工"
    },
    {
        "id":1733,
        "name":"826290  :  Weavers, Knitters And Other Machines | ช่างทอ ช่างถักผ้าด้วยเครื่องจักรอื่น ๆ | 织布机、针织机和其他机器"
    },
    {
        "id":1734,
        "name":"826320  :  Textile, Knitted And Clothing Product Sewing Technician, Industrial Sewing Machine Technician | ช่างเย็บผลิตภัณฑ์สิ่งทอสิ่งถักและเครื่องแต่งกาย , ช่างเย็บจักรอุตสาหกรรม | 纺织、针织及服装产品缝制技术员、工业缝纫机技术员"
    },
    {
        "id":1735,
        "name":"826330  :  Embroiderer, Embroiderer | ช่างปักจักร , ช่างปักผ้า | 绣花师，绣花师"
    },
    {
        "id":1736,
        "name":"826340  :  Lace Embroidery Machine | ช่างปักผ้าลูกไม้ด้วยเครื่องจักร | 花边绣花机"
    },
    {
        "id":1737,
        "name":"826390  :  Seamstress, Embroidery Worker With Other Machines | ช่างเย็บ ช่างปักด้วยเครื่องจักรอื่น ๆ | 裁缝、刺绣工人与其他机器"
    },
    {
        "id":1738,
        "name":"826420  :  Operator Of Yarn And Fabric Bleaching Machine | พนักงานคุมเครื่องฟอกขาวเส้นด้ายและผืนผ้า | 纱线和织物漂白机操作员"
    },
    {
        "id":1739,
        "name":"826430  :  Yarn Dyeing Machine Operator, Yarn Dyeing Machine Technician | พนักงานคุมเครื่องย้อมเส้นด้าย , ช่างย้อมเส้นด้ายด้วยเครื่องจักร | 纱线染色机操作工、纱线染色机技术员"
    },
    {
        "id":1740,
        "name":"826440  :  Fabric Dyeing Machine Operator, Fabric Dyeing Machine | พนักงานคุมเครื่องย้อมผืนผ้า , ช่างย้อมผืนผ้าด้วยเครื่องจักร | 织物染色机操作员、织物染色机"
    },
    {
        "id":1741,
        "name":"826450  :  Operator Of A Washing Machine Washing Knitted Items | พนักงานคุมเครื่องซักล้างสิ่งทอสิ่งถัก | 洗衣机操作员清洗针织品"
    },
    {
        "id":1742,
        "name":"826460  :  Operator Of Fabric Decoration, Textiles, Knitted Items | พนักงานคุมเครื่องตกแต่งผืนผ้าสิ่งทอสิ่งถัก | 织物装饰、纺织品、针织品经营者"
    },
    {
        "id":1743,
        "name":"826490  :  Air Purifier Operator Dyeing And Cleaning Other Woven Fabrics | พนักงานคุมเครื่องฟอก ย้อมและทำความสะอาดสิ่งทอสิ่งถักอื่นๆ | 空气净化器操作员其他机织物的染色和清洗"
    },
    {
        "id":1744,
        "name":"826520  :  Workers Scrape Skin And Fur | พนักงานถากหนังขูดขน | 工人们刮擦皮肤和毛皮"
    },
    {
        "id":1745,
        "name":"826530  :  Leather Cutting Machine Operator | พนักงานเครื่องผ่าหนัง | 皮革切割机操作员"
    },
    {
        "id":1746,
        "name":"826540  :  Tanning Machine Operator | พนักงานคุมเครื่องฟอกหนัง | 制革机操作员"
    },
    {
        "id":1747,
        "name":"826550  :  Leather Dresser Worker , Leather Decorating Technician | พนักงานเครื่องแต่งสีหนัง ,ช่างคุมเครื่องตกแต่งสีหนัง | 皮革梳妆台工人、皮革装饰技师"
    },
    {
        "id":1748,
        "name":"826560  :  Wool Mixing Machine Operator | พนักงานคุมเครื่องผสมขนสัตว์ | 混毛机操作员"
    },
    {
        "id":1749,
        "name":"826570  :  The Operator Of The Machine Pulls And Stretches Wool Fibers. | พนักงานคุมเครื่องดึง ยืด เส้นใยขนสัตว์ | 机器操作员拉动和拉伸羊毛纤维。"
    },
    {
        "id":1750,
        "name":"826620  :  Machine Operator Cutting Parts Of Shoe Leather | พนักงานเครื่องตัดชิ้นส่วนหนังหน้ารองเท้า | 机器操作员切割鞋革零件"
    },
    {
        "id":1751,
        "name":"826625  :  Shoe Sole Cutting Machine Operator | พนักงานเครื่องตัดพื้นรองเท้า | 鞋底切割机操作工"
    },
    {
        "id":1752,
        "name":"826630  :  Shoe Sewing Machine Worker | พนักงานเครื่องเย็บรองเท้า | 制鞋机工人"
    },
    {
        "id":1753,
        "name":"826920  :  Hat Production Machine Operator, Hat Maker With Machinery | พนักงานควบคุมเครื่องจักรผลิตหมวก , ช่างทำหมวกด้วยเครื่องจักร | 帽子生产机操作员、带机械的帽子制造商"
    },
    {
        "id":1754,
        "name":"826930  :  The Operator Of The Machine Knits The Thread Into Twists. | พนักงานคุมเครื่องถักด้ายให้เป็นเกลียว | 机器操作员将线编织成麻花。"
    },
    {
        "id":1755,
        "name":"826990  :  Machine Operator Producing Textile, Knitted, Wool, And Leather Products. Which Are Not Classified Anywhere Else | พนักงานคุมเครื่องผลิตผลิตภัณฑ์สิ่งทอสิ่งถัก ขนสัตว์ และเครื่องหนัง ซึ่งมิได้จัดประเภทไว้ในในที่อื่น | 生产纺织、针织、羊毛和皮革产品的机器操作员。没有被分类在其他任何地方"
    },
    {
        "id":1756,
        "name":"827120  :  Machine Operators Produce Food Products From Meat And Aquatic Animals In Sealed Containers (Cans, Glass Bottles, Etc.). | ผู้ควบคุมเครื่องผลิตผลิตภัณฑ์อาหารจากเนื้อสัตว์และสัตว์น้ำในภาชนะบรรจุปิดสนิท (กระป๋อง ขวดแก้ว ฯลฯ ) | 机器操作员在密封容器（罐头、玻璃瓶等）中生产肉类和水生动物食品。"
    },
    {
        "id":1757,
        "name":"827125  :  Sausage Making Machine Operator | ผู้ควบคุมเครื่องทำไส้กรอก | 香肠制作机操作工"
    },
    {
        "id":1758,
        "name":"827130  :  Machine Operator Producing Food Products From Meat And Aquatic Animals Chill And Freeze | ผู้ควบคุมเครื่องผลิตผลิตภัณฑ์อาหารจากเนื้อสัตว์และสัตว์น้ำ แช่เย็นและแช่เยือกแข็ง | 机器操作员生产肉类和水生动物食品冷藏和冷冻"
    },
    {
        "id":1759,
        "name":"827190  :  Machine Operators Producing Food Products From Meat And Other Aquatic Animals | ผู้ควบคุมเครื่องจักรผลิตผลิตภัณฑ์อาหารจากเนื้อสัตว์และสัตว์น้ำอื่นๆ | 生产肉类和其他水生动物食品的机器操作员"
    },
    {
        "id":1760,
        "name":"827220  :  Machine Operators In The Ready-To-Drink Milk Production Process | ผู้ควบคุมเครื่องจักรในกระบวนการผลิตนมพร้อมดื่ม | 即饮奶生产过程中的机器操作员"
    },
    {
        "id":1761,
        "name":"827230  :  Operator Of Other Dairy Product Production Machines (Powdered Milk, Condensed Milk, Cheese, Etc.) | ผู้ควบคุมเครื่องผลิตผลิตภัณฑ์นมอื่นๆ (นมผง นมข้น เนยแข็งฯลฯ ) | 其他乳制品生产机器（奶粉、炼乳、奶酪等）的操作员"
    },
    {
        "id":1762,
        "name":"827240  :  Ice Cream Machine Operator | ผู้ควบคุมเครื่องผลิตไอศกรีม | 冰淇淋机操作员"
    },
    {
        "id":1763,
        "name":"827290  :  Other Dairy Product Machine Operators | ผู้ควบคุมเครื่องผลิตผลิตภัณฑ์นมอื่น ๆ | 其他乳制品机器操作员"
    },
    {
        "id":1764,
        "name":"827320  :  Operator Of A Cassava Flour Production Machine | ผู้คุมเครื่องผลิตแป้งมันสำปะหลัง | 木薯粉生产机的操作员"
    },
    {
        "id":1765,
        "name":"827330  :  Rice Mill Operator | ผู้ควบคุมเครื่องสีข้าว | 碾米机操作员"
    },
    {
        "id":1766,
        "name":"827340  :  Operator Of A Spice Grinder, Operator Of A Grain Mill | ผู้ควบคุมเครื่องป่นเครื่องเทศ , ผู้ควบคุมเครื่องโม่ บด สี เมล็ดธัญพืช | 香料研磨机操作员、谷物磨坊操作员"
    },
    {
        "id":1767,
        "name":"827350  :  Animal Feed Mixer Operator | ผู้ควบคุมเครื่องผสมอาหารสัตว์ | 动物饲料搅拌机操作员"
    },
    {
        "id":1768,
        "name":"827355  :  Animal Feed Pellet Machine Operator | ผู้ควบคุมเครื่องอัดเม็ดอาหารสัตว์ | 动物饲料颗粒机操作员"
    },
    {
        "id":1769,
        "name":"827390  :  Operator Of Grain And Other Spice Mills | ผู้ควบคุมเครื่องโม่เมล็ดธัญพืชและเครื่องเทศอื่น ๆ | 谷物和其他香料工厂的经营者"
    },
    {
        "id":1770,
        "name":"827410  :  General Bakery Machine Operator | ผู้ควบคุมเครื่องผลิตขนมอบทั่วไป | 一般面包机操作员"
    },
    {
        "id":1771,
        "name":"827420  :  Operator Of Sugar Sweets Production Machine (Chocolate, Candy, Confectionery) | ผู้ควบคุมเครื่องผลิตขนมหวานจากน้ำตาล (ช็อกโกแลต ลูกอม ลูกกวาด ) | 糖果生产机操作员（巧克力、糖果、糕点）"
    },
    {
        "id":1772,
        "name":"827430  :  Operator Of Instant Noodle Production Machine | ผู้ควบคุมเครื่องผลิตบะหมี่สำเร็จรูป | 方便面生产机操作工"
    },
    {
        "id":1773,
        "name":"827490  :  Operator Of A Machine Producing Flour And Other Sugar Products | ผู้ควบคุมเครื่องผลิตผลิตภัณฑ์จากแป้งและน้ำตาลอื่นๆ | 生产面粉和其他糖产品的机器的操作员"
    },
    {
        "id":1774,
        "name":"827510  :  Operator Of Food And Beverage Processing Machines From Plants, Vegetables, And Fruits In Sealed Containers (Cans, Glass Bottles, Etc.) | ผู้ควบคุมเครื่องแปรรูปอาหารและเครื่องดื่มจากพืช ผัก ผลไม้ในภาชนะบรรจุปิดสนิท (กระป๋อง ขวดแก้ว ฯลฯ ) | 使用密封容器（罐头、玻璃瓶等）中的植物、蔬菜和水果进行食品和饮料加工的操作员"
    },
    {
        "id":1775,
        "name":"827520  :  Operator Of Frozen Vegetable, Fruit And Vegetable Processing Machine | ผู้ควบคุมเครื่องแปรรูปพืช ผัก ผลไม้ แช่เยือกแข็ง | 冷冻蔬菜、果蔬加工机械操作员"
    },
    {
        "id":1776,
        "name":"827530  :  Operator Of Plant Products, Vegetables, And Dried Fruits | ผู้ควบคุมเครื่องผลิตผลิตภัณฑ์จากพืช ผัก ผลไม้อบแห้ง | 植物产品、蔬菜、干果经营者"
    },
    {
        "id":1777,
        "name":"827540  :  Operator Of A Plant-Based Sauce And Seasoning Production Machine | ผู้ควบคุมเครื่องผลิตซอสและเครื่องปรุงรสจากพืช | 植物性酱料和调味料生产机的操作员"
    },
    {
        "id":1778,
        "name":"827550  :  Operator Of Machine To Extract Edible Oil From Plants | ผู้ควบคุมเครื่องสกัดน้ำมันสำหรับบริโภคจากพืช | 从植物中提取食用油的机器操作员"
    },
    {
        "id":1779,
        "name":"827560  :  Margarine Production Machine Operator | ผู้ควบคุมเครื่องผลิตเนยเทียม | 人造黄油生产机操作员"
    },
    {
        "id":1780,
        "name":"827590  :  Plant Processing Machine Operator Other Vegetables And Fruits | ผู้ควบคุมเครื่องแปรรูปพืช ผักและผลไม้อื่น ๆ | 植物加工机械操作员其他蔬菜和水果"
    },
    {
        "id":1781,
        "name":"827620  :  Sugar Cane Crusher Operator | ผู้ควบคุมเครื่องหีบอ้อย | 甘蔗破碎机操作员"
    },
    {
        "id":1782,
        "name":"827630  :  Sugar Purification Machine Operator | ผู้ควบคุมเครื่องทำน้ำตาลให้บริสุทธิ์ | 糖精制机操作员"
    },
    {
        "id":1783,
        "name":"827640  :  Sugar Crystal Making Machine Operator | ผู้ควบคุมเครื่องทำผลึกน้ำตาล | 糖晶制造机操作员"
    },
    {
        "id":1784,
        "name":"827690  :  Sugar Processing Workers And Other Sugar Purifiers | ผู้ปฏิบัติงานในกรรมวิธีการทำน้ำตาลและผู้ทำน้ำตาลให้บริสุทธิ์อื่น ๆ | 糖加工工人和其他糖净化者"
    },
    {
        "id":1785,
        "name":"827720  :  Tea Leaf Mixing Machine Operator | ผู้ควบคุมเครื่องผสมใบชา | 茶叶搅拌机操作员"
    },
    {
        "id":1786,
        "name":"827730  :  Coffee Bean Processing Machine Operator, Coffee Bean Roasting Machine Operator | ผู้ควบคุมเครื่องแปรรูปเมล็ดกาแฟ , ผู้ควบคุมเครื่องคั่วเมล็ดกาแฟ | 咖啡豆加工机操作员、咖啡豆烘焙机操作员"
    },
    {
        "id":1787,
        "name":"827790  :  Operator Of Tea, Coffee And Cocoa Leaf Processing Machines, Etc. | ผู้ควบคุมเครื่องแปรรูปใบชา กาแฟและโกโก้ อื่นๆ | 茶叶、咖啡和可可叶加工机等操作员"
    },
    {
        "id":1788,
        "name":"827810  :  Brewing Supervisor, Brewmaster, Brewer | ผู้ควบคุมการผลิตเบียร์ , บริวมาสเตอร์ , ผู้ปรุงเบียร์ | 酿酒主管、酿酒师、酿酒师"
    },
    {
        "id":1789,
        "name":"827820  :  Beer Machine Operator | ผู้ควบคุมเครื่องผลิตเบียร์ | 啤酒机操作员"
    },
    {
        "id":1790,
        "name":"827830  :  Fermentation Controller, Fermenter | ผู้ควบคุมการหมักส่า , ผู้หมักส่า | 发酵控制器、发酵罐"
    },
    {
        "id":1791,
        "name":"827840  :  Liquor Flavoring Supervisor | ผู้ควบคุมการปรุงแต่งสุรา | 白酒调味主管"
    },
    {
        "id":1792,
        "name":"827850  :  Soft Drink Production Machine Operator | ผู้ควบคุมเครื่องผลิตน้ำอัดลม | 软饮料生产机操作员"
    },
    {
        "id":1793,
        "name":"827860  :  Wine And Fruit Wine Production Supervisor | ผู้ควบคุมการผลิตไวน์และไวน์ผลไม้ | 葡萄酒、果酒生产主管"
    },
    {
        "id":1794,
        "name":"827870  :  Operator Of Drinking Water And Ice Production Machines For Consumption | ผู้ควบคุมเครื่องผลิตน้ำดื่มและน้ำแข็งบริโภค | 消费饮用水和制冰机的操作员"
    },
    {
        "id":1795,
        "name":"827890  :  Machine Operators For The Production Of Beer, Spirits, Wine And Other Beverages | ผู้ควบคุมเครื่องจักรในการผลิตเบียร์ เหล้า ไวน์และเครื่องดื่มอื่นๆ | 生产啤酒、烈酒、葡萄酒和其他饮料的机器操作员"
    },
    {
        "id":1796,
        "name":"827910  :  Expert Cook | ผู้ชำนาญการปรุง | 专家厨师"
    },
    {
        "id":1797,
        "name":"827920  :  Operator Of Machine To Separate Medicinal Leaves And Stems | พนักงานควบคุมเครื่องแยกใบยาและก้าน | 分离药用叶和茎的机器操作员"
    },
    {
        "id":1798,
        "name":"827930  :  Operator Of Tobacco Production Machine | พนักงานควบคุมเครื่องผลิตยาเส้น | 烟草生产机器操作员"
    },
    {
        "id":1799,
        "name":"827940  :  Operator Of Machine For Mixing Perfume And Medicinal Leaf Concoction | พนักงานควบคุมเครื่องผสมน้ำหอมและน้ำปรุงใบยา | 香水和药用叶混合物混合机的操作员"
    },
    {
        "id":1800,
        "name":"827950  :  Cigarette Rolling Machine Operator | พนักงานควบคุมเครื่องมวนบุหรี่ | 卷烟机操作工"
    },
    {
        "id":1801,
        "name":"827990  :  Operator Of Other Tobacco Products Production Machines | พนักงานควบคุมเครื่องผลิตผลิตภัณฑ์ยาสูบอื่น ๆ | 其他烟草制品生产机器的操作员"
    },
    {
        "id":1802,
        "name":"828110  :  Machinery Assembler, Machinery Installer | ช่างประกอบเครื่องจักรกล , ช่างติดตั้งเครื่องจักร | 机械装配工、机械安装工"
    },
    {
        "id":1803,
        "name":"828120  :  Aircraft Assembler (Airplane) | ช่างประกอบอากาศยาน (เครื่องบิน) | 飞机组装工（飞机）"
    },
    {
        "id":1804,
        "name":"828130  :  Automotive Assembly Technician | ช่างประกอบยานยนต์ | 汽车装配技术员"
    },
    {
        "id":1805,
        "name":"828140  :  Bicycle Assembler | ช่างประกอบรถจักรยาน | 自行车组装工"
    },
    {
        "id":1806,
        "name":"828150  :  Motorcycle Assembler | ช่างประกอบรถจักรยานยนต์ | 摩托车组装工"
    },
    {
        "id":1807,
        "name":"828220  :  Electrical Equipment Assembly Technician (Motor, Dynamo, Transformer, Office Equipment, Household Appliances, Elevator, Electrical Control Unit) | ช่างประกอบอุปกรณ์ชิ้นส่วนทางไฟฟ้า (มอเตอร์, ไดนาโม , หม้อแปลงไฟฟ้า, เครื่องใช้สำนักงาน , เครื่องใช้ในบ้านเรือน ,ลิฟท์, แยกควบคุมไฟฟ้า) | 电气设备装配技术员（电机、发电机、变压器、办公设备、家用电器、电梯、电气控制单元）"
    },
    {
        "id":1808,
        "name":"828230  :  Precision Tool Assembler | ช่างประกอบเครื่องมือที่มีความเที่ยงตรงแม่นยำ | 精密工具装配工"
    },
    {
        "id":1809,
        "name":"828290  :  Other Electrical Equipment Assemblers | ผู้ประกอบอุปกรณ์ไฟฟ้าอื่น ๆ | 其他电气设备组装商"
    },
    {
        "id":1810,
        "name":"828320  :  Electronic Equipment Assembler (Radio And Television Transmitter) | ช่างประกอบอุปกรณ์อิเล็กทรอนิกส์ (เครื่องส่งวิทยุโทรทัศน์) | 电子设备组装工（广播电视发射机）"
    },
    {
        "id":1811,
        "name":"828330  :  Electronic Equipment Assembler (Medical) | ช่างประกอบอุปกรณ์อิเล็กทรอนิกส์ (การแพทย์) | 电子设备组装工（医疗）"
    },
    {
        "id":1812,
        "name":"828340  :  Electronic Equipment Assembly Technician (Industrial) | ช่างประกอบอุปกรณ์อิเล็กทรอนิกส์ (อุตสาหกรรม) | 电子设备组装技术员（工业）"
    },
    {
        "id":1813,
        "name":"828350  :  Electronic Equipment Assembler (Computer) | ช่างประกอบอุปกรณ์อิเล็กทรอนิกส์ (คอมพิวเตอร์) | 电子设备组装工（电脑）"
    },
    {
        "id":1814,
        "name":"828390  :  Other Electronic Equipment Assemblers | ผู้ประกอบอุปกรณ์อิเล็กทรอนิกส์อื่นๆ | 其他电子设备组装商"
    },
    {
        "id":1815,
        "name":"828420  :  Metal Product Assembly Technician | ช่างประกอบผลิตภัณฑ์โลหะ | 金属制品装配技术员"
    },
    {
        "id":1816,
        "name":"828430  :  Rubber Product Assembly Technician | ช่างประกอบผลิตภัณฑ์ยาง | 橡胶制品装配技术员"
    },
    {
        "id":1817,
        "name":"828440  :  Plastic Product Assembly Technician | ช่างประกอบผลิตภัณฑ์พลาสติก | 塑料制品组装技术员"
    },
    {
        "id":1818,
        "name":"828490  :  Metal Product Assembler Rubber And Other Plastics | ผู้ประกอบผลิตภัณฑ์โลหะ ยางและพลาสติก อื่นๆ | 金属产品组装工橡胶及其他塑料"
    },
    {
        "id":1819,
        "name":"828520  :  Wooden Vehicle Body Builder | ช่างต่อตัวถังยานพาหนะด้วยไม้ | 木制车身制造商"
    },
    {
        "id":1820,
        "name":"828590  :  Other Wood Product Assemblers | ช่างประกอบผลิตภัณฑ์ไม้อื่น ๆ | 其他木制品组装商"
    },
    {
        "id":1821,
        "name":"828620  :  Leather Product Assembly Technician | ช่างประกอบชิ้นส่วนผลิตภัณฑ์เครื่องหนัง | 皮革制品组装技术员"
    },
    {
        "id":1822,
        "name":"828630  :  Technician Who Assembles Parts For Pressed Paper Products | ช่างประกอบชิ้นส่วนผลิตภัณฑ์กระดาษอัด | 组装压制纸制品零件的技术人员"
    },
    {
        "id":1823,
        "name":"828640  :  Textile Product Assembly Technician | ช่างประกอบชิ้นส่วนผลิตภัณฑ์สิ่งทอ | 纺织产品组装技术员"
    },
    {
        "id":1824,
        "name":"828690  :  Manufacturer Of Pressed Paper Products, Textiles, Leather Products And Other Related Products. | ผู้ประกอบผลิตภัณฑ์กระดาษอัด สิ่งทอ เครื่องหนังและผลิตภัณฑ์ต่าง ๆ ที่เกี่ยวข้องอื่น ๆ | 压制纸制品、纺织品、皮革制品和其他相关产品的制造商。"
    },
    {
        "id":1825,
        "name":"829020  :  Product Labeling Machine Operator | ผู้ควบคุมเครื่องปิดฉลากผลิตภัณฑ์ | 产品贴标机操作员"
    },
    {
        "id":1826,
        "name":"829030  :  The Operator Closes And Seals The Lid. | ผู้ควบคุมเครื่องปิดและผนึกฝา | 操作员关闭并密封盖子。"
    },
    {
        "id":1827,
        "name":"829040  :  Packing Machine Operator | ผู้ควบคุมเครื่องบรรจุของ | 包装机操作工"
    },
    {
        "id":1828,
        "name":"829050  :  Bottle Filling Machine Operator | ผู้ควบคุมเครื่องบรรจุขวด | 灌装机操作员"
    },
    {
        "id":1829,
        "name":"829060  :  Wrapping Machine Worker | พนักงานเครื่องห่อของ | 包装机工人"
    },
    {
        "id":1830,
        "name":"829090  :  Other Packers And Labelers | ผู้บรรจุหีบห่อและปิดฉลากอื่น ๆ | 其他包装机和贴标机"
    },
    {
        "id":1831,
        "name":"831120  :  Train Driver, Locomotive Driver | พนักงานขับรถไฟ , พนักงานขับรถจักร | 火车司机、机车司机"
    },
    {
        "id":1832,
        "name":"831130  :  Employee, Assistant Locomotive Driver, Locomotive Mechanic (Train) | พนักงาน , ผู้ช่วยขับรถจักร , ช่างเครื่องรถจักร (รถไฟ) | 雇员、助理机车司机、机车机械师（火车）"
    },
    {
        "id":1833,
        "name":"831190  :  Other Locomotive Drivers | พนักงานขับรถจักรอื่น ๆ | 其他机车司机"
    },
    {
        "id":1834,
        "name":"831220  :  Train Brake Operator | พนักงานห้ามล้อรถไฟ | 火车制动操作员"
    },
    {
        "id":1835,
        "name":"831230  :  Train Signal Operator | พนักงานให้สัญญาณรถไฟ | 列车信号操作员"
    },
    {
        "id":1836,
        "name":"831240  :  Railway Switching Worker | พนักงานสับเปลี่ยนรางรถไฟ | 铁路转辙工"
    },
    {
        "id":1837,
        "name":"832120  :  Motorcycle Rider | ผู้ขับรถจักรยานยนต์ | 摩托车骑手"
    },
    {
        "id":1838,
        "name":"832130  :  Tricycle Driver | ผู้ขับรถสามล้อ | 三轮车司机"
    },
    {
        "id":1839,
        "name":"832210  :  Driver | พนักงานขับรถยนต์ | 司机"
    },
    {
        "id":1840,
        "name":"832220  :  Driver Of A Small Passenger Car, Driver Of A Car For Hire | พนักงานขับรถยนต์โดยสารขนาดเล็ก , พนักงานขับรถยนต์รับจ้าง | 小型客车司机、出租汽车司机"
    },
    {
        "id":1841,
        "name":"832230  :  Light Truck Driver, Van Driver | พนักงานขับรถบรรทุกขนาดเล็ก , พนักงานขับรถตู้ | 轻型卡车司机、货车司机"
    },
    {
        "id":1842,
        "name":"832290  :  Drivers Of Cars, Hired Cars, And Vans, Etc. | ผู้ขับรถยนต์ รถรับจ้าง และรถตู้ อื่น ๆ | 汽车、出租汽车、货车等的司机"
    },
    {
        "id":1843,
        "name":"832320  :  Bus Driver | พนักงานขับรถยนต์โดยสารประจำทาง | 公交车司机"
    },
    {
        "id":1844,
        "name":"832330  :  Tram Driver | พนักงานขับรถราง | 电车司机"
    },
    {
        "id":1845,
        "name":"832420  :  Driver Of Large Trucks And Vans | พนักงานขับรถบรรทุกและรถตู้ขนาดใหญ่ | 大型卡车和货车司机"
    },
    {
        "id":1846,
        "name":"832430  :  Dump Truck Driver, Dump Truck Driver | พนักงานขับรถดัมพ์ , พนักงานขับรถกระบะเทหลัง | 自卸车司机、自卸车司机"
    },
    {
        "id":1847,
        "name":"833120  :  Tractor Driver | พนักงานขับรถแทรกเตอร์ | 拖拉机司机"
    },
    {
        "id":1848,
        "name":"833130  :  Log Truck Driver | พนักงานขับรถบรรทุกไม้ซุง | 运木卡车司机"
    },
    {
        "id":1849,
        "name":"833140  :  Harvesting Machine Operator, Agricultural Machinery Operator | ผู้ควบคุมเครื่องเก็บเกี่ยว , พนักงานเครื่องจักรการเกษตร | 收割机操作员、农业机械操作员"
    },
    {
        "id":1850,
        "name":"833190  :  Equipment Operators In Fields, Farms, And Other Agricultural Work | ผู้ควบคุมอุปกรณ์ในไร่นา , ฟาร์ม , งานเกษตรอื่น ๆ | 田间、农场和其他农业工作中的设备操作员"
    },
    {
        "id":1851,
        "name":"833210  :  General Earthmoving Machine Workers | พนักงานเครื่องขนย้ายดินทั่วไป | 一般土方机械工人"
    },
    {
        "id":1852,
        "name":"833220  :  Excavator Operator, Loader Operator | พนักงานรถขุดดิน , พนักงานรถตัก | 挖掘机操作员、装载机操作员"
    },
    {
        "id":1853,
        "name":"833225  :  Trench Operator | พนักงานเครื่องขุดคู | 沟渠操作员"
    },
    {
        "id":1854,
        "name":"833230  :  Plowing\/Grading Worker | พนักงานไถ\/ปราบดิน | 犁地\/平整工人"
    },
    {
        "id":1855,
        "name":"833240  :  Machine Workers Scrape And Level Roads. | พนักงานเครื่องครูดและปรับระดับถนน | 机器工人刮平道路。"
    },
    {
        "id":1856,
        "name":"833245  :  Road Compactor Driver | พนักงานขับรถบดอัดถนน | 道路压路机司机"
    },
    {
        "id":1857,
        "name":"833250  :  Moving Equipment Operator | พนักงานเครื่องลากขนย้าย | 移动设备操作员"
    },
    {
        "id":1858,
        "name":"833260  :  Pile Driving Machine Operator | พนักงานรถเครื่องตอกเสาเข็ม | 打桩机操作员"
    },
    {
        "id":1859,
        "name":"833270  :  Concrete Pourer Operator | พนักงานเครื่องเทคอนกรีต | 混凝土浇筑操作员"
    },
    {
        "id":1860,
        "name":"833275  :  Concrete Conveyor Operator | พนักงานเครื่องลำเลียงคอนกรีต | 混凝土输送机操作员"
    },
    {
        "id":1861,
        "name":"833280  :  Dredger Worker | พนักงานเรือขุด | 挖泥工人"
    },
    {
        "id":1862,
        "name":"833290  :  Machine Operator Engines Used To Move Other Materials | ผู้ควบคุมเครื่องจักร เครื่องยนต์ที่ใช้ในการขนย้ายวัสดุอื่น ๆ | 机器操作员用于移动其他材料的发动机"
    },
    {
        "id":1863,
        "name":"833320  :  Bridge Crane Operator | พนักงานปั้นจั่นแบบสะพาน | 桥式起重机操作员"
    },
    {
        "id":1864,
        "name":"833330  :  Arm Crane Operator Except For Mobile Cranes | พนักงานปั้นจั่นแบบแขน ยกเว้นปั้นจั่นเคลื่อนที่ | 臂式起重机操作员除移动式起重机外"
    },
    {
        "id":1865,
        "name":"833340  :  Mobile Crane Operator | พนักงานปั้นจั่นแบบเคลื่อนที่ | 移动式起重机操作员"
    },
    {
        "id":1866,
        "name":"833350  :  Winch Operator | พนักงานเครื่องกว้าน | 绞车操作员"
    },
    {
        "id":1867,
        "name":"833360  :  Construction Crane Operator, Lifting Machine Operator (Construction) | พนักงานปั้นจั่นงานก่อสร้าง , พนักงานเครื่องยก (การก่อสร้าง) | 建筑起重机操作员、起重机械操作员（建造）"
    },
    {
        "id":1868,
        "name":"833370  :  Pratunam Staff | พนักงานประจำประตูน้ำ | 水门工作人员"
    },
    {
        "id":1869,
        "name":"833390  :  Operators Of Cranes, Hoists, Hoists, And Other Related Machinery. | ผู้ควบคุมปั้นจั่น รอก ยก และเครื่องจักรต่าง ๆ ที่เกี่ยวข้องอื่น ๆ | 起重机、提升机、提升机和其他相关机械的操作员。"
    },
    {
        "id":1870,
        "name":"833420  :  Fork Lift Driver | พนักงานขับรถยก (fork lift) | 叉车司机"
    },
    {
        "id":1871,
        "name":"833430  :  Operator Of Lifting Equipment | พนักงานควบคุมอุปกรณ์ยกขน | 起重设备操作员"
    },
    {
        "id":1872,
        "name":"834020  :  Sailor | กลาสี | 水手"
    },
    {
        "id":1873,
        "name":"834030  :  Build A Boat | สรั่งเรือ | 建造一艘船"
    },
    {
        "id":1874,
        "name":"834035  :  Build A Ship Mechanic | สรั่งช่างกลเรือ | 培养一名船舶机械师"
    },
    {
        "id":1875,
        "name":"834040  :  Motorboat Mechanic | ช่างเครื่องเรือยนต์ | 摩托艇机械师"
    },
    {
        "id":1876,
        "name":"834050  :  Helmsman | พนักงานถือท้ายเรือ | 舵手"
    },
    {
        "id":1877,
        "name":"834055  :  Motorboat Helmsman | นายท้ายเรือยนต์ | 摩托艇舵手"
    },
    {
        "id":1878,
        "name":"834057  :  Car Ferry Conductor | พนักงานคุมแพขนานยนต์ | 汽车渡轮售票员"
    },
    {
        "id":1879,
        "name":"834060  :  Machine Grease Technician | ช่างอัดจาระบีประจำเครื่อง | 机器润滑脂技术员"
    },
    {
        "id":1880,
        "name":"834065  :  Ship'S Mechanic And Oil Technician | ช่างเครื่องและช่างน้ำมันประจำเรือ | 船舶机械师和石油技术员"
    },
    {
        "id":1881,
        "name":"834070  :  Skilled Crew | ลูกเรือชำนาญงาน | 熟练的船员"
    },
    {
        "id":1882,
        "name":"834090  :  Crew And Other Related Workers | ลูกเรือและผู้ปฏิบัติงานที่เกี่ยวข้องอื่นๆ | 船员及其他相关人员"
    },
    {
        "id":1883,
        "name":"911120  :  Food Vendors In Public Places | ผู้จำหน่ายอาหารในสถานที่สาธารณะ | 公共场所的食品摊贩"
    },
    {
        "id":1884,
        "name":"911130  :  Street Food Vendors | ผู้จำหน่ายอาหารตามถนน | 街头食品摊贩"
    },
    {
        "id":1885,
        "name":"911140  :  Food Vendors Along The Waterways | ผู้จำหน่ายอาหารตามทางน้ำ | 水道沿岸的食品摊贩"
    },
    {
        "id":1886,
        "name":"911220  :  Newspaper Distributor | ผู้จำหน่ายหนังสือพิมพ์ | 报纸经销商"
    },
    {
        "id":1887,
        "name":"911230  :  Street Vendors Selling Various Products (Except Food) | ผู้จำหน่ายสินค้าต่าง ๆ ตามถนน (ยกเว้นอาหาร) | 街头小贩出售各种产品（食品除外）"
    },
    {
        "id":1888,
        "name":"911240  :  Product Distributors At Various Shows | ผู้จำหน่ายสินค้าตามงานแสดงต่างๆ | 各种展会上的产品经销商"
    },
    {
        "id":1889,
        "name":"911320  :  Direct Sales Distributor | ผู้จำหน่ายสินค้าแบบขายตรง | 直销经销商"
    },
    {
        "id":1890,
        "name":"911330  :  Telephone Distributor | ผู้จำหน่ายสินค้าทางโทรศัพท์ | 电话分配器"
    },
    {
        "id":1891,
        "name":"912010  :  General Contractor (Poster Closed) | ผู้รับจ้างทั่วไป (ปิดโปสเตอร์) | 总承包商（海报已关闭）"
    },
    {
        "id":1892,
        "name":"912020  :  Shoe Polisher | พนักงานขัดรองเท้า | 擦鞋机"
    },
    {
        "id":1893,
        "name":"912030  :  Car Window Cleaner | พนักงานเช็ดกระจกหน้าต่างรถยนต์ | 车窗清洁剂"
    },
    {
        "id":1894,
        "name":"912090  :  Work To Provide Services Along Other Roads. | ทำงานให้บริการตามข้างถนนอื่น ๆ | 致力于在其他道路沿线提供服务。"
    },
    {
        "id":1895,
        "name":"913120  :  Housekeeper Helper | ผู้ช่วยแม่บ้าน | 管家帮手"
    },
    {
        "id":1896,
        "name":"913130  :  Cleaning Worker | คนงานทำความสะอาด | 清洁工"
    },
    {
        "id":1897,
        "name":"913220  :  Cleaning Staff In Public Places | พนักงานทำความสะอาดในที่สาธารณะ | 公共场所保洁人员"
    },
    {
        "id":1898,
        "name":"913230  :  Employee Washing Dishes By Hand | พนักงานล้างจานด้วยมือ | 员工用手洗碗"
    },
    {
        "id":1899,
        "name":"913320  :  Hand Washing Clothes\/Laundry Attendant | ผู้ซักล้างเสื้อผ้าด้วยมือ\/ พนักงานซักรีด | 洗手衣服\/洗衣服务员"
    },
    {
        "id":1900,
        "name":"914120  :  Building Cleaner, Building Cleaning Staff | ผู้ทำความสะอาดอาคาร , พนักงานทำความสะอาดอาคาร | 建筑物清洁工、建筑物清洁人员"
    },
    {
        "id":1901,
        "name":"914130  :  Rented House\/Apartment Caretaker | ผู้ดูแลบ้านเช่า \/ อาพาร์ทเม้นต์ | 出租房屋\/公寓看管人"
    },
    {
        "id":1902,
        "name":"914140  :  Temple Or Church Caretaker | ผู้ดูแลวัดหรือโบสถ์ | 寺庙或教堂管理员"
    },
    {
        "id":1903,
        "name":"914220  :  Window Cleaner | พนักงานทำความสะอาดหน้าต่าง | 窗户清洁剂"
    },
    {
        "id":1904,
        "name":"914230  :  Manual Vehicle Cleaner | ผู้ทำความสะอาดยานพาหนะด้วยมือ | 手动车辆清洁剂"
    },
    {
        "id":1905,
        "name":"915120  :  Book Delivery Worker | พนักงานส่งหนังสือ | 送书员"
    },
    {
        "id":1906,
        "name":"915130  :  Newspaper Delivery Person | คนส่งหนังสือพิมพ์ | 送报纸的人"
    },
    {
        "id":1907,
        "name":"915140  :  Baggage Porter, Baggage Porter | พนักงานยกกระเป๋า , พนักงานขนสัมภาระ | 行李搬运工, 行李搬运工"
    },
    {
        "id":1908,
        "name":"915150  :  Employee Carrying Golf Bag | พนักงานแบกถุงกอล์ฟ | 携带高尔夫球包的员工"
    },
    {
        "id":1909,
        "name":"915190  :  Other Delivery Personnel | พนักงานจัดส่งสินค้าอื่น ๆ | 其他配送人员"
    },
    {
        "id":1910,
        "name":"915220  :  Employee Opens And Closes The Door | พนักงานเปิด - ปิดประตู | 员工打开和关闭门"
    },
    {
        "id":1911,
        "name":"915230  :  Sentinel | ยามรักษาการณ์ | 哨兵"
    },
    {
        "id":1912,
        "name":"915240  :  Ticket Collector\/Permission Card | พนักงานเก็บตั๋ว\/บัตรอนุญาติ | 检票员\/许可卡"
    },
    {
        "id":1913,
        "name":"915320  :  Automated Cashier | พนักงานเก็บเงินเครื่องอัตโนมัติ | 自动收银"
    },
    {
        "id":1914,
        "name":"915330  :  Employee Collects Parking Fee | พนักงานเก็บค่าบริการจอดรถ | 员工收取停车费"
    },
    {
        "id":1915,
        "name":"915340  :  Water\/Electricity Meter Recorder | พนักงานจดมาตรวัดน้ำ\/ไฟฟ้า | 水\/电表记录仪"
    },
    {
        "id":1916,
        "name":"916120  :  Garbage Collector | ผู้เก็บขยะ | 垃圾收集器"
    },
    {
        "id":1917,
        "name":"916220  :  Public Park Cleaning Staff | พนักงานเก็บกวาดสวนสาธารณะ | 公园保洁人员"
    },
    {
        "id":1918,
        "name":"916230  :  Street Sweeper | พนักงานกวาดถนน | 街道清洁工"
    },
    {
        "id":1919,
        "name":"916240  :  Workers Guarding The Floodgates; Guards Watch Over The Flood Gates. | คนงานเฝ้าประตูระบายน้ำ ; ยามเฝ้าประตูระบายน้ำ | 守卫水闸的工人；警卫看守防洪闸门。"
    },
    {
        "id":1920,
        "name":"916245  :  Sewer Worker | คนงานท่อระบายน้ำ | 下水道工人"
    },
    {
        "id":1921,
        "name":"921120  :  General Farm Worker | คนงานในฟาร์มทั่วไป | 普通农场工人"
    },
    {
        "id":1922,
        "name":"921130  :  Fruit\/Crop Harvesters | ผู้เก็บเกี่ยวผลไม้\/พืชไร่ | 水果\/农作物收割机"
    },
    {
        "id":1923,
        "name":"921220  :  Forest Planting Workers | แรงงานปลูกป่า | 造林工人"
    },
    {
        "id":1924,
        "name":"921310  :  Fishing Workers | แรงงานประมง | 渔业工人"
    },
    {
        "id":1925,
        "name":"921320  :  Hunting Workers | แรงงานจับสัตว์ล่า | 狩猎工人"
    },
    {
        "id":1926,
        "name":"921330  :  Workers On Aquatic Farms | คนงานในฟาร์มเพาะเลี้ยงสัตว์น้ำ | 水产养殖场的工人"
    },
    {
        "id":1927,
        "name":"931120  :  Mining Workers, Quarry | แรงงานเหมืองแร่ เหมืองหิน | 采矿工人、采石场"
    },
    {
        "id":1928,
        "name":"931220  :  Road, Dam And Other Related Construction Workers | แรงงานก่อสร้างถนน เขื่อน และอื่น ๆ ที่เกี่ยวข้อง | 道路、水坝及其他相关建筑工人"
    },
    {
        "id":1929,
        "name":"931320  :  Labor Demolishing Buildings | แรงงานรื้อถอน อาคาร สิ่งปลูกสร้าง | 劳工拆除建筑物"
    },
    {
        "id":1930,
        "name":"931330  :  Building Construction Workers Various Buildings | แรงงานก่อสร้างอาคาร สิ่งปลูกสร้างต่าง ๆ | 建筑工人各种建筑物"
    },
    {
        "id":1931,
        "name":"932120  :  Employee Sorting Bottles | พนักงานคัดแยกขวด | 员工对瓶子进行分类"
    },
    {
        "id":1932,
        "name":"932130  :  Production Labor | แรงงานด้านการผลิต | 生产劳动力"
    },
    {
        "id":1933,
        "name":"932132  :  Hand Made Cement Tiles | ผู้ทำกระเบื้องซีเมนต์ด้วยมือ | 手工水泥砖"
    },
    {
        "id":1934,
        "name":"932134  :  Hand Caster Of Cement Concrete | ผู้หล่อซีเมนต์คอนกรีตด้วยมือ | 水泥混凝土手摇脚轮"
    },
    {
        "id":1935,
        "name":"932140  :  Smoked Rubber Sheet Grader | ผู้คัดชั้นยางแผ่นรมควัน | 烟熏胶板平地机"
    },
    {
        "id":1936,
        "name":"932190  :  Other Assembly Workers | แรงงานด้านการประกอบอื่น ๆ | 其他装配工"
    },
    {
        "id":1937,
        "name":"932220  :  Labor Filling | แรงงานบรรจุ | 劳动力填补"
    },
    {
        "id":1938,
        "name":"932225  :  Employees Pack Food Onto Trays | พนักงานบรรจุอาหารลงถาด | 员工将食物装入托盘"
    },
    {
        "id":1939,
        "name":"932230  :  Those Who Wash And Dry Raw Rubber Sheets | ผู้ล้างและผึ่งยางแผ่นดิบ | 清洗和干燥生橡胶板的人"
    },
    {
        "id":1940,
        "name":"932235  :  Compressor And Packager Of Smoked Rubber Sheets | ผู้อัดและหีบห่อก้อนยางแผ่นรมควัน | 烟熏橡胶板压缩机和包装机"
    },
    {
        "id":1941,
        "name":"932290  :  Labor In Various Production Fields, General Labor | แรงงานในด้านการผลิตต่าง ๆ , แรงงานทั่วไป | 各生产领域的劳动、一般劳动"
    },
    {
        "id":1942,
        "name":"933120  :  Tricycle Rider | คนถีบสามล้อ | 三轮车骑手"
    },
    {
        "id":1943,
        "name":"933130  :  Shopping Cart | คนเข็นของ | 购物车"
    },
    {
        "id":1944,
        "name":"933220  :  Drivers Of Vehicles Using Harnessed Animals (Cargo) | ผู้ขับยานพาหนะที่ใช้สัตว์ลากเทียม(สินค้า) | 使用挽具动物（货物）的车辆司机"
    },
    {
        "id":1945,
        "name":"933225  :  Drivers Of Vehicles Using Harnessed Animals (Passengers) | ผู้ขับยานพหนะที่ใช้สัตว์ลากเทียม(ผู้โดยสาร) | 使用挽具动物的车辆司机（乘客）"
    },
    {
        "id":1946,
        "name":"933230  :  Mahout | ควาญช้าง | 象夫"
    },
    {
        "id":1947,
        "name":"933290  :  Persons Who Drive Vehicles And Machinery Using Other Animal-Drawn Animals. | ผู้ขับเคลื่อนพาหนะและเครื่องจักรโดยใช้สัตว์ลากจูงอื่น ๆ | 使用其他动物来驾驶车辆和机械的人。"
    },
    {
        "id":1948,
        "name":"933310  :  Product Loading And Unloading Staff | พนักงานขนถ่ายสินค้า | 产品装卸人员"
    },
    {
        "id":1949,
        "name":"933320  :  Goods Transporters (Cars, Trains) | ผู้ขนถ่ายสินค้า (รถ, รถไฟ) | 货物运输工具（汽车、火车）"
    },
    {
        "id":1950,
        "name":"933330  :  Cargo Transporter (By Boat) | ผู้ขนถ่ายสินค้า (ทางเรือ) | 货物运输车（乘船）"
    },
    {
        "id":1951,
        "name":"933340  :  Cargo Transporter (Air) | ผู้ขนถ่ายสินค้า (ทางอากาศ) | 货物运输机（空运）"
    },
    {
        "id":1952,
        "name":"933345  :  Employees Transporting Food Onto Airplanes | พนักงานลำเลียงอาหารขึ้นเครื่องบิน | 员工将食物运送上飞机"
    },
    {
        "id":1953,
        "name":"933390  :  Other Carriers | ผู้ขนส่งสินค้าอื่นๆ | 其他运营商"
    },
    {
        "id":1954,
        "name":"T11010  :  Trainee | ผู้ฝึกงาน | 学员"
    },
    {
        "id":1955,
        "name":"X11020  :  The Name Of The Person Who Reported The Occupation Is Not Clear. | ผู้แจ้งชื่ออาชีพไม่ชัดเจน | 举报这一占领行为的人的姓名尚不清楚。"
    }
];

module.exports = jobTitles;